import './propertyChat2.css';
import React, { useState, useEffect, useRef } from "react";
import PropertiesService from "../../Services/PropertiesService";
import upload from "./../../assets/Images/ChatBot/upload.png";
import uploadw from "./../../assets/Images/Request_Property/upload.png";
import UserImage from "../../assets/Images/ChatBot/user.png";
import uploadIcon from './../../assets/Images/Request_Property/upload.png';
import MarketValueCertificate from "../MarketValueCertificate/MarketValueCertificate.jsx";
import MarketValueCertificateModal from "../MarketValueCertificate/MarketValueCertificateModal.jsx";


import moment from 'moment';

import send from "./../../assets/Images/ChatBot/send.png";
import { toast, ToastContainer } from "react-toastify";
import { io } from "socket.io-client";
import chatService from "../../Services/chat";
import { Button, Form } from "react-bootstrap";
import civilengineerService from "../../Services/civilEngineer";
import loader from "./../../assets/Images/Request_Property/Loader.gif";
import { Modal } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import "react-circular-progressbar/dist/styles.css";
import EditPropertyModal from "../editPropertyModel/EditPropertyModel";
import ProgressWithCategories from "../ProgressWithCategories/ProgressWithCategories";
import requestsService from "../../Services/requests";
import MergeAllDocuments from "../MergeAllDocuments/MergeAllDocuments.jsx";
import { uploadFile } from "@files-ui/react";
import { ArrowLeft, Bot, Clock, Pencil, Info, MapPinHouseIcon, Menu, User, ChevronLeft, ChevronRight, Filter, Loader2, Send } from 'lucide-react';
import * as pdfjsLib from "pdfjs-dist";
import { XCircle } from "react-bootstrap-icons";
import Product from '../RazorPay.jsx';
import PaymentPreviewCard from '../PaymentPreviewCard/PaymentPreviewCard.jsx';
import BlurLoader from '../blurLoader/BlurLoader.jsx';
import { server } from '../../serverUrl.js';
import FetchingCard from '../FetchingCard/FetchingCard.jsx';
import FilePreview from '../Common/FilePreview';
import { getApiErrorMessage, isApiErrorResponse, MAX_UPLOAD_SIZE_BYTES, MAX_UPLOAD_SIZE_MB } from '../../utils/fileHelpers';
const PropertyChat2 = () => {
    const [text, setText] = useState("Upload a file to extract text.");
    const getMissingDocsCount = () => {
        let completedCount = 0;
        const docTypes = [
            { label: 'Land Use Certificate', question: '⁠link documents explaining the title deeds?' },
            { label: 'Market Value Declaration', question: 'Have you obtained the Market Value Declaration Certificate?' },
            { label: 'Digital Transfer process/Bank payment details', question: 'Have you completed the Digital Transfer process/Bank payment details?' },
            { label: 'Bank Loan', question: 'Are you interested in applying for a bank loan?' }
        ];
        docTypes.forEach(cat => {
            let completed = false;
            UserUploadedDocs?.forEach(doc => {
                const type = doc.Type?.trim();
                const value = doc.url || doc.value;
                if (type === cat.question && value !== 'No') {
                    completed = true;
                }
            });
            if (completed) completedCount++;
        });
        return docTypes.length - completedCount;
    };
    const [AllUsers, setAllUsers] = useState([]);
    const [PaymentScreen, showPaymentScreen] = useState(false);
    const [SelectedRadioForChatBrokerOrRelative, setSelectedRadioForChatBrokerOrRelative] = useState('');
    const [expanded, setExpanded] = useState({});

    const toggleExpand = (id) => {
        setExpanded((prev) => ({
            ...prev,
            [id]: !prev[id], // toggle only the clicked message
        }));
    };
    const [AllCivilEngineers, setAllCivilEngineers] = useState([]);
    const [showAllQuestions, setShowAllQuestions] = useState(false);
    const [showAllFiles, setShowAllFiles] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
    const [showRightPanel, setShowRightPanel] = useState(false);
    const [ErrorForMergeDocument, setErrorForMergeDocument] = useState('');
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedStatusFilter, setSelectedStatusFilter] = useState("All");
    const [selectedStateFilter, setSelectedStateFilter] = useState("All");
    const [showStatusFilterDropdown, setShowStatusFilterDropdown] = useState(false);

    const normalizeUrlToHttps = (url) => {
        if (!url) return url;
        return url.replace(/^http:\/\//i, 'https://');
    };
    const validateFileSizeLimit = (file) => {
        if (!file) return false;
        if (file.size > MAX_UPLOAD_SIZE_BYTES) {
            toast.error(`File size (${(file.size / (1024 * 1024)).toFixed(1)}MB) exceeds the maximum limit of ${MAX_UPLOAD_SIZE_MB}MB.`);
            return false;
        }
        return true;
    };
    const [openUploadSaledeedModel, setopenUploadSaledeedModel] = useState('');
    const [hasManuallyClosedSaledeedPopup, setHasManuallyClosedSaledeedPopup] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showInlineFileUploadModal, setShowInlineFileUploadModal] = useState(false);
    const [inlineFileUploadLoading, setInlineFileUploadLoading] = useState(false);
    const [inlineFileUploadError, setInlineFileUploadError] = useState("");
    const socket = useRef(null);
    const [ExtendForText, setExtendForText] = useState('')
    const formatExtendForDisplay = (text) => {
        if (!text) return "";
        if (text === "saledeed document") return "sale deed document";
        if (text === "Registration Document") return "registration document";
        return text;
    };
    const [ErrorMessagesForSaledeedModel, setErrorMessagesForSaledeedModel] = useState('')
    const [uploadRemainingDocsType, setUploadRemainingDocsType] = useState([])
    const [uploadRemainingDocsErrors, setUploadRemainingDocsErrors] = useState({});
    const messagesEndRefUser2 = useRef(null);
    const [saledeedSubmissionErrorMessage, setSaledeedSubmissionErrorMessage] = useState("");
    const [raiseRequestErrors, setRaiseRequestErrors] = useState([]);
    const [raiseRequestFormValues, setRaiseRequestFormValues] = useState([]);
    const [SaleDeedUploadedFile, setSaleDeedUploadedFile] = useState(null);
    const [userQuestion, setUserQuestion] = useState("");
    const [userResponseForDocUpload, setUserResponseForDocUpload] = useState("");
    const [selectedInlineRadioOption, setSelectedInlineRadioOption] = useState(null);
    // Engineer-driven document request (e.g. "Upload registration document")
    const [engineerDocRequest, setEngineerDocRequest] = useState(null); // { type: string, messageKey: string }
    const [showEngineerDocUploadModal, setShowEngineerDocUploadModal] = useState(false);
    const [engineerDocUploadText, setEngineerDocUploadText] = useState("");
    const [chatMessages, setChatMessages] = useState([]);
    const [registrationFileLoader, setRegistrationFileLoader] = useState(false);
    const [registrationUploadedFile, setRegistrationUploadedFile] = useState("");
    const [marketValueFileLoader, setMarketValueFileLoader] = useState(false);
    const [marketValueUploadedFile, setMarketValueUploadedFile] = useState(false);
    const [showInlineRegistrationUploadModal, setShowInlineRegistrationUploadModal] = useState(false);
    const [inlineRegistrationUploadLoading, setInlineRegistrationUploadLoading] = useState(false);
    const [inlineRegistrationUploadingPropertyId, setInlineRegistrationUploadingPropertyId] = useState("");
    const inlineRegistrationUploadRef = useRef(null);
    const registrationUploadCardRef = useRef(null);
    const restoredSelectionRef = useRef(false);
    const [showSaleDeedSuccessCard, setShowSaleDeedSuccessCard] = useState(false);
    const [AssignedCivilEngineerData, setAssignedCivilEngineerData] = useState([]);
    const [Message, setMessage] = useState("");
    const [chatVisible, setChatVisible] = useState(false);
    const [propertyList, setPropertyList] = useState([]);
    const [filteredProperties, setFilteredProperties] = useState([]);
    const [selectedProperty, setSelectedProperty] = useState(null);
    const [remainingQuestions, setRemainingQuestions] = useState([]);
    const [openRaiseIssueModel, setOpenRaiseIssueModel] = useState(false);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [currentQuestion, setCurrentQuestion] = useState(null);
    const [isInput, setIsInput] = useState(true);
    const [conversationEnded, setConversationEnded] = useState(false);
    const [uploadedFile, setUploadedFile] = useState(null);
    const chatEndRef = useRef(null);
    const marketValueInputRef = useRef(null);
    const UserUploadInputRef = useRef(null);
    const fileInputRef = useRef(null);
    const fileInputRef2 = useRef(null);
    const inlineFileUploadRef = useRef(null);
    const engineerDocUploadFileRef = useRef(null);
    const fileInputRefForSaleAggrement = useRef(null);
    const fileInputRefForSaleDeedUploaded = useRef(null);
    const [UploadFileLoader, setUploadFileLoader] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [showMarketValueCertificate, setShowMarketValueCertificate] = useState(false);
    const [certificateData, setCertificateData] = useState(null);
    const [showMarketValueCertificateModal, setShowMarketValueCertificateModal] = useState(false);
    const [isLoading1, setIsLoading1] = useState(false);
    const [hasError, setHasError] = useState(false);
    const [userDetails, setUserDetails] = useState([]);
    const [chartId, setChartId] = useState("");
    const [EnableInput, setEnableInput] = useState(false);
    const [botMessageForUser, setBotMessageForUser] = useState("");
    const [UserUploadedDocs, setUserUploadedDocs] = useState([]);
    const [SwitchToUploadDocsTab, SetSwitchToUploadDocsTab] = useState({ active: false, id: null, });
    const [AlertMessage, setAlertMessage] = useState([]);
    const [ViewDoc, setViewDoc] = useState(false);
    const [PropertyDetails, setPropertyDetails] = useState([]);
    const [page, setPage] = useState("page1");
    const [SaleAggementloading, setSaleAggementloading] = useState(false);
    const [SaleDeedUploadedloading, setSaleDeedUploadedloading] = useState(false);
    const [isSubmittingSaledeed, setIsSubmittingSaledeed] = useState(false);
    const [ShowPropertyList, setShowPropertyList] = useState(false);
    const [aggregateViewMode, setAggregateViewMode] = useState(false);
    const [expandedStates, setExpandedStates] = useState({});
    const [expandedCities, setExpandedCities] = useState({});
    const [expandedPincodes, setExpandedPincodes] = useState({});
    const [upiId, setUpiId] = useState("");
    const [UpdatedDocuments, setUpdatedDocuments] = useState([]);
    const messgaeData = [];
    const [PdfUrls, setPdfUrls] = useState([])
    const [PropertySwitch, setPropertySwitch] = useState(true)
    const [allQuestions, setAllQuestions] = useState([]);
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [LoaderForUploadFile, setLoaderForUploadFile] = useState([])
    const [DisplayFinalMessage, setDisplayFinalMessage] = useState(false);
    const [docsStatus, setDocsStatus] = useState({});
    const [openDocUploadErrorInChat, setopenDocUploadErrorInChat] = useState(false)
    const [DocUploadAlertError, setDocUploadAlertError] = useState('')
    const [saleDeedExtensionRequests, setSaleDeedExtensionRequests] = useState([]);
    const [paymentStatus, setPaymentStatus] = useState(false);
    const [hasMatchedQuestions, setHasMatchedQuestions] = useState(0);
    const [propertyListLoading, setpropertyListLoading] = useState(false)
    const [token, setToken] = useState("");
    const [ChatPageLoading, setChatPageLoading] = useState(false)
    const [SendMessageLoad, setSendMessageLoad] = useState(false)
    const [HandleSaledeedFields, setHandleSaledeedFields] = useState([])
    const SALE_DEED_ACCEPTED_KEYWORD = "sale deed draft accepted successfully";
    const [registrationDocNumber, setRegistrationDocNumber] = useState('');
    const [registrationDate, setRegistrationDate] = useState('');
    const [marketValueAmount, setMarketValueAmount] = useState('');
    const [marketValueCurrency, setMarketValueCurrency] = useState('INR');
    const [propertyValueAmount, setPropertyValueAmount] = useState('');
    const [propertyValueCurrency, setPropertyValueCurrency] = useState('INR');
    const [regDocError, setRegDocError] = useState('');
    const [registrationDateError, setRegistrationDateError] = useState('');
    const [isRegisteredDocSubmittedToDoCity, setIsRegisteredDocSubmittedToDoCity] = useState(false);
    const [isStrictlyConfidential, setIsStrictlyConfidential] = useState(false);
    const [marketValueAgreementError, setMarketValueAgreementError] = useState('');
    const radioQuestions = [
        "Have you obtained the Market Value Declaration Certificate?",
        "Have you completed the Digital Transfer process/Bank payment details?",
        "Are you interested in applying for a bank loan?",
    ];
    const BANK_LOAN_QUESTION = "Are you interested in applying for a bank loan?";
    const BANK_LOAN_ANSWER_LABELS = {
        Yes: "I am intrestedin bank loan",
        No: "I will apply for a bank loan in future",
    };

    const mapRadioAnswerForBackend = (questionText = "", value = "") => {
        const normalizedQuestion = questionText.toString().trim().toLowerCase();
        const isBankLoanQuestion = normalizedQuestion === BANK_LOAN_QUESTION.toLowerCase();
        if (!isBankLoanQuestion) return value;
        return BANK_LOAN_ANSWER_LABELS[value] || value;
    };
    const isMarketValueDeclarationQuestion = (questionText = "") =>
        questionText.toLowerCase().includes("market value declaration certificate");

    const isPresent = (value) => {
        if (value === null || value === undefined) return false;
        if (typeof value === "string") return value.trim() !== "";
        return true;
    };

    const getPropertyStageOrder = (item = {}) => {
        const hasAssignedEngineer = isPresent(item?.assignedCivilEngineer);
        const hasSaleDeedUploaded = isPresent(item?.saleDeedUploaded);
        const hasRegistrationUploaded = isPresent(item?.registrationDocument);
        const hasFinalDocumentUploaded = isPresent(item?.FinalMarketValue);

        // 6) Final document uploaded
        if (hasFinalDocumentUploaded) return 6;
        // 5) Registration uploaded
        if (hasRegistrationUploaded) return 5;
        // 4) Sale deed uploaded
        if (hasSaleDeedUploaded) return 4;
        // 3) Assigned engineer
        if (hasAssignedEngineer) return 3;

        // Remaining categories before assignment
        // 2) Waiting for civil engineer assignment
        if (item?.Status === "running" || isPresent(item?.property_Key)) return 2;
        // 1) New property with chatbot process
        if (item?.Payment_Status === true || String(item?.paymentStatus || "").toLowerCase() === "paid") return 1;
        // 0) New property requested
        return 0;
    };

    const sortPropertiesByPriority = (items = []) => {
        return [...items].sort((a, b) => {
            const timeA = new Date(a?.updatedAt || a?.createdAt || 0).getTime();
            const timeB = new Date(b?.updatedAt || b?.createdAt || 0).getTime();
            return timeB - timeA;
        });
    };
    const location = useLocation();
    const handleClose = () => {
        setOpenRaiseIssueModel(false);
    };
    const sethandleOpenBankLoanLink = (ee) => {
        window.open("https://docity-user.netlify.app/#/LoanImportance");
    };
    const toggleShowAllQuestions = () => {
        setShowAllQuestions(prev => !prev);
    };
    const toggleShowAllFiles = () => {
        setShowAllFiles((prev) => !prev);
    };
    useEffect(() => {
        const timer = setTimeout(() => {
            if (isLoading) {
                setHasError(true);
            }
        }, 10000);
        setTimeout(() => {
            setErrorMessagesForSaledeedModel('')
        }, 2000)
        return () => clearTimeout(timer);
    }, [isLoading, ErrorMessagesForSaledeedModel]);
    useEffect(() => {
        const userDetails2 = JSON.parse(localStorage.getItem("userDetails"));
        setUserDetails(userDetails2);
        console.log(hasMatchedQuestions, 'hasMatchedQuestions')
        console.log(server, 'server')
        socket.current = io(server, {
            transports: ["websocket"],
        });
        const propertyDetails = JSON.parse(localStorage.getItem('propertyDetails'))
        console.log(propertyDetails, 'propertyDetails')
        if (propertyDetails) {
            handlePropertyConvo(propertyDetails);
        }
        socket.current.on('connect', () => {
            const userId = userDetails2?.user_id;
            socket.current.emit('addNewUser', userId);
            socket.current.on('getOnlineUsers', (res) => {
            })
        })
        socket.current.on("receiveMessage", async (incomingMessage) => {
            console.log(incomingMessage, 'incomingMessage')
            setEnableInput(true);
            setConversationEnded(false);
            setBotMessageForUser("");
            const messageKey =
                incomingMessage?._id ||
                incomingMessage?.id ||
                incomingMessage?.createdAt ||
                `sock-${Date.now()}`;
            const normalizedText = (incomingMessage?.text || "").toString().toLowerCase().trim();
            let propertyObject1 = { propertyId: incomingMessage.receiverId };
            const getSingleProperty = await PropertiesService.getSignleProperty(
                propertyObject1
            );
            let objengineer = {
                propertyId: incomingMessage.receiverId
            }
            const getgetEngineer = await PropertiesService.getAssignedEngineer(
                objengineer
            );
            if (selectedProperty?._id == incomingMessage.receiverId) {
                console.log('matched')
                if (incomingMessage.text == `Hii User I am ${getgetEngineer?.data?.name}`) {
                    handlePropertyConvo(getSingleProperty.data);
                    setMessage("")
                    console.log('response-1')
                }
                if (normalizedText.includes(SALE_DEED_ACCEPTED_KEYWORD)) {
                    const findMessage = await chatService.getMessages({ userId: selectedProperty?._id });
                    console.log('setMessages');
                    handlePropertyConvo(getSingleProperty.data);
                    setChatMessages(findMessage?.data?.data);
                    setShowSaleDeedSuccessCard(true);
                    setEngineerDocRequest({ type: "Registration Document", messageKey });
                }
                if (normalizedText.includes("to complete the process, upload the sale deed draft")) {
                    setHasManuallyClosedSaledeedPopup(false);
                }
                const incomingWithKey = { ...incomingMessage, _clientKey: messageKey };
                setChatMessages((prevMessages) => [...prevMessages, incomingWithKey]);
                // If engineer requests a specific document upload, switch UI into upload-mode.
                // Currently supported: Registration Document.
                // if (
                //     normalizedText.includes("🎉🎊 Congratulations! Sale Deed Draft Accepted Successfully 🎉🎊") ||
                //     normalizedText.includes("🎉🎊 Congratulations! Sale Deed Draft Accepted Successfully 🎉🎊") ||
                //     normalizedText === "🎉🎊 Congratulations! Sale Deed Draft Accepted Successfully 🎉🎊"
                // ) {
                //     setEngineerDocRequest({ type: "Registration Document", messageKey });
                // }
                if (incomingMessage.rejected == true) {
                    setChatMessages(prev =>
                        prev.map(m =>
                            m.verificationStatus === 'Pending' ? { ...m, verificationStatus: "Rejected", rejectionReason: incomingMessage.reason } : m
                        )
                    );
                    setHasManuallyClosedSaledeedPopup(false);
                }
            } else {
                console.log('not matched')
                let propertyObject1 = { propertyId: incomingMessage.receiverId };
                const getSingleProperty = await PropertiesService.getSignleProperty(
                    propertyObject1
                );
                const previousCount = Number(getSingleProperty?.data?.engineerMessageCount);
                const updatedMessageCount = previousCount + 1;
                setFilteredProperties((prev) => {
                    let updated = prev.map((property) =>
                        property._id === getSingleProperty.data._id
                            ? { ...property, engineerMessageCount: updatedMessageCount, updatedAt: new Date().toISOString() }
                            : property
                    );
                    return sortPropertiesByPriority(updated);
                });
                setPropertyList((prev) => {
                    const updated = prev.map((property) =>
                        property._id === getSingleProperty.data._id
                            ? { ...property, engineerMessageCount: updatedMessageCount, updatedAt: new Date().toISOString() }
                            : property
                    );
                    return sortPropertiesByPriority(updated);
                });
                const obj = {
                    propertyId: getSingleProperty.data._id,
                    userId: getSingleProperty.data.userId,
                    engineerMessageCount: updatedMessageCount,
                };
                PropertiesService.UpdateProperty(obj).catch((err) =>
                    console.error("Failed to sync message count to server", err)
                );
                if (getSingleProperty?.data?.assignedCivilEngineer !== '') {
                    setConversationEnded(true)
                } else {
                    setConversationEnded(false)
                }
            }
        });
        fetchPropertyData();
        return () => {
            socket.current.off("receiveMessage");
            socket.current.disconnect();
        };
    }, [chartId, selectedProperty]);

    const handleEngineerDocRequestNo = async () => {
        // send "No" back to engineer and exit upload-mode
        try {
            setMessage("No");
            await handleSendMessage();
        } finally {
            setMessage("");
            setEngineerDocRequest(null);
            setEngineerDocUploadText("");
            setShowEngineerDocUploadModal(false);
        }
    };

    const handleEngineerDocRequestYes = () => {
        if (engineerDocUploadFileRef.current) {
            engineerDocUploadFileRef.current.value = null;
            engineerDocUploadFileRef.current.click();
        }
    };

    const handleEngineerDocUploadPick = () => {
        if (engineerDocUploadFileRef.current) {
            engineerDocUploadFileRef.current.value = null;
            engineerDocUploadFileRef.current.click();
        }
    };

    const handleEngineerDocUploadSend = async () => {
        // uploadedFiles is populated by handleFileUpload2 (extract + upload)
        if (!uploadedFiles || uploadedFiles.length === 0) {
            setopenDocUploadErrorInChat(true);
            setTimeout(() => setopenDocUploadErrorInChat(false), 2000);
            setDocUploadAlertError("Please upload the document before sending.");
            return;
        }
        try {
            setMessage(engineerDocUploadText || "");
            await handleSendMessage();
            setShowEngineerDocUploadModal(false);
            setEngineerDocRequest(null);
            setEngineerDocUploadText("");
        } finally {
            setMessage("");
        }
    };

    const registrationDocKeywords = [
        "registered sale deed", "sub-registrar", "document no", "registration number",
        "this deed of sale", "registration act", "vendor", "vendee", "seller", "buyer",
        "sale consideration", "survey no", "construction details", "survey drawing",
        "plan", "sketch", "north", "east", "south", "west", "neighbour details",
        "before docity", "after docity", "certified copy", "original copy"
    ];
    const coreRegistrationKeywords = [
        "registered sale deed", "sub-registrar", "document no", "registration number",
        "this deed of sale", "registration act", "vendor", "vendee", "seller", "buyer",
        "sale consideration", "survey no", "construction details", "survey drawing",
        "plan", "sketch", "north", "east", "south", "west", "neighbour details",
        "before docity", "after docity", "certified copy", "original copy"
    ];

    const getRegistrationValidationResult = (rawText = "") => {
        const lowerText = rawText.toLowerCase();
        const allMatches = registrationDocKeywords.filter((kw) =>
            lowerText.includes(kw.toLowerCase())
        );
        const coreMatches = coreRegistrationKeywords.filter((kw) =>
            lowerText.includes(kw.toLowerCase())
        );

        const isValid = allMatches.length >= 4 && coreMatches.length >= 1;
        return {
            isValid,
            allMatchesCount: allMatches.length,
            coreMatchesCount: coreMatches.length,
        };
    };

    const extractPdfText = async (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsArrayBuffer(file);

            reader.onload = async () => {
                try {
                    const pdfData = new Uint8Array(reader.result);
                    const pdf = await pdfjsLib.getDocument({ data: pdfData }).promise;
                    let extractedText = "";

                    for (let i = 1; i <= pdf.numPages; i++) {
                        const page = await pdf.getPage(i);
                        const textContent = await page.getTextContent();
                        const pageText = textContent.items.map(item => item.str).join(" ");
                        extractedText += pageText + "\n";
                    }
                    resolve(extractedText);
                } catch (err) {
                    reject(err);
                }
            };

            reader.onerror = () => reject(new Error("Error reading PDF file"));
        });
    };

    const isValidRegistrationDocument = async (file) => {
        try {
            const extractedText = await extractPdfText(file);
            return getRegistrationValidationResult(extractedText).isValid;
        } catch (error) {
            return false;
        }
    };

    const handleEngineerRegistrationUpload = async (event) => {
        const file = event.target.files?.[0];
        if (!file || !selectedProperty?._id) return;
        if (!validateFileSizeLimit(file)) return;

        setUploadFileLoader(true);
        try {
            const validRegistrationDoc = await isValidRegistrationDocument(file);
            if (!validRegistrationDoc) {
                alert("Wrong document selected. Please upload a valid Registration Document.");
                return;
            }

            const f = new FormData();
            f.append("image", file);
            const uploadResponse = await PropertiesService.UploadFiles(f);
            const fileUrl = uploadResponse?.Location;

            if (!fileUrl) {
                toast.error("Upload failed. Please try again.");
                return;
            }

            const properyObject = { propertyId: selectedProperty?._id };
            const getProperty = await PropertiesService.getSignleProperty(properyObject);
            const findChat = await chatService.findChat({
                firstId: selectedProperty?._id,
                secondId: getProperty?.data?.assignedCivilEngineer,
            });

            const chat = findChat?.data?.data?.[0];
            if (!chat?._id) {
                toast.error("Unable to find chat. Please try again.");
                return;
            }

            await PropertiesService.uploadDoc({
                userId: getProperty?.data?._id,
                docType: "Registration Document",
                docUrl: fileUrl,
            });

            const docs = await PropertiesService.getDocs({ userId: selectedProperty?._id });
            setUserUploadedDocs(docs.data);

            const msgData = {
                senderId: selectedProperty?._id,
                receiverId: selectedProperty?.assignedCivilEngineer,
                text: fileUrl,
                chartId: chat._id,
                id: Date.now(),
                files: [],
            };

            sendMessageOptimistic(msgData, () => {
                PropertiesService.UpdateProperty({
                    ...selectedProperty,
                    propertyId: selectedProperty?._id,
                    resolvedBy: selectedProperty?.assignedCivilEngineer,
                    registrationDocument: fileUrl,
                    registrationDocumentSubmittedDate: new Date().toISOString().split("T")[0],
                    Status: 'resolved',
                })
                    .then((response) => {
                        handlePropertyConvo(response?.data);
                        fetchPropertyData();
                        setRegistrationUploadedFile(fileUrl);
                    })
                    .catch((err) => console.error(err));
            });

            setEngineerDocRequest(null);
            setMessage("");
            setUploadedFiles([]);
            setUploadedFile("");
        } catch (error) {
            console.error("Error uploading engineer-requested registration document", error);
            toast.error("Something went wrong. Please try again.");
        } finally {
            setUploadFileLoader(false);
            if (event.target) event.target.value = "";
        }
    };
    const handleInlineRegistrationUpload = async (event) => {
        const file = event.target.files?.[0];
        if (!file || !selectedProperty?._id) return;
        if (!validateFileSizeLimit(file)) return;

        setInlineRegistrationUploadLoading(true);
        setInlineRegistrationUploadingPropertyId(selectedProperty?._id || "");
        try {
            const validRegistrationDoc = await isValidRegistrationDocument(file);
            if (!validRegistrationDoc) {
                alert("Wrong document selected. Please upload a valid Registration Document.");
                setInlineRegistrationUploadLoading(false);
                setInlineRegistrationUploadingPropertyId("");
                if (event.target) event.target.value = "";
                return;
            }

            const f = new FormData();
            f.append("image", file);

            // Extract text from PDF to find key points
            const reader = new FileReader();
            reader.readAsArrayBuffer(file);

            reader.onload = async () => {
                const pdfData = new Uint8Array(reader.result);
                const pdf = await pdfjsLib.getDocument({ data: pdfData }).promise;
                let extractedText = "";

                for (let i = 1; i <= pdf.numPages; i++) {
                    const page = await pdf.getPage(i);
                    const textContent = await page.getTextContent();
                    const pageText = textContent.items.map(item => item.str).join(" ");
                    extractedText += pageText + "\n";
                }

                // Check for registration document keywords
                const lowerText = extractedText.toLowerCase();
                const registrationKeywords = [
                    "registered sale deed", "sub-registrar", "document no", "registration number",
                    "this deed of sale", "registration act", "vendor", "vendee", "seller", "buyer",
                    "sale consideration", "survey no", "construction details", "survey drawing",
                    "plan", "sketch", "north", "east", "south", "west", "neighbour details",
                    "before docity", "after docity", "certified copy", "original copy"
                ];

                const regMatches = registrationKeywords.filter(kw => lowerText.includes(kw.toLowerCase()));
                const isRegistrationDoc = regMatches.length >= 3;

                if (!isRegistrationDoc) {
                    alert("Wrong document selected. Please upload a valid Registration Document.");
                    setInlineRegistrationUploadLoading(false);
                    setInlineRegistrationUploadingPropertyId("");
                    if (event.target) event.target.value = "";
                    return;
                }

                try {
                    const uploadResponse = await PropertiesService.UploadFiles(f);
                    const fileUrl = uploadResponse?.Location;

                    if (!fileUrl) {
                        toast.error("Upload failed. Please try again.");
                        setInlineRegistrationUploadLoading(false);
                        setInlineRegistrationUploadingPropertyId("");
                        return;
                    }

                    const properyObject = { propertyId: selectedProperty?._id };
                    const getProperty = await PropertiesService.getSignleProperty(properyObject);
                    const findChat = await chatService.findChat({
                        firstId: selectedProperty?._id,
                        secondId: getProperty?.data?.assignedCivilEngineer,
                    });

                    const chat = findChat?.data?.data?.[0];
                    if (!chat?._id) {
                        toast.error("Unable to find chat. Please try again.");
                        setInlineRegistrationUploadLoading(false);
                        setInlineRegistrationUploadingPropertyId("");
                        return;
                    }

                    await PropertiesService.uploadDoc({
                        userId: getProperty?.data?._id,
                        docType: "Registration Document",
                        docUrl: fileUrl,
                    });

                    const docs = await PropertiesService.getDocs({ userId: selectedProperty?._id });
                    setUserUploadedDocs(docs.data);

                    const msgData = {
                        senderId: selectedProperty?._id,
                        receiverId: selectedProperty?.assignedCivilEngineer,
                        text: fileUrl,
                        chartId: chat._id,
                        id: Date.now(),
                        files: [],
                    };

                    sendMessageOptimistic(msgData, () => {
                        PropertiesService.UpdateProperty({
                            ...selectedProperty,
                            propertyId: selectedProperty?._id,
                            resolvedBy: selectedProperty?.assignedCivilEngineer,
                            registrationDocument: fileUrl,
                            registrationDocumentSubmittedDate: new Date().toISOString().split("T")[0],
                            Status: 'resolved',
                        })
                            .then((response) => {
                                handlePropertyConvo(response?.data);
                                fetchPropertyData();
                                setShowSaleDeedSuccessCard(false);
                                setRegistrationUploadedFile(fileUrl);
                                setInlineRegistrationUploadLoading(false);
                                setInlineRegistrationUploadingPropertyId("");
                            })
                            .catch((err) => console.error(err));
                    });

                    setShowInlineRegistrationUploadModal(false);
                } catch (error) {
                    console.error("Inline registration upload failed", error);
                    toast.error("Upload failed. Please try again.");
                    setInlineRegistrationUploadLoading(false);
                    setInlineRegistrationUploadingPropertyId("");
                }
            };

            reader.onerror = () => {
                alert("Unable to read document. Please upload a valid Registration Document.");
                setInlineRegistrationUploadLoading(false);
                setInlineRegistrationUploadingPropertyId("");
            };
        } catch (error) {
            console.error("Error uploading registration document", error);
            toast.error("Something went wrong. Please try again.");
            setInlineRegistrationUploadLoading(false);
            setInlineRegistrationUploadingPropertyId("");
        }
    };
    const [isUserClick, setIsUserClick] = useState(false);
    // Replace your existing scroll effect with this:
    useEffect(() => {
        const scrollToBottom = () => {
            if (messagesEndRefUser2.current) {
                messagesEndRefUser2.current.scrollIntoView({
                    behavior: isUserClick ? "auto" : "smooth",
                    block: "end",
                });
                getAllRequests();
                setIsUserClick(false);
            }
        };

        // Delay scroll slightly to allow iframes/images to calculate height
        const timer = setTimeout(scrollToBottom, 100);

        return () => clearTimeout(timer);
    }, [chatMessages]); // Removed isUserClick to ensure it always targets the latest state
    useEffect(() => {
        checkAllDocs();
        getAllUsers()
        getAllCivilEngs()
    }, [filteredProperties]);
    useEffect(() => {
        document.body.style.overflow = "auto";
        const userDetails = JSON.parse(localStorage.getItem("userDetails"));
        setToken(localStorage.getItem("token") || "");
        setUserDetails(userDetails);
    }, []);
    const triggerFileForSaleAggrementInput = () => {
        fileInputRefForSaleAggrement.current.click();
    };
    const triggerFileForSaleDeedUploadedInput = () => {
        fileInputRefForSaleDeedUploaded.current.click();
    };
    const handleBoxClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.value = null;
            fileInputRef.current.click();
        } else {
            console.warn("fileInputRef is not attached yet");
        }
    };
    const handleBoxClick2 = () => {
        if (fileInputRef2.current) {
            fileInputRef2.current.value = null;
            fileInputRef2.current.click();
        } else {
            console.warn("fileInputRef is not attached yet");
        }
    };
    React.useEffect(() => {
        const handleResize = () => {
            const mobile = window.innerWidth < 1024;
            setIsMobile(mobile);
            if (!mobile) {
                setShowPropertyList(true);
                setShowRightPanel(true);
            } else {
                setShowPropertyList(false);
                setShowRightPanel(false);
            }
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    const onLoad = () => {
        setIsLoading(false);
        setHasError(false);
    };
    const onError = () => {
        setIsLoading(false);
        setHasError(true);
    };
    const getAllRequests = async () => {
        const getReqs = await requestsService.getSaleDeedExtensionRequests();
        setSaleDeedExtensionRequests(getReqs?.data);
    };
    const handleRaiseRequestValues = (e) => {
        const { name, value } = e.target;
        setRaiseRequestFormValues({
            ...raiseRequestFormValues,
            [name]: value,
        });
    };
    const handleRerequest = (property_Key, extendFor) => {
        if (!Array.isArray(saleDeedExtensionRequests)) {
            console.error("saleDeedExtensionRequests is undefined or not an array");
            return false;
        }
        const now = new Date();
        const twentyFourHoursAgo = new Date(now.getTime() - 24 * 60 * 60 * 1000);
        const findData = saleDeedExtensionRequests.filter(
            (req) =>
                req.property_Key === property_Key && req.extendFor === extendFor
            // new Date(req.createdAt) > twentyFourHoursAgo
        );
        if (findData.length > 0) {
            return false;
        } else {
            return true;
        }
    };
    const getPropertyStatusLabel = (item) => {
        if (item.FinalMarketValue && item.FinalMarketValue !== "") {
            return "Cleared";
        }
        if (item.registrationDocument && item.registrationDocument !== "") {
            return "Market Value Declared";
        }
        if (item.saleDeedUploaded && item.saleDeedUploaded !== "") {
            return "Pending";
        }
        if (item.saleDeedSubmissionDate && item.saleDeedSubmissionDate !== "") {
            return "In Process";
        }
        return "Pending";
    };

    const applyFilters = (list, searchVal, statusVal, stateVal) => {
        let res = list || [];
        if (stateVal && stateVal !== "All") {
            res = res.filter(item => String(item.state || "").toLowerCase() === stateVal.toLowerCase());
        }
        if (statusVal !== "All") {
            res = res.filter(item => getPropertyStatusLabel(item) === statusVal);
        }
        if (searchVal.trim() !== "") {
            const query = searchVal.toLowerCase();
            res = res.filter(item =>
                item.address?.toLowerCase().includes(query) ||
                item.property_Key?.toLowerCase().includes(query) ||
                item.pincode?.toLowerCase().includes(query) ||
                item.region?.toLowerCase().includes(query) ||
                item.city?.toLowerCase().includes(query) ||
                item.state?.toLowerCase().includes(query)
            );
        }
        return sortPropertiesByPriority(res);
    };

    const fetchPropertyData = async () => {
        setpropertyListLoading(true);
        try {
            const userDetails = JSON.parse(localStorage.getItem("userDetails"));
            const obj = {
                userId: userDetails?.user_id,
            };
            const response = await PropertiesService.getUserProperties(obj);

            // Show completed/filled properties; also include paid properties as fallback
            // (handles Pay Later flow where backend may persist payment first and fill-status slightly later).
            let data = response?.data?.filter(
                (x) =>
                    x?.isFilled === true ||
                    x?.Payment_Status === true ||
                    String(x?.paymentStatus || "").toLowerCase() === "paid"
            );

            data = sortPropertiesByPriority(data);

            for (let x of data) {
                socket.current.emit("addNewUser", x._id);
                socket.current.on("getOnlineUsers", function () { });
            }

            setViewDoc(true);
            setChatVisible(true);
            setPropertyList(data);
            setFilteredProperties(applyFilters(data, searchTerm, selectedStatusFilter, selectedStateFilter));

            // Restore previously selected property once after refresh
            if (!restoredSelectionRef.current) {
                const persistedSelectedId = localStorage.getItem("selectedPropertyId");
                if (persistedSelectedId) {
                    const matchedProperty = data.find((x) => x?._id === persistedSelectedId);
                    if (matchedProperty) {
                        restoredSelectionRef.current = true;
                        handlePropertyConvo(matchedProperty);
                    }
                }
            }
        } catch (error) {
            console.error("Error fetching property data", error);
        } finally {
            setpropertyListLoading(false);
        }
    };
    const handleSearch = (e) => {
        const value = e.target.value;
        setSearchTerm(value);
        setFilteredProperties(applyFilters(propertyList, value, selectedStatusFilter, selectedStateFilter));
    };

    const handleStatusFilterSelect = (status) => {
        setSelectedStatusFilter(status);
        setFilteredProperties(applyFilters(propertyList, searchTerm, status, selectedStateFilter));
        setShowStatusFilterDropdown(false);
    };

    const handleStateFilterSelect = (state) => {
        setSelectedStateFilter(state);
        setFilteredProperties(applyFilters(propertyList, searchTerm, selectedStatusFilter, state));
    };

    const getUniqueStates = () => {
        const states = propertyList.map(p => p.state).filter(Boolean);
        return ["All", ...new Set(states)];
    };
    const buildAggregation = (list = []) => {
        const tree = {};
        list.forEach((item) => {
            const state = item.state?.trim() || 'Unknown State';
            const city = item.city?.trim() || 'Unknown City';
            const pincode = String(item.pincode || '').trim() || 'Unknown Pincode';
            if (!tree[state]) tree[state] = {};
            if (!tree[state][city]) tree[state][city] = {};
            if (!tree[state][city][pincode]) tree[state][city][pincode] = [];
            tree[state][city][pincode].push(item);
        });
        return tree;
    };

    const toggleAggState = (state) =>
        setExpandedStates((prev) => ({ ...prev, [state]: !prev[state] }));
    const toggleAggCity = (key) =>
        setExpandedCities((prev) => ({ ...prev, [key]: !prev[key] }));
    const toggleAggPincode = (key) =>
        setExpandedPincodes((prev) => ({ ...prev, [key]: !prev[key] }));

    const handleAggPincodeClick = (items) => {
        setFilteredProperties(sortPropertiesByPriority(items));
        setAggregateViewMode(false);
        if (items.length === 1) handlePropertyConvo(items[0]);
    };

    const getUserUploadedDocuments = async (x) => {
        const response = await PropertiesService.getQuestions();
        setAllQuestions(response.data);
        if (response?.message === "Success") {
            let obj = {
                userId: x._id,
            };
            const response2 = await PropertiesService.getDocs(obj);
            if (response2?.message === "Success") {
                const filterData = response2.data;
                if (filterData.length > 0) {
                    const filteredDocuments = filterData.filter((question) => {
                        return response.data.some(
                            (filterItem) => filterItem.question === question.Type
                        );
                    });
                    if (filteredDocuments.length > 0) {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        }
    };
    const checkAllDocs = async () => {
        const statusMap = {};
        await Promise.all(
            filteredProperties.map(async (property) => {
                const hasDocs = await getUserUploadedDocuments(property);
                statusMap[property._id] = hasDocs;
            })
        );
        setDocsStatus(statusMap);
    };
    const showPropertyListView = () => {
        setShowPropertyList(true);
    };
    const fetchSidebarData = async () => {
        console.log(selectedProperty, 'selectedProperty')
        if (selectedProperty?._id) {
            const result = await handleSidebarPanelData(selectedProperty._id);
            console.log(result, 'result222')
            setHasMatchedQuestions(result);
        }
    };
    useEffect(() => {
        fetchSidebarData();
    }, [selectedProperty?._id]);

    const getSaledeedRejectionReason = () => {
        if (!chatMessages) return null;
        const saledeedMsgs = chatMessages.filter(
            (msg) => msg.senderId === selectedProperty?._id && (msg.verificationStatus === 'Rejected' || msg.rejected === true)
        );
        if (saledeedMsgs.length > 0) {
            const latest = saledeedMsgs[saledeedMsgs.length - 1];
            return latest.rejectionReason || latest.reason;
        }
        return null;
    };

    useEffect(() => {
        if (!selectedProperty || ChatPageLoading || !chatMessages) return;

        const hasPendingSaledeed = chatMessages.some(
            (msg) => msg.senderId === selectedProperty?._id && msg.verificationStatus === 'Pending'
        );
        const isVerified = selectedProperty?.saledeedVerified === true;

        if (hasPendingSaledeed || isVerified) {
            setopenUploadSaledeedModel(false);
        }
    }, [chatMessages, selectedProperty, ChatPageLoading]);

    const [QuwstionsList, setQuwstionsList] = useState([])
    const handlePropertyConvo = async (property) => {
        console.log(currentQuestion?.question, 'currentQuestion?.question')
        localStorage.removeItem('propertyDetails');
        if (property?._id) {
            localStorage.setItem("selectedPropertyId", property._id);
            restoredSelectionRef.current = true;
        }
        const updatedMessageCount = 0;
        setChatPageLoading(true);
        setSelectedProperty(property);
        setViewDoc(true);
        setChatVisible(true);
        setHasManuallyClosedSaledeedPopup(false);

        setUserQuestion("");
        setCurrentQuestion(null);
        setRemainingQuestions([]);
        setUserUploadedDocs([]);
        setUserResponseForDocUpload("");
        setUploadedFiles([]);
        setChatMessages([]);
        setShowSaleDeedSuccessCard(false);
        setInlineRegistrationUploadLoading(false);
        setInlineRegistrationUploadingPropertyId("");
        setEngineerDocRequest(null);
        setShowEngineerDocUploadModal(false);
        setEngineerDocUploadText("");
        const obj = {
            propertyId: property?._id,
            userId: property?.userId,
            engineerMessageCount: updatedMessageCount,
        };
        setIsUserClick(true);
        const updateProperty = await PropertiesService.UpdateProperty(obj);
        setFilteredProperties((prev) => {
            const updated = prev.map((p) =>
                p?._id === updateProperty?.data?._id
                    ? { ...p, engineerMessageCount: updatedMessageCount }
                    : p
            );
            return sortPropertiesByPriority(updated);
        });
        setPropertyList((prev) => {
            const updated = prev.map((p) =>
                p?._id === updateProperty?.data?._id
                    ? { ...p, engineerMessageCount: updatedMessageCount }
                    : p
            );
            return sortPropertiesByPriority(updated);
        });

        setChatPageLoading(true);
        if (isMobile) setShowPropertyList(false);
        setSidebarOpen(false);

        try {
            const questionsResp = await PropertiesService.getQuestions();
            setQuwstionsList(questionsResp?.data);

            const propertyResp = await PropertiesService.getSignleProperty({ propertyId: property?._id });
            const singleProperty = propertyResp?.data;

            const docsResp = await PropertiesService.getDocs({ userId: singleProperty?._id });
            const uploadedDocs = docsResp?.data || [];

            SetSwitchToUploadDocsTab({ active: false, id: singleProperty?._id });

            const exceptedDocs = [
                "Have you obtained the Market Value Declaration Certificate?",
                "Have you completed the Digital Transfer process/Bank payment details?",
                "Are you interested in applying for a bank loan?",
            ];

            const documentsPending = uploadedDocs.filter(
                (doc) => doc.url === 'No' && !exceptedDocs.includes(doc.Type)
            );

            setErrorForMergeDocument(
                documentsPending.length > 0
                    ? 'Please upload all documents to download the complete final document. You can view any pending documents in the right panel.'
                    : 'Proceedt'
            );

            if (singleProperty?.saleDeedUploaded) {
                SetSwitchToUploadDocsTab({ active: true, id: singleProperty?._id });
                setTimeout(() => SetSwitchToUploadDocsTab({ active: false, id: singleProperty?._id }), 50);
            }

            setPropertySwitch(singleProperty?.finalMergedWithAllDocuments === '');
            setDisplayFinalMessage(
                propertyResp?.data?.registrationDocument !== "" &&
                propertyResp?.data?.resolvedBy !== ""
            );
            if (singleProperty?.assignedCivilEngineer) setConversationEnded(false);

            const engineerResp = await PropertiesService.getAssignedEngineer({ propertyId: singleProperty?._id });
            setAssignedCivilEngineerData(engineerResp?.message === "Success" ? engineerResp.data : []);

            setViewDoc(true);
            setChatVisible(true);
            setSelectedProperty(singleProperty);
            setChatMessages([{ sender: "bot", text: "Loading conversation..." }]);

            await getQuestion(singleProperty);
            setEnableInput(false);
            setIsInput(false);

            if (singleProperty?.assignedCivilEngineer) {
                const chatResp = await chatService.findChat({
                    firstId: singleProperty?._id,
                    secondId: singleProperty?.assignedCivilEngineer,
                });

                if (chatResp?.data?.message === "Success" && chatResp.data.data.length > 0) {
                    const chat = chatResp.data.data[0];
                    setSaledeedSubmissionErrorMessage("");
                    setEnableInput(true);
                    setIsInput(true);
                    setCurrentQuestion([]);
                    setChartId(chat);

                    const msgResp = await chatService.getMessagesWithChatId({ chartId: chat._id });
                    if (msgResp?.data?.message === "Success" && msgResp.data.data.length > 0) {
                        setChatMessages(msgResp.data.data);
                        setConversationEnded(false);
                    } else {
                        setChatMessages([{ sender: "bot", text: "No messages found for this property." }]);
                    }

                    setChatPageLoading(false);
                    return;
                }
            }

            // No chat - show QnA or wait message
            const pendingQuestions = questionsResp.data.filter(
                (q) => !uploadedDocs.some((doc) => doc.Type === q.question)
            );

            const docsWithQuestions = uploadedDocs.filter((doc) =>
                questionsResp.data.some((q) => q.question === doc.Type)
            );

            if (docsWithQuestions.length > 0) setUserUploadedDocs(docsWithQuestions);

            if (pendingQuestions.length > 0) {

                const firstQuestion = pendingQuestions[0];
                setCurrentQuestion(firstQuestion);
                setSelectedInlineRadioOption(null);
                console.log(firstQuestion, 'firstQuestion')
                if (firstQuestion?.question !== "Expected date for saledeed document upload?") {
                    setSaledeedSubmissionErrorMessage('')
                }
                setChatMessages([
                    { sender: "bot", text: `Please provide your response to: ${firstQuestion.question}` },
                ]);
                setIsInput(true);
                setConversationEnded(false);
            } else {
                setCurrentQuestion("");
                setSelectedInlineRadioOption(null);
                // assignCivlEngineer()
                if (singleProperty?.assignedCivilEngineer) {
                    setChatMessages([{ sender: "bot", text: "Please wait for the civil engineer to connect." }]);
                    setConversationEnded(false);
                } else {
                    setChatMessages([{ sender: "bot", text: "Please wait until a civil engineer is assigned." }]);
                    setConversationEnded(true);
                }
            }
            setChatPageLoading(false);
            fetchSidebarData();
        } catch (error) {
            setChatMessages([{ sender: "bot", text: "Error loading conversation. Please try again." }]);
            setChatPageLoading(false);
            console.error("Error in handlePropertyConvo:", error);
        }
    };
    const RaiseRequestModelWithRequestForText = (data) => {
        setOpenRaiseIssueModel(true)
        setExtendForText(data)
    }
    const handleRaiseRequest = async () => {
        if (!raiseRequestFormValues?.ExtendedDate) {
            setRaiseRequestErrors({ ExtendedDate: "Please select an extended date." });
            setTimeout(() => {
                setRaiseRequestErrors("");
            }, 2000);
        } else if (!raiseRequestFormValues?.ExtendedDateReason) {
            setRaiseRequestErrors({
                ExtendedDateReason: "Please enter a reason for the extension.",
            });
            setTimeout(() => {
                setRaiseRequestErrors("");
            }, 2000);
        } else {
            let obj = {
                ActualDate: selectedProperty?.saleDeedSubmissionDate,
                extendionDate: raiseRequestFormValues?.ExtendedDate,
                reasonForExtend: raiseRequestFormValues?.ExtendedDateReason,
                propertyId: selectedProperty?._id,
                extendFor: ExtendForText
            };
            const createRequest =
                await requestsService.CreateSaleDeedExtensionRequest(obj);

            if (createRequest?.message === "Success") {
                getAllRequests();
                handleRerequest(selectedProperty?._id, createRequest?.extendFor);

                setOpenRaiseIssueModel(false);
            } else {
                getAllRequests();
                handleRerequest(selectedProperty?._id, createRequest?.extendFor);
                setOpenRaiseIssueModel(false);
            }
        }
    };
    const getQuestion = async (x) => {
        try {
            const userDetails = JSON.parse(localStorage.getItem("userDetails"));
            setUserDetails(userDetails);
            const response = await PropertiesService.getQuestions();
            setAllQuestions(response.data);
            if (response?.message === "Success") {
                let obj = {
                    userId: x._id,
                };
                const response2 = await PropertiesService.getDocs(obj);
                if (response2?.message === "Success") {
                    const filterData = response2.data;
                    if (filterData.length > 0) {
                        const filteredQuestions = response.data.filter((question) => {
                            return !filterData.some(
                                (filterItem) => filterItem.Type === question.question
                            );
                        });
                        const filteredDocuments = filterData.filter((question) => {
                            return response.data.some(
                                (filterItem) => filterItem.question === question.Type
                            );
                        });
                        if (filteredDocuments.length > 0) {
                            setUserUploadedDocs(filteredDocuments);
                        } else {
                        }
                        setRemainingQuestions(filteredQuestions);
                    } else {
                        const filteredQuestions = response.data.filter((question) => {
                            return !filterData.some(
                                (filterItem) => filterItem.Type === question.question
                            );
                        });
                        setRemainingQuestions(filteredQuestions);
                        setUserUploadedDocs([]);
                    }
                }
            } else {
                toast.error(
                    "Error in fetching the questions. Try again by reloading the page"
                );
            }
        } catch (err) {
            toast.error(
                "Error in fetching the questions. Try again by reloading the page",
                err
            );
        }
    };
    // Optimistic send: update UI immediately, emit socket, and create message in background
    const sendMessageOptimistic = (msgData, onSuccess) => {
        const tempId = `tmp-${Date.now()}`;
        const optimisticMsg = {
            _id: tempId,
            ...msgData,
            sender: 'user',
            createdAt: new Date().toISOString(),
        };
        setChatMessages((prev) => [...prev, optimisticMsg]);
        try {
            socket.current?.emit("sendMessage", msgData);
        } catch (err) {
            console.error('socket emit failed', err);
        }
        // Fire-and-forget server persistence; replace optimistic message on success
        chatService.createMessage({ ...msgData, images: [] })
            .then((createdMessage) => {
                if (createdMessage?.data?.message === "Success") {
                    setChatMessages((prev) => prev.map((m) => (m._id === tempId ? createdMessage.data.data : m)));
                    try {
                        socket.current?.emit("addNewUser", selectedProperty?._id);
                    } catch (err) { }
                    if (onSuccess) onSuccess(createdMessage.data.data);
                }
            })
            .catch((err) => console.error('createMessage failed', err));
    };
    const checkUserUploadedToQuestions = (datas) => {
        const filterdata = UserUploadedDocs.find((x) => x.Type === datas.Type);
        return filterdata && filterdata.url !== "No";
    };
    const checkUserUploadedToQuestions2 = (datas) => {
        const filterdata = UserUploadedDocs.find((x) => x.Type === datas.question);
        if (filterdata) {
            return true;
        } else {
            return false
        }
    };
    const handleSidebarPanelData = async (sss) => {
        const getQuestionsList = await getQuestions();
        const response = await getDocs(sss);

        const documents = response?.data || [];

        const matchedQuestions = getQuestionsList?.data?.filter((question) =>
            documents.some((doc) => doc.Type === question.question)
        );
        console.log(matchedQuestions, 'matchedQuestions')
        return matchedQuestions?.length;
    };
    const getQuestions = async () => {
        return await PropertiesService.getQuestions();
    };
    const getDocs = async (userId) => {
        return await PropertiesService.getDocs({ userId });
    };
    const getPendingBotQuestions = (datas) => {
        const filteredData = UserUploadedDocs.filter(
            (x) => x.url === "No"
        );
        return filteredData.length;
    };
    const getQuestionType = (datas) => {
        const filterdata = allQuestions.find((x) => x.question === datas.Type);
        return filterdata?.questionType;
    };
    const handleSendMessage = async () => {
        console.log('working-1')
        if (SendMessageLoad) return;
        if (currentQuestion?.questionType) {
            if (
                currentQuestion?.questionType === "FileUpload" &&
                userResponseForDocUpload === 'Yes' &&
                uploadedFiles.length === 0
            ) {
                setopenDocUploadErrorInChat(true)
                setTimeout(() => {
                    setopenDocUploadErrorInChat(false)
                }, 2000)
                setDocUploadAlertError("Please upload a document before proceeding.");
                return;
            }
        }

        if (
            (!userQuestion || userQuestion.trim() === "") &&
            (!Message || Message.trim() === "") &&
            (!uploadedFile || uploadedFile.trim() === "") &&
            uploadedFiles.length === 0 &&
            !userResponseForDocUpload
        ) {
            toast.error("Please provide a response or upload a valid file.");
            return;
        } else {
            console.log('working-2')
            setSendMessageLoad(true);
            try {
                checkAllDocs();
                const properyObject = { propertyId: selectedProperty?._id };
                const getProperty = await PropertiesService.getSignleProperty(properyObject);

                const findChat = await chatService.findChat({
                    firstId: selectedProperty?._id,
                    secondId: getProperty?.data?.assignedCivilEngineer,
                });
                console.log(currentQuestion, 'currentQuestion')
                if (Array.isArray(currentQuestion) ? currentQuestion.length > 0 : !!currentQuestion) {

                    console.log(currentQuestion, 'currentQuestio2222n')
                    if (currentQuestion?.question === "Expected date for saledeed document upload?" && currentQuestion?.questionType !== "FileUpload") {
                        const selectedDate = new Date(userQuestion);
                        const today = new Date();
                        const minDate = new Date(today);
                        const maxDate = new Date(today);
                        maxDate.setDate(today.getDate() + 30);
                        selectedDate.setHours(0, 0, 0, 0); minDate.setHours(0, 0, 0, 0); maxDate.setHours(0, 0, 0, 0);

                        if (selectedDate >= minDate && selectedDate <= maxDate) {
                            setSaledeedSubmissionErrorMessage("");
                            assignCivlEngineer()
                            await PropertiesService.uploadDoc({
                                userId: selectedProperty?._id,
                                docType: currentQuestion.question,
                                docUrl: userQuestion,
                            });

                            await PropertiesService.UpdateProperty({
                                ...selectedProperty,
                                propertyId: selectedProperty._id,
                                userId: userDetails.user_id,
                                saleDeedSubmissionDate: userQuestion,
                            });

                            const docs = await PropertiesService.getDocs({ userId: selectedProperty._id });
                            setChatPageLoading(true);
                            setUserUploadedDocs(docs.data);
                            handlePropertyConvo(selectedProperty);
                        } else {
                            if (currentQuestion?.question === "Expected date for saledeed document upload?" && currentQuestion?.questionType !== "FileUpload") {
                                setSaledeedSubmissionErrorMessage("The sale deed submission date must be within 30 days from today's date. Please select a valid date.");
                            } else {
                                setSaledeedSubmissionErrorMessage('')
                            } handlePropertyConvo(selectedProperty);
                        }
                        setSendMessageLoad(false);
                        return;
                    }
                    if (currentQuestion?.questionType !== "FileUpload") {
                        console.log('working=1')
                        await PropertiesService.uploadDoc({
                            userId: selectedProperty?._id,
                            docType: currentQuestion.question,
                            docUrl: userQuestion,
                        });
                        const docs = await PropertiesService.getDocs({ userId: selectedProperty?._id });
                        setUserUploadedDocs(docs.data);
                        fetchSidebarData();
                        setSendMessageLoad(false);
                    }
                    // let answerData;
                    // if (userResponseForDocUpload === 'Yes') {
                    //     answerData = userQuestion;
                    // } else if (userResponseForDocUpload === 'No') {
                    //     answerData = 'No';
                    // }
                    // console.log(userQuestion, 'userQuestion')
                    // if (currentQuestion?.questionType !== "FileUpload" && answerData !== '') {
                    //     console.log('working=1')
                    //     const datasssss = await PropertiesService.uploadDoc({
                    //         userId: selectedProperty?._id,
                    //         docType: currentQuestion.question,
                    //         docUrl: (userResponseForDocUpload ? answerData : userQuestion),
                    //     });

                    //     const docs = await PropertiesService.getDocs({ userId: selectedProperty?._id });
                    //     setUserUploadedDocs(docs.data);
                    //     setSendMessageLoad(false);
                    // } else {
                    //     console.log('working=2')
                    //     const datasssss = await PropertiesService.uploadDoc({
                    //         userId: selectedProperty?._id,
                    //         docType: currentQuestion.question,
                    //         docUrl: userQuestion || answerData,
                    //     });
                    //     console.log(datasssss, 'datasssss')
                    //     const docs = await PropertiesService.getDocs({ userId: selectedProperty?._id });
                    //     setUserUploadedDocs(docs.data);
                    //     setSendMessageLoad(false);
                    // }
                }

                if (findChat?.data?.message === "Success" && findChat.data.data.length > 0) {
                    console.log('finding-1')
                    const chat = findChat.data.data[0];
                    // const chatMessagesResp = await chatService.getMessagesWithChatId({ chartId: chat._id });
                    // if (chatMessagesResp?.data.message === "Success") {
                    //     // for (let message of chatMessagesResp.data.data) {
                    //     //     if (message.text === "To complete the process, upload the sale deed draft" && uploadedFile) {
                    //     //         await PropertiesService.uploadDoc({
                    //     //             userId: selectedProperty?._id,
                    //     //             docType: "saledeedDocument",
                    //     //             docUrl: uploadedFile,
                    //     //         });

                    //     //         await PropertiesService.UpdateProperty({
                    //     //             ...selectedProperty,
                    //     //             propertyId: selectedProperty._id,
                    //     //             saleDeedUploaded: uploadedFile,
                    //     //             saledeedSubmittedDate: new Date().toISOString().split("T")[0],
                    //     //             userId: userDetails.user_id,
                    //     //             // resolvedBy: selectedProperty.assignedCivilEngineer,
                    //     //             // assignedCivilEngineer: "",
                    //     //         });

                    //     //         const msgData = {
                    //     //             senderId: selectedProperty._id,
                    //     //             receiverId: selectedProperty?.assignedCivilEngineer,
                    //     //             text: 'Saledeed Uploaded',
                    //     //             chartId: chat._id,
                    //     //             id: Date.now(),
                    //     //             files: []
                    //     //         };
                    //     //         socket.current.emit("sendMessage", msgData);
                    //     //         await chatService.createMessage({ ...msgData, images: [] });

                    //     //         const getCivilEngineer = await civilengineerService.getCivilEngData({ userId: selectedProperty.assignedCivilEngineer });
                    //     //         const updatedAssignedProperties = (getCivilEngineer?.data?.assignedProperties || []).filter(
                    //     //             x => x.assignedProperties !== selectedProperty._id
                    //     //         );
                    //     //         await civilengineerService.editCivilEngData({
                    //     //             ...getCivilEngineer?.data,
                    //     //             assignedProperties: updatedAssignedProperties,
                    //     //         });

                    //     //         handlePropertyConvo(selectedProperty);
                    //     //     }
                    //     // }
                    // }
                    console.log(uploadedFiles, 'finding-2')
                    if (uploadedFiles.length > 0) {
                        console.log('working-3')
                        if (Message !== '') {
                            if (uploadedFiles[0].data !== '') {
                                await PropertiesService.uploadDoc({
                                    userId: getProperty?.data?._id,
                                    docType: uploadedFiles[0].question,
                                    docUrl: uploadedFiles[0].data,
                                });
                                let objsss = {
                                    userId: getProperty?.data?._id,
                                    docType: uploadedFiles[0].question,
                                    docUrl: uploadedFiles[0].data,
                                }
                                console.log(objsss, 'finding-3')
                                const docs = await PropertiesService.getDocs({ userId: selectedProperty._id });
                                setUserUploadedDocs(docs.data);
                                fetchSidebarData();
                                const msgData = {
                                    senderId: selectedProperty._id,
                                    receiverId: selectedProperty?.assignedCivilEngineer,
                                    text: Message,
                                    chartId: chat._id,
                                    id: Date.now(),
                                    files: [uploadedFiles[0].data],
                                };
                                console.log(msgData, 'msgDataqqq')
                                sendMessageOptimistic(msgData, (created) => {
                                    if (uploadedFiles[0].question == 'Registration Document') {
                                        PropertiesService.UpdateProperty({
                                            ...selectedProperty,
                                            propertyId: selectedProperty?._id,
                                            resolvedBy: selectedProperty?.assignedCivilEngineer,
                                            registrationDocument: uploadedFiles[0].data,
                                            registrationDocumentSubmittedDate: new Date()
                                                .toISOString()
                                                .split("T")[0],
                                            Status: 'resolved'
                                        }).then((response) => {
                                            handlePropertyConvo(response?.data);
                                            fetchPropertyData();
                                            setRegistrationUploadedFile(uploadedFiles[0].data);
                                        }).catch(err => console.error(err));
                                    }
                                    setUserQuestion("");
                                    setMessage("");
                                });
                                setUploadedFiles([]);
                                setUploadedFile("");
                                setSendMessageLoad(false);
                                return;
                            }
                        } else {
                            console.log('working-4')
                            if (uploadedFiles[0].data !== '') {
                                await PropertiesService.uploadDoc({
                                    userId: getProperty?.data?._id,
                                    docType: uploadedFiles[0].question,
                                    docUrl: uploadedFiles[0].data,
                                });
                                let objsss = {
                                    userId: getProperty?.data?._id,
                                    docType: uploadedFiles[0].question,
                                    docUrl: uploadedFiles[0].data,
                                }
                                console.log(objsss, 'finding-3')
                                const docs = await PropertiesService.getDocs({ userId: selectedProperty._id });
                                setUserUploadedDocs(docs.data);
                                fetchSidebarData();
                                const msgData = {
                                    senderId: selectedProperty._id,
                                    receiverId: selectedProperty?.assignedCivilEngineer,
                                    text: uploadedFiles[0].data,
                                    chartId: chat._id,
                                    id: Date.now(),
                                    files: [],
                                };
                                sendMessageOptimistic(msgData, (created) => {
                                    if (uploadedFiles[0].question == 'Registration Document') {
                                        PropertiesService.UpdateProperty({
                                            ...selectedProperty,
                                            propertyId: selectedProperty?._id,
                                            resolvedBy: selectedProperty?.assignedCivilEngineer,
                                            registrationDocument: uploadedFiles[0].data,
                                            registrationDocumentSubmittedDate: new Date()
                                                .toISOString()
                                                .split("T")[0],
                                            Status: 'resolved'
                                        }).then((response) => {
                                            handlePropertyConvo(response?.data);
                                            fetchPropertyData();
                                            setRegistrationUploadedFile(uploadedFiles[0].data);
                                            setUploadedFiles([]);
                                        }).catch(err => console.error(err));
                                    }
                                    setUserQuestion("");
                                    setMessage("");
                                    setUploadedFiles([]);
                                });

                                setUploadedFile("");
                                setSendMessageLoad(false);
                                return;
                            }

                        }
                    }
                    if (Message !== "") {
                        console.log('working-5')
                        const msgData = {
                            senderId: selectedProperty?._id,
                            receiverId: selectedProperty?.assignedCivilEngineer,
                            text: Message,
                            chartId: chat._id,
                            id: Date.now(),
                        };
                        sendMessageOptimistic(msgData, (created) => {
                            setUserQuestion("");
                            setMessage("");
                            setUploadedFiles([]);
                        });
                        setUploadedFile("");
                        setSendMessageLoad(false);
                        return;
                    }
                } else {
                    console.log('finding-5')
                    let answerData;
                    if (userResponseForDocUpload === 'Yes') {
                        answerData = uploadedFiles[0].data;
                    } else if (userResponseForDocUpload === 'No') {
                        answerData = 'No';
                    }
                    if (userResponseForDocUpload) {
                        setChatMessages((prevMessages) => [
                            ...prevMessages,
                            { sender: "user", text: userQuestion || uploadedFile || answerData },
                        ]);
                        console.log(userQuestion, 'userQuestionww')
                        if (uploadedFiles.length > 0 || answerData) {
                            let obj = {
                                userId: selectedProperty?._id,
                                docType: answerData ? currentQuestion?.question : uploadedFiles?.[0]?.question,
                                docUrl: answerData || uploadedFiles?.[0]?.data,
                            };

                            await PropertiesService.uploadDoc(obj);
                            const docs = await PropertiesService.getDocs({ userId: selectedProperty._id });
                            setUserUploadedDocs(docs.data);
                            setUserQuestion("");

                            if (currentQuestion?.questionType === "FileUpload") {
                                setChatMessages((prevMessages) => [
                                    ...prevMessages,
                                    {
                                        sender: "bot",
                                        text: userResponseForDocUpload === 'Yes' ? `File uploaded for: ${uploadedFiles[uploadedFiles.length - 1].question.split('?')[0]}` : answerData,
                                    },
                                ]);
                            }
                            setUserResponseForDocUpload("")
                            setUploadedFiles([]);
                            setUploadedFile("");
                        }
                        else if (uploadedFiles.length > 0) {
                            console.log('finding-6')
                            let obj = {
                                userId: selectedProperty?._id,
                                docType: uploadedFiles?.[0]?.question,
                                docUrl: uploadedFiles?.[0]?.data,
                            };

                            await PropertiesService.uploadDoc(obj);
                            const docs = await PropertiesService.getDocs({ userId: selectedProperty._id });
                            setUserUploadedDocs(docs.data);
                            setUserQuestion("");

                            if (currentQuestion?.questionType === "FileUpload") {
                                const question = uploadedFiles[uploadedFiles.length - 1].question;
                                const cleanQuestion = question.split('?')[0];

                                const message = `File uploaded for: ${cleanQuestion}`;

                                setChatMessages((prevMessages) => [
                                    ...prevMessages,
                                    {
                                        sender: "bot",
                                        text: message,
                                    },
                                ]);

                            }
                            setUploadedFiles([]);
                            setUploadedFile("");

                        } else {
                            setChatMessages((prevMessages) => [
                                ...prevMessages,
                                { sender: "bot", text: userQuestion },
                            ]);
                        }

                        if (remainingQuestions.length === 1) {
                            setConversationEnded(true);
                            setChatMessages((prevMessages) => [
                                ...prevMessages,
                                { sender: "bot", text: "A civil engineer will connect with you soon." },
                            ]);
                            setUserQuestion("");
                            setMessage();
                            if (
                                currentQuestion.question ===
                                "Expected date for saledeed document upload?"
                            ) {
                                const selectedDate = new Date(userQuestion);
                                const today = new Date();
                                const minDate = new Date(today);
                                const maxDate = new Date(today);
                                maxDate.setDate(today.getDate() + 30);

                                // Clear time
                                selectedDate.setHours(0, 0, 0, 0);
                                minDate.setHours(0, 0, 0, 0);
                                maxDate.setHours(0, 0, 0, 0);

                                if (selectedDate >= minDate && selectedDate <= maxDate) {
                                    assignCivlEngineer();
                                    setIsInput(false);
                                }
                            }
                        } else {
                            const updatedRemainingQuestions = remainingQuestions.slice(1);
                            const nextQuestion = updatedRemainingQuestions[0];
                            setRemainingQuestions(updatedRemainingQuestions);
                            setCurrentQuestion(nextQuestion);
                            setConversationEnded(false);
                            setIsInput(true);
                            setUserQuestion("");
                            setMessage();

                            let botMessage = "";
                            switch (nextQuestion?.questionType) {
                                case "text":
                                    botMessage = `Please provide your response to: ${nextQuestion?.question}`;
                                    break;
                                case "date":
                                    botMessage = `Please provide a date for: ${nextQuestion?.question}`;
                                    break;
                                case "FileUpload":
                                    botMessage = `Please upload the document for: ${nextQuestion?.question}`;
                                    break;
                                case "radio":
                                    botMessage = `Please select an option for: ${nextQuestion?.question}`;
                                    break;
                                case "number":
                                    botMessage = `Please provide a number for: ${nextQuestion?.question}`;
                                    break;
                                default:
                                    botMessage = `Please provide an answer for: ${nextQuestion?.question}`;
                            }

                            if (
                                nextQuestion?.question ===
                                "⁠link documents explaining the title deeds?"
                            ) {
                                setChatMessages((prevMessages) => [
                                    ...prevMessages,
                                    { sender: "bot", text: botMessage, Link: "Link" },
                                ]);
                            } else {
                                setChatMessages((prevMessages) => [
                                    ...prevMessages,
                                    { sender: "bot", text: botMessage },
                                ]);
                            }
                        }
                    }
                    else if (userQuestion || uploadedFiles.length > 0) {
                        setChatMessages((prevMessages) => [
                            ...prevMessages,
                            { sender: "user", text: userQuestion || uploadedFile },
                        ]);
                        if (uploadedFiles.length > 0) {
                            let obj = {
                                userId: selectedProperty?._id,
                                docType: uploadedFiles?.[0]?.question,
                                docUrl: uploadedFiles?.[0]?.data,
                            };

                            await PropertiesService.uploadDoc(obj);
                            const docs = await PropertiesService.getDocs({ userId: selectedProperty._id });
                            setUserUploadedDocs(docs.data);
                            setUserQuestion("");

                            if (currentQuestion?.questionType === "FileUpload") {
                                const question = uploadedFiles[uploadedFiles.length - 1].question;
                                const cleanQuestion = question.split('?')[0];

                                const message = `File uploaded for: ${cleanQuestion}`;

                                setChatMessages((prevMessages) => [
                                    ...prevMessages,
                                    {
                                        sender: "bot",
                                        text: message,
                                    },
                                ]);
                            }
                            setUploadedFiles([]);
                            setUploadedFile("");
                        } else {
                            setChatMessages((prevMessages) => [
                                ...prevMessages,
                                { sender: "bot", text: userQuestion },
                            ]);
                        }

                        if (remainingQuestions.length === 1) {
                            setConversationEnded(true);
                            setChatMessages((prevMessages) => [
                                ...prevMessages,
                                { sender: "bot", text: "A civil engineer will connect with you soon." },
                            ]);
                            setUserQuestion("");
                            setMessage();
                            if (
                                currentQuestion.question ===
                                "Expected date for saledeed document upload?"
                            ) {
                                const selectedDate = new Date(userQuestion);
                                const today = new Date();
                                const minDate = new Date(today);
                                const maxDate = new Date(today);
                                maxDate.setDate(today.getDate() + 30);

                                // Clear time
                                selectedDate.setHours(0, 0, 0, 0);
                                minDate.setHours(0, 0, 0, 0);
                                maxDate.setHours(0, 0, 0, 0);

                                if (selectedDate >= minDate && selectedDate <= maxDate) {
                                    assignCivlEngineer();
                                    setIsInput(false);
                                }
                            }
                        } else {
                            const updatedRemainingQuestions = remainingQuestions.slice(1);
                            const nextQuestion = updatedRemainingQuestions[0];
                            setRemainingQuestions(updatedRemainingQuestions);
                            setCurrentQuestion(nextQuestion);
                            setConversationEnded(false);
                            setIsInput(true);
                            setUserQuestion("");
                            setMessage();

                            let botMessage = "";
                            switch (nextQuestion?.questionType) {
                                case "text":
                                    botMessage = `Please provide your response to: ${nextQuestion?.question}`;
                                    break;
                                case "date":
                                    botMessage = `Please provide a date for: ${nextQuestion?.question}`;
                                    break;
                                case "FileUpload":
                                    botMessage = `Please upload the document for: ${nextQuestion?.question}`;
                                    break;
                                case "radio":
                                    botMessage = `Please select an option for: ${nextQuestion?.question}`;
                                    break;
                                case "number":
                                    botMessage = `Please provide a number for: ${nextQuestion?.question}`;
                                    break;
                                default:
                                    botMessage = `Please provide an answer for: ${nextQuestion?.question}`;
                            }

                            if (
                                nextQuestion?.question ===
                                "⁠link documents explaining the title deeds?"
                            ) {
                                setChatMessages((prevMessages) => [
                                    ...prevMessages,
                                    { sender: "bot", text: botMessage, Link: "Link" },
                                ]);
                            } else {
                                setChatMessages((prevMessages) => [
                                    ...prevMessages,
                                    { sender: "bot", text: botMessage },
                                ]);
                            }
                        }

                        setUploadedFile("");
                    } else {
                        toast.error("Please provide a response.");
                    }
                }
            } catch (error) {
                console.error("Error in handleSendMessage", error);
                toast.error("Something went wrong. Please try again.");
            }

            setSendMessageLoad(false);
        }
    };
    const pushNextQuestionAfterInlineAnswer = () => {
        if (remainingQuestions.length === 1) {
            setConversationEnded(true);
            setChatMessages((prevMessages) => [
                ...prevMessages,
                { sender: "bot", text: "A civil engineer will connect with you soon." },
            ]);
            setUserQuestion("");
            setMessage("");
            setSelectedInlineRadioOption(null);
            return;
        }

        const updatedRemainingQuestions = remainingQuestions.slice(1);
        const nextQuestion = updatedRemainingQuestions[0];
        setRemainingQuestions(updatedRemainingQuestions);
        setCurrentQuestion(nextQuestion);
        setConversationEnded(false);
        setIsInput(true);
        setUserQuestion("");
        setMessage("");
        setSelectedInlineRadioOption(null);

        let botMessage = "";
        switch (nextQuestion?.questionType) {
            case "text":
                botMessage = `Please provide your response to: ${nextQuestion?.question}`;
                break;
            case "date":
                botMessage = `Please provide a date for: ${nextQuestion?.question}`;
                break;
            case "FileUpload":
                botMessage = `Please upload the document for: ${nextQuestion?.question}`;
                break;
            case "radio":
                botMessage = `Please select an option for: ${nextQuestion?.question}`;
                break;
            case "number":
                botMessage = `Please provide a number for: ${nextQuestion?.question}`;
                break;
            default:
                botMessage = `Please provide an answer for: ${nextQuestion?.question}`;
        }

        if (nextQuestion?.question === "⁠link documents explaining the title deeds?") {
            setChatMessages((prevMessages) => [
                ...prevMessages,
                { sender: "bot", text: botMessage, Link: "Link" },
            ]);
        } else {
            setChatMessages((prevMessages) => [
                ...prevMessages,
                { sender: "bot", text: botMessage },
            ]);
        }
    };
    const handleInlineFileQuestionAnswer = async (value, fileUrl = "") => {
        if (!currentQuestion || currentQuestion?.questionType !== "FileUpload") return;
        if (SendMessageLoad) return;

        setSendMessageLoad(true);
        try {
            const answerUrl = value === "No" ? "No" : fileUrl;
            if (!answerUrl) {
                setSendMessageLoad(false);
                return;
            }

            setChatMessages((prevMessages) => [
                ...prevMessages,
                { sender: "user", text: value === "No" ? "No" : answerUrl },
            ]);

            await PropertiesService.uploadDoc({
                userId: selectedProperty?._id,
                docType: currentQuestion.question,
                docUrl: answerUrl,
            });

            const docs = await PropertiesService.getDocs({ userId: selectedProperty?._id });
            setUserUploadedDocs(docs.data);

            if (value === "Yes") {
                const cleanQuestion = (currentQuestion.question || "").split("?")[0];
                setChatMessages((prevMessages) => [
                    ...prevMessages,
                    { sender: "bot", text: `File uploaded for: ${cleanQuestion}` },
                ]);
            }

            setUserResponseForDocUpload("");
            setUploadedFiles([]);
            setUploadedFile("");
            pushNextQuestionAfterInlineAnswer();
        } catch (error) {
            console.error("Inline file answer failed", error);
            toast.error("Something went wrong. Please try again.");
        } finally {
            setSendMessageLoad(false);
        }
    };
    const openInlineFileUploadModal = () => {
        setInlineFileUploadError("");
        setShowInlineFileUploadModal(true);
        setTimeout(() => {
            inlineFileUploadRef.current?.click();
        }, 50);
    };
    const handleInlineFileSelected = async (event) => {
        const file = event.target.files?.[0];
        if (!file) return;
        if (!validateFileSizeLimit(file)) {
            setInlineFileUploadError(`File size (${(file.size / (1024 * 1024)).toFixed(1)}MB) exceeds the maximum limit of ${MAX_UPLOAD_SIZE_MB}MB.`);
            if (event.target) event.target.value = "";
            return;
        }

        setInlineFileUploadLoading(true);
        setInlineFileUploadError("");
        try {
            const f = new FormData();
            f.append("image", file);
            const response = await PropertiesService.UploadFiles(f);
            if (isApiErrorResponse(response)) {
                const message = getApiErrorMessage(response, "Upload failed. Please try again.");
                setInlineFileUploadError(message);
                toast.error(message);
                return;
            }
            const fileUrl = response?.Location || response?.previewUrl || response?.url || response?.downloadUrl;
            if (!fileUrl) {
                const message = "Upload failed. Please try again.";
                setInlineFileUploadError(message);
                toast.error(message);
                return;
            }

            setShowInlineFileUploadModal(false);
            await handleInlineFileQuestionAnswer("Yes", fileUrl);
        } catch (error) {
            console.error("Inline upload failed", error);
            const message = getApiErrorMessage(error, "Upload failed. Please try again.");
            setInlineFileUploadError(message);
            toast.error(message);
        } finally {
            setInlineFileUploadLoading(false);
            if (event.target) event.target.value = "";
        }
    };
    const handleInlineRadioAnswer = async (value) => {
        if (!currentQuestion || currentQuestion?.questionType !== "radio") return;
        if (SendMessageLoad) return;
        // Prevent double-send by checking if already selected
        if (selectedInlineRadioOption === value) return;

        setSelectedInlineRadioOption(value);
        setUserQuestion(value);
        setSendMessageLoad(true);

        try {
            const backendAnswer = mapRadioAnswerForBackend(currentQuestion?.question, value);
            // Always save the answer to docs so Q&A flow progresses even before chat exists
            await PropertiesService.uploadDoc({
                userId: selectedProperty?._id,
                docType: currentQuestion?.question,
                docUrl: backendAnswer,
            });
            const docs = await PropertiesService.getDocs({ userId: selectedProperty?._id });
            setUserUploadedDocs(docs.data);

            // If chat exists, send to engineer as well
            const properyObject = { propertyId: selectedProperty?._id };
            const getProperty = await PropertiesService.getSignleProperty(properyObject);
            const findChat = await chatService.findChat({
                firstId: selectedProperty?._id,
                secondId: getProperty?.data?.assignedCivilEngineer,
            });
            const chat = findChat?.data?.data?.[0];

            if (chat?._id) {
                const msgData = {
                    senderId: selectedProperty?._id,
                    receiverId: getProperty?.data?.assignedCivilEngineer,
                    text: backendAnswer,
                    chartId: chat._id,
                    id: Date.now(),
                    files: [],
                };
                sendMessageOptimistic(msgData);
            } else {
                // No chat yet: still reflect user answer in UI immediately
                setChatMessages((prevMessages) => [
                    ...prevMessages,
                    { sender: "user", text: backendAnswer },
                ]);
            }

            pushNextQuestionAfterInlineAnswer();
        } catch (error) {
            console.error("Inline radio answer failed", error);
            toast.error("Something went wrong. Please try again.");
        } finally {
            setSendMessageLoad(false);
        }
    };
    const handleFileUpload = async (event) => {
        const file = event.target.files[0];
        if (!file || !validateFileSizeLimit(file)) return;
        const f = new FormData();
        f.append("image", file);
        setIsLoading(true);
        const response = await PropertiesService.UploadFiles(f);
        setUploadFileLoader(true);
        setTimeout(() => {
            setUploadedFile(response.Location);
            setUploadFileLoader(false);
        }, 2000);
        const data = response.Location;
        if (file && currentQuestion) {
            setUploadedFiles((prevFiles) => [
                ...prevFiles,
                { question: currentQuestion.question, data },
            ]);
            setIsInput(true);
            setIsLoading(false);
        }
    };
    const handleFileUpload2 = async (event) => {
        const file = event.target.files[0];
        if (!file || !validateFileSizeLimit(file)) return;
        const f = new FormData();
        f.append("image", file);
        extractTextFromPDF(file, f, 'sss')
    };
    const handleSaledeedFileUpload = async (event) => {
        const file = event.target.files[0];
        if (!file) return;
        if (!validateFileSizeLimit(file)) return;
        setErrorMessagesForSaledeedModel('');
        const f = new FormData();
        f.append("image", file);
        extractTextFromPDF(file, f, 'saledeed')
    };
    const extractTextFromPDF = async (file, f, item) => {
        const reader = new FileReader();
        reader.readAsArrayBuffer(file);

        reader.onload = async () => {
            const pdfData = new Uint8Array(reader.result);
            const pdf = await pdfjsLib.getDocument({ data: pdfData }).promise;
            let extractedText = "";

            for (let i = 1; i <= pdf.numPages; i++) {
                const page = await pdf.getPage(i);
                const textContent = await page.getTextContent();
                const pageText = textContent.items.map(item => item.str).join(" ");
                extractedText += pageText + "\n";
            }

            setText(extractedText,);
            extractData(extractedText, f, item);
        };

        reader.onerror = () => {
            setText("Error reading PDF file.");
        };
    };
    const extractData = async (text, f, item) => {
        try {
            const lowerText = text.toLowerCase();

            if (item === 'Final Market Value') {
                const marketValueKeywords = [
                    "final market value", "total market value", "market value of the property",
                    "market value as per sub-registrar", "declared market value",
                    "self declaration", "annexure", "payment details", "financial statement",
                    "bank statement", "receipt paid to vendor", "receipt paid to seller",
                    "bank loan approval", "legal opinion", "clearance certificate",
                    "housing finance loan", "principal bank"
                ];

                const mvMatches = marketValueKeywords.filter(kw => lowerText.includes(kw.toLowerCase()));
                const isMarketValueDoc = mvMatches.length >= 2;

                if (isMarketValueDoc) {
                    try {
                        const uploadResponse = await PropertiesService.UploadFiles(f);
                        if (isApiErrorResponse(uploadResponse)) {
                            throw new Error(getApiErrorMessage(uploadResponse, 'Unable to upload market value document'));
                        }
                        if (uploadResponse?.Location) {
                            let obj = {
                                propertyId: selectedProperty._id,
                                FinalMarketValue: uploadResponse.Location,
                            };
                            const updateResponse = await PropertiesService.UpdateProperty(obj);
                            await PropertiesService.uploadDoc({
                                userId: selectedProperty._id,
                                docType: 'Final Market Value',
                                docUrl: uploadResponse.Location,
                            });
                            if (updateResponse.message === "Success") {
                                handlePropertyConvo(updateResponse?.data);
                                fetchPropertyData();
                                setMarketValueUploadedFile(uploadResponse.Location);
                            }
                        }
                    } catch (error) {
                        console.error("Upload error:", error);
                        setMarketValueUploadedFile("");
                        toast.error(getApiErrorMessage(error, 'Unable to upload market value document'));
                    } finally {
                        setMarketValueFileLoader(false);
                    }
                } else {
                    alert("Identification failed. Market Value Document must include: Self Declaration, Payment Details, Bank Statements, or Loan Approval letters.");
                    setMarketValueFileLoader(false);
                }

                return;
            }

            const registrationValidation = getRegistrationValidationResult(text);
            const isRegistrationDoc = registrationValidation.isValid;
            const documentType = isRegistrationDoc ? "Registration Document" : "Unknown";

            if (documentType === 'Registration Document' && selectedProperty?.saledeedVerified === true) {
                setIsLoading(true);
                const UploadFilesresponse22 = await PropertiesService.UploadFiles(f);
                if (isApiErrorResponse(UploadFilesresponse22)) {
                    throw new Error(getApiErrorMessage(UploadFilesresponse22, 'Upload failed'));
                }
                setUploadFileLoader(true);
                setTimeout(() => {
                    setUploadedFile(UploadFilesresponse22.Location);
                    setUploadFileLoader(false);
                }, 2000);

                const data = UploadFilesresponse22.Location;
                if (data) {
                    const uploadedDoc = { question: "Registration Document", data };
                    setUploadedFiles((prevFiles) => [...prevFiles, uploadedDoc]);
                    setIsInput(true);
                    setIsLoading(false);
                }
            } else if (documentType === 'Registration Document' && !selectedProperty?.saledeedVerified) {
                alert('Please wait for Sale Deed verification before uploading the Registration Document.');
            } else if (item === 'saledeed') {
                setIsLoading1(true);
                const response = await PropertiesService.UploadFiles(f);
                if (isApiErrorResponse(response)) {
                    throw new Error(getApiErrorMessage(response, 'Unable to upload sale deed document'));
                }
                setSaleDeedUploadedFile(response.Location);

                let obj = {
                    userId: selectedProperty.userId,
                    docType: "saledeedDocument",
                    docUrl: response.Location,
                    fields: []
                };
                await PropertiesService.uploadDoc(obj);
                setUploadedFiles([{ question: "saledeedDocument", data: response.Location }]);
                setIsInput(true);
                setIsLoading1(false);
            } else {
                alert("Identification failed. Registration Document must match key points (minimum 4 keyword matches including at least 1 core keypoint like registered sale deed / sub-registrar / registration number). Please upload a valid Registration Document.");
            }
        } catch (error) {
            const message = getApiErrorMessage(error, 'Unable to process the uploaded document');
            setErrorMessagesForSaledeedModel(message);
            toast.error(message);
            setIsLoading(false);
            setIsLoading1(false);
        }
    };
    const handleUploadRegistrationFileUpload = async (event) => {
        setRegistrationFileLoader(true);
        const file = event.target.files[0];
        if (!file || !validateFileSizeLimit(file)) {
            setRegistrationFileLoader(false);
            if (event.target) event.target.value = "";
            return;
        }
        const validRegistrationDoc = await isValidRegistrationDocument(file);
        if (!validRegistrationDoc) {
            alert("Wrong document selected. Please upload a valid Registration Document.");
            setRegistrationFileLoader(false);
            if (event.target) event.target.value = "";
            return;
        }

        const f = new FormData();
        f.append("image", file);

        try {
            const uploadResponse = await PropertiesService.UploadFiles(f);
            if (uploadResponse?.Location) {
                let obj = {
                    propertyId: selectedProperty._id,
                    registrationDocument: uploadResponse.Location,
                    registrationDocumentSubmittedDate: new Date()
                        .toISOString()
                        .split("T")[0],
                };
                const updateResponse = await PropertiesService.UpdateProperty(obj);
                if (updateResponse.message === 'Success') {
                    handlePropertyConvo(updateResponse?.data);
                    fetchPropertyData()
                    setRegistrationUploadedFile(uploadResponse.Location);
                } else {
                    setRegistrationUploadedFile("");
                }
            }
        } catch (error) {
            console.error("Upload error:", error);
            setRegistrationUploadedFile("");
        } finally {
            setRegistrationFileLoader(false);
        }
    };
    const handleUploadMarketValueFileUpload = async (event) => {
        setMarketValueFileLoader(true);
        const file = event.target.files[0];
        if (!file || !validateFileSizeLimit(file)) {
            setMarketValueFileLoader(false);
            if (event.target) event.target.value = "";
            return;
        }
        const f = new FormData();
        f.append("image", file);
        extractTextFromPDF(file, f, 'Final Market Value')

    };
    const validateRegistrationNumber = (number, state) => {
        if (!number || !state) return false;

        let clean = number.trim();
        const currentYear = new Date().getFullYear();

        switch (state.toLowerCase()) {
            case 'tamil nadu': {
                const regex = /^\d{1,6}\s*\/\s*\d{4}/;

                if (!regex.test(clean)) return false;

                // Normalize → keep only doc/year
                const parts = clean.split('/').map(p => p.trim());
                if (parts.length < 2) return false;

                const docNum = parseInt(parts[0]);
                const regYear = parseInt(parts[1]);

                if (isNaN(docNum) || isNaN(regYear)) return false;

                return regYear >= 1950 && regYear <= currentYear + 1;
            }

            // ✅ Telangana
            case 'telangana': {
                const regex = /^\d{1,4}\s*\/\s*\d{4}\s*\/\s*[A-Z]{2}-[A-Za-z\s]+$/;

                if (!regex.test(clean)) return false;

                const parts = clean.split('/').map(p => p.trim());
                const docNum = parseInt(parts[0]);
                const regYear = parseInt(parts[1]);

                if (docNum < 1 || docNum > 9999) return false;
                if (regYear < 1950 || regYear > currentYear + 1) return false;

                return true;
            }

            // ✅ Karnataka
            case 'karnataka':
            case 'maharashtra': {
                const regex = /^\d{1,6}\/\d{4}$/;
                return regex.test(clean);
            }

            // ✅ Default fallback
            default: {
                const regex = /^\d{1,6}\/\d{4}$/;
                return regex.test(clean);
            }
        }
    };
    const getValidationErrorMessage = (number, state) => {
        if (!number || !state) return 'Invalid state or number';

        const clean = number.trim();
        const state_lower = state.toLowerCase();
        const currentYear = new Date().getFullYear();

        // ✅ Tamil Nadu
        if (state_lower === 'tamil nadu') {
            const regex = /^\d{1,6}\s*\/\s*\d{4}/;

            if (!regex.test(clean)) {
                return 'Format must be: 1234/2020 or 1234/2020 Chennai';
            }

            const parts = clean.split('/').map(p => p.trim());
            if (parts.length < 2) {
                return 'Invalid format. Example: 1234/2020';
            }

            const regYear = parseInt(parts[1]);

            if (isNaN(regYear) || regYear < 1950 || regYear > currentYear + 1) {
                return `Year must be between 1950 and ${currentYear + 1}`;
            }

            return '';
        }

        // ✅ Telangana
        // if (state_lower === 'telangana') {
        //     const regex = /^\d{1,4}\s*\/\s*\d{4}\s*\/\s*[A-Z]{2}-[A-Za-z\s]+$/;

        //     if (!regex.test(clean)) {
        //         return 'Format must be: 1234 / 2023 / SR-Serilingampally';
        //     }

        //     const parts = clean.split('/').map(p => p.trim());
        //     const docNum = parseInt(parts[0]);
        //     const regYear = parseInt(parts[1]);

        //     if (docNum < 1 || docNum > 9999) {
        //         return 'Document number must be between 1 and 9999';
        //     }

        //     if (regYear < 1950 || regYear > currentYear + 1) {
        //         return `Year must be between 1950 and ${currentYear + 1}`;
        //     }

        //     return '';
        // }

        // ✅ Default
        return `Invalid Registration Document Number for ${state}`;
    };

    if (false) {
        console.log(handleEngineerDocRequestNo, getValidationErrorMessage);
    }

    const validateRegDoc = () => {
        // if (!registrationDocNumber.trim()) {
        //     setRegDocError('Registration Document Number is required');
        //     return false;
        // }
        // if (!validateRegistrationNumber(registrationDocNumber, state)) {
        //     const errorMsg = getValidationErrorMessage(registrationDocNumber, state);
        //     setRegDocError(errorMsg);
        //     return false;
        // } else {
        return true;
    };

    const validateRegistrationDate = (dateVal) => {
        const val = dateVal !== undefined ? dateVal : registrationDate;
        if (!val) {
            setRegistrationDateError('Property Registered Date is required');
            return false;
        }
        const today = new Date().toISOString().split('T')[0];
        if (val > today) {
            setRegistrationDateError('Property Registered Date cannot be in the future');
            return false;
        }
        setRegistrationDateError('');
        return true;
    };

    const handleSubmitMarketValueDetails = async () => {
        const isRegDocValid = validateRegDoc();
        const isRegDateValid = validateRegistrationDate();
        if (!isRegDocValid || !isRegDateValid) return;

        if (!registrationDocNumber || !registrationDate || !marketValueAmount) {
            toast.error('Please fill all required fields');
            return;
        }

        if (!isRegisteredDocSubmittedToDoCity || !isStrictlyConfidential) {
            setMarketValueAgreementError('Please agree to both declarations before submitting.');
            return;
        }
        setMarketValueAgreementError('');

        setMarketValueFileLoader(true);
        try {
            const marketValueDetails = [{
                registrationDocNumber,
                registrationDate,
                marketValue: marketValueAmount,
                currency: marketValueCurrency,
                propertyValue: propertyValueAmount,
                propertyCurrency: propertyValueCurrency,

            }];
            let obj = {
                propertyId: selectedProperty._id,
                FinalMarketValue: JSON.stringify(marketValueDetails), // or send as array
            };
            const updateResponse = await PropertiesService.UpdateProperty(obj);
            await PropertiesService.uploadDoc({
                userId: selectedProperty._id,
                docType: 'Final Market Value',
                docUrl: JSON.stringify(marketValueDetails),
            });
            if (updateResponse.message === "Success") {
                await handlePropertyConvo(updateResponse?.data);
                fetchPropertyData();
                setMarketValueUploadedFile(JSON.stringify(marketValueDetails));

                // Show certificate with the submitted data
                setCertificateData({
                    registrationDocNumber,
                    registrationDate,
                    marketValue: marketValueAmount,
                    currency: marketValueCurrency,
                    ownerName: selectedProperty?.ownerName || selectedProperty?.userName || 'rohitkalyan',
                    propertyAddress: selectedProperty?.address || selectedProperty?.propertyAddress || 'Address not available',
                    expiryDate: selectedProperty?.expiryDate || 'N/A',
                });
                setShowMarketValueCertificate(true);

                // Reset fields
                setRegistrationDocNumber('');
                setRegistrationDate('');
                setMarketValueAmount('');
                setMarketValueCurrency('INR');
                setPropertyValueAmount('');
                setPropertyValueCurrency('INR');
                setRegDocError('');
                setRegistrationDateError('');
                setIsRegisteredDocSubmittedToDoCity(false);
                setIsStrictlyConfidential(false);
                setMarketValueAgreementError('');
            }
        } catch (error) {
            console.error("Submit error:", error);
            toast.error('Error submitting details');
        } finally {
            setMarketValueFileLoader(false);
        }
    };
    const handleUploadUserDocumentFileUpload = async (event) => {
        const file = event.target.files[0];
        const uploadType = uploadRemainingDocsType.docId ?
            uploadRemainingDocsType : window._currentUploadProperty;
        setLoaderForUploadFile(uploadRemainingDocsType)
        if (!file || !uploadType || !uploadType.docId) {
            console.error('Missing file or document information');
            alert('Cannot upload: Missing required information');
            return;
        }

        const errorKey = uploadType.docId || uploadType.Type;
        if (file.size > MAX_UPLOAD_SIZE_BYTES) {
            const message = `File size (${(file.size / (1024 * 1024)).toFixed(1)}MB) exceeds the maximum limit of ${MAX_UPLOAD_SIZE_MB}MB.`;
            setUploadRemainingDocsErrors((prev) => ({ ...prev, [errorKey]: message }));
            toast.error(message);
            if (event.target) event.target.value = "";
            setLoaderForUploadFile({});
            return;
        }
        setUploadRemainingDocsErrors((prev) => ({ ...prev, [errorKey]: "" }));

        const isRegistrationDocUpload = /registration document/i.test(uploadType?.Type || "");
        if (isRegistrationDocUpload) {
            const validRegistrationDoc = await isValidRegistrationDocument(file);
            if (!validRegistrationDoc) {
                alert("Wrong document selected. Registration Document must match key points (minimum 4 keyword matches including at least 1 core keypoint like registered sale deed / sub-registrar / registration number).");
                if (event.target) event.target.value = "";
                setLoaderForUploadFile({});
                return;
            }
        }

        const formData = new FormData();
        formData.append("image", file);

        try {
            let uploadResponse;

            try {
                uploadResponse = await PropertiesService.UploadFiles(formData);
            } catch (networkError) {
                console.error('Network error during upload:', networkError);
                throw new Error(`Network error: ${networkError.message}`);
            }

            if (!uploadResponse || !uploadResponse.Location) {
                console.error('Invalid upload response:', uploadResponse);
                throw new Error('Server did not return a valid file location');
            }
            const newDocUrl = uploadResponse.Location;
            const updatePayload = {
                userId: uploadType.userId,
                docId: uploadType.docId,
                newDocUrl,
            };
            try {
                await PropertiesService.updateDocument(updatePayload);
                if (event.target) {
                    event.target.value = "";
                }
                setUploadRemainingDocsErrors((prev) => ({ ...prev, [errorKey]: "" }));
                refreshDocuments();
            } catch (updateError) {
                console.error('Error updating document:', updateError);
                throw new Error(`Document update failed: ${updateError.message}`);
            }

        } catch (error) {
            console.error('Upload process failed:', error);
            setUploadRemainingDocsErrors((prev) => ({ ...prev, [errorKey]: `Upload failed: ${error.message}` }));
            alert(`Upload failed: ${error.message}`);
        } finally {
            // Clean up
            window._currentUploadProperty = null;
            setUploadRemainingDocsType({});
            setLoaderForUploadFile({});
        }
    };
    const refreshDocuments = async () => {
        try {
            const response = await PropertiesService.getQuestions();
            const docs = await PropertiesService.getDocs({
                userId: selectedProperty?._id
            });

            const filterDocs = docs?.data.filter((x) => x.url === 'No')
            console.log(filterDocs, 'filterDocs')
            const excludedQuestions = [
                "Have you obtained the Market Value Declaration Certificate?",
                "Have you completed the Digital Transfer process/Bank payment details?",
                "Are you interested in applying for a bank loan?"
            ];

            const filterDocuments = filterDocs.filter(
                (x) => !excludedQuestions.includes(x.Type)
            );
            console.log(filterDocuments, 'filterDocuments')
            if (filterDocuments.length === 0) {
                handlePropertyConvo(selectedProperty)
            }
            if (docs?.data?.length > 0) {
                const filteredDocs = docs.data.filter((question) => {
                    return response.data.some(
                        (filterItem) => filterItem.question === question.Type
                    );
                });
                setUserUploadedDocs(filteredDocs.length > 0 ? filteredDocs : []);
            }
        } catch (error) {
            console.error('Error refreshing documents:', error);
        }
    };
    const updateMissingQuestion = async (response, questionData) => {
        const mappedResponse = mapRadioAnswerForBackend(questionData?.Type, response);
        let obj2 = {
            userId: questionData?.userId,
            docId: questionData.docId,
            newDocUrl: mappedResponse,
        };
        await PropertiesService.updateDocument(obj2);
        const responseww = await PropertiesService.getQuestions();
        const docs = await PropertiesService.getDocs({ userId: selectedProperty?._id });
        const filterData = docs.data;
        if (filterData.length > 0) {
            const filteredDocuments = filterData.filter((question) => {
                return responseww.data.some(
                    (filterItem) => filterItem.question === question.Type
                );
            });
            if (filteredDocuments.length > 0) {
                setUserUploadedDocs(filteredDocuments);
            } else {
            }
        }
    }
    const handleUploadRemainingDocs = (property) => {
        setUploadRemainingDocsType(property);
        setUploadRemainingDocsErrors((prev) => ({ ...prev, [property.docId || property.Type]: "" }));

        window._currentUploadProperty = property;
        const fileInput = document.getElementById('registration-upload');

        if (fileInput) {
            fileInput.click();
        } else {
            console.error('File input not found in DOM');
            alert('Error: Upload element not found');
        }
    };
    const assignCivlEngineer = async () => {
        const obj = {
            propertyId: selectedProperty._id,
        };
        const PropertiesServicesss =
            await PropertiesService.verifyPropertyAndAssignCivilEngineer(obj);
        console.log(PropertiesServicesss, 'PropertiesServicesss')
        if (PropertiesServicesss?.message === "Success") {
            let obj2 = {
                firstId: PropertiesServicesss.data._id,
                secondId: PropertiesServicesss.data.assignedCivilEngineer,
            };

            try {
                const findChat = await chatService.findChat(obj2);
                if (!findChat) {
                    if (
                        findChat?.data?.message === "Success" &&
                        findChat.data.data.length > 0
                    ) {
                        setEnableInput(true);

                        const chat = findChat.data.data[0];
                        setChartId(chat);
                        const response = await chatService.getMessagesWithChatId({
                            chartId: chat._id,
                        });

                        if (response?.data?.message === "Success") {
                            setChatMessages(response.data.data);
                        }
                    }
                } else {
                    const createChat = await chatService.createChat({
                        firstId: PropertiesServicesss.data._id,
                        secondId: PropertiesServicesss.data.assignedCivilEngineer,
                    });
                    if (createChat?.data?.message === "Success") {
                        setChartId(createChat._id);
                        const response = await chatService.getMessagesWithChatId({
                            chartId: createChat.data.data._id,
                        });
                        if (response.data.data.length > 0) {
                            if (response?.data?.message === "Success") {
                                const msgData = {
                                    senderId: PropertiesServicesss.data._id,
                                    receiverId: PropertiesServicesss.data.assignedCivilEngineer,
                                    text: "Hello",
                                    chartId: response.data.chartId,
                                    id: Date.now(),
                                };
                                socket.current.emit("sendMessage", msgData);

                                const objmsgData = {
                                    chartId: chartId,
                                    senderId: msgData.senderId,
                                    receiverId: msgData.receiverId,
                                    text: msgData.text,
                                };
                                try {
                                    sendMessageOptimistic(objmsgData, (created) => {
                                        setChatPageLoading(false);
                                        console.log('loader-false-1');
                                        // created already replaced optimistic message by helper
                                    });
                                } catch (error) { console.error(error); }

                                setMessage("");
                                setUploadedFile(null);
                            }
                        } else {
                            if (response?.data?.message === "Success") {
                                const findCivilEngineer =
                                    await civilengineerService.getAllCivilEngs();
                                const filterData = findCivilEngineer.data;
                                const filterCivilEngineer = filterData.filter(
                                    (x) =>
                                        x.civilEng_id ===
                                        PropertiesServicesss.data.assignedCivilEngineer
                                );
                                const object = `You are now connected with ${filterCivilEngineer[0].email}`;
                                messgaeData.push(object);

                                const msgData = {
                                    senderId: PropertiesServicesss.data._id,
                                    receiverId: PropertiesServicesss.data.assignCivlEngineer,
                                    text: `Hi Engineer, I have uploaded all the documents. Can you help me with the further process?`,
                                    chartId: createChat.data.data._id,
                                    id: Date.now(),
                                };
                                socket.current.emit("sendMessage", msgData);

                                const objmsgData = {
                                    chartId: msgData.chartId,
                                    senderId: msgData.senderId,
                                    receiverId: msgData.receiverId,
                                    text: msgData.text,
                                    // files: [],
                                    images: [],
                                };
                                try {
                                    sendMessageOptimistic(objmsgData, (created) => {
                                        setMessage("");
                                        setUploadedFile("");
                                        setUploadedFiles([]);
                                        const msgData2 = {
                                            senderId: PropertiesServicesss.data.assignCivlEngineer,
                                            receiverId: PropertiesServicesss.data._id,
                                            text: `Hello`,
                                            chartId: createChat.data.data._id,
                                            id: Date.now(),
                                        };
                                        setChatPageLoading(false);
                                        console.log('loader-false-3');
                                        handlePropertyConvo(PropertiesServicesss.data);
                                        // send second message optimistically as well
                                        sendMessageOptimistic(msgData2, () => {
                                            handlePropertyConvo(PropertiesServicesss.data);
                                        });
                                    });
                                } catch (error) { console.error(error); }

                                setMessage("");
                                setUploadedFile(null);
                            }
                        }
                    }
                }
            } catch (error) { }
        } else {
            if (
                PropertiesServicesss ===
                "Error: No Civil Engineers found for this pincode"
            ) {
                setChatPageLoading(false)
                console.log('loader-false-5')
                setChatMessages((prevMessages) => [
                    {
                        sender: "bot",
                        text: "No civil engineers were found for this pin code. Please wait—our team will assign a civil engineer.",
                    },
                ]);
            }
        }
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        setPropertyDetails({
            ...PropertyDetails,
            [name]: value,
        });
    };
    const handleSubmitPropertyData = (document) => {
        setUpdatedDocuments(document);
    };
    const handleSubmitOfEditProperty = async () => {
        let obj = {
            propertyId: PropertyDetails._id,
            Declaration: PropertyDetails.Declaration,
            DocumentsFormat: PropertyDetails.DocumentsFormat,
            Payment_Status: PropertyDetails.Payment_Status,
            Status: PropertyDetails.Status,
            address: PropertyDetails.address,
            city: PropertyDetails.city,
            documents: UpdatedDocuments,
            pincode: PropertyDetails.pincode,
            propertyType: PropertyDetails.propertyType,
            region: PropertyDetails.region,
            sale_Aggrement: PropertyDetails.sale_Aggrement,
            state: PropertyDetails.state,
            userId: userDetails.user_id,
            saleDeedUploaded: PropertyDetails.saleDeedUploaded,
            saleDeedSubmissionDate: PropertyDetails.saleDeedSubmissionDate || "",
        };
        console.log(obj, 'handleSubmitOfEditProperty')
        const response = await PropertiesService.UpdateProperty(obj);
        if (response?.message === "Success") {
            setShowEditModal(false);
            toast.success("Property Updated Successfully");
        }
    };
    const onDeleteSaleAgreement = (index) => {
        setPropertyDetails((prevState) => {
            const updatedFiles = [...prevState.sale_Aggrement];
            updatedFiles.splice(index, 1);
            return {
                ...prevState,
                sale_Aggrement: "",
            };
        });
    };
    const onDeleteSaleDeedUploaded = (index) => {
        setPropertyDetails((prevState) => {
            const updatedFiles = [...prevState.saleDeedUploaded];
            updatedFiles.splice(index, 1);
            return {
                ...prevState,
                saleDeedUploaded: "",
            };
        });
    };
    const getRemainingDays = (property) => {
        if (!property) return null;

        const today = new Date();
        const deadline = new Date(property.saleDeedSubmissionDate);
        const timeDiff = deadline - today;

        const daysRemaining = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
        return daysRemaining >= 0 ? daysRemaining : 0;
    };
    const getRemainingDays2 = (submissionDate) => {
        if (!submissionDate) return null;

        const submission = new Date(submissionDate);
        const deadline = new Date(submission);
        deadline.setDate(deadline.getDate() + 45);

        const today = new Date();
        today.setHours(0, 0, 0, 0);
        deadline.setHours(0, 0, 0, 0);

        const timeDiff = deadline - today;
        const daysRemaining = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

        return daysRemaining >= 0 ? daysRemaining : 0;
    };
    const getRemainingDays3 = (submissionDate) => {
        if (!submissionDate) return null;

        const submission = new Date(submissionDate);
        const deadline = new Date(submission);
        deadline.setDate(deadline.getDate() + 60);

        const today = new Date();
        today.setHours(0, 0, 0, 0);
        deadline.setHours(0, 0, 0, 0);

        const timeDiff = deadline - today;
        const daysRemaining = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

        return daysRemaining >= 0 ? daysRemaining : 0;
    };
    const handleEditProperty = async (x) => {
        let obj = {
            propertyId: x._id,
        };
        const response = await PropertiesService.getSignleProperty(obj);

        setPropertyDetails(response.data);
        setPage("page1");
        setShowEditModal(true);
    };
    const onOpenSaleAggrimentUpload = () => {
        triggerFileForSaleAggrementInput();
    };
    const onOpenSaleDeedUploaded = () => {
        triggerFileForSaleDeedUploadedInput();
    };
    const onEditSaleAggriment = () => {
        triggerFileForSaleAggrementInput();
    };
    const onEditSaleDeedUploaded = () => {
        triggerFileForSaleDeedUploadedInput();
    };
    const handleSaleAggrementUpload = async (e) => {
        const file = e.target.files[0];
        if (!file || !validateFileSizeLimit(file)) {
            setSaleAggementloading(false);
            return;
        }
        const formData = new FormData();
        formData.append("image", file);
        setSaleAggementloading(true);
        try {
            const response = await PropertiesService.UploadFiles(formData);
            if (response) {
                setPropertyDetails({
                    ...PropertyDetails,
                    sale_Aggrement: response.Location,
                });
                setSaleAggementloading(false);
            } else {

            }
        } catch { }
    };
    const totalQuestions = QuwstionsList?.length || 0;
    const completedQuestions = QuwstionsList?.filter(q => checkUserUploadedToQuestions2(q)).length || 0;
    const handleSaleDeedUploaded = async (e) => {
        const file = e.target.files[0];
        if (!file || !validateFileSizeLimit(file)) {
            setSaleDeedUploadedloading(false);
            return;
        }
        const formData = new FormData();
        formData.append("image", file);
        setSaleDeedUploadedloading(true);
        try {
            const response = await PropertiesService.UploadFiles(formData);
            if (response) {
                setPropertyDetails({
                    ...PropertyDetails,
                    saleDeedUploaded: response.Location,
                });
                setSaleDeedUploadedloading(false);
            } else {
            }
        } catch { }
    };
    const getAllUsers = async () => {
        const response = await PropertiesService.getdoCityUsers()
        setAllUsers(response.data)
    }
    const getAllCivilEngs = async () => {
        const response = await civilengineerService.getAllCivilEngs()
        console.log(response, 'civilengineerService')
        setAllCivilEngineers(response.data)
    }
    const getUserImage = (propertyId) => {
        const DEFAULT_DUMMY_AVATAR = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='100' height='100'><circle cx='12' cy='12' r='12' fill='%23cbd5e1'/><path d='M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z' fill='%2394a3b8'/></svg>";

        if (!propertyId) return DEFAULT_DUMMY_AVATAR;

        const filterTheUser = AllUsers?.find((x) => x.user_id === propertyId?.userId || x.user_id === propertyId || x._id === propertyId);
        if (filterTheUser?.image && typeof filterTheUser.image === 'string' && filterTheUser.image.trim() !== "" && filterTheUser.image !== "null" && filterTheUser.image !== "undefined") {
            return filterTheUser.image;
        }

        const engId = typeof propertyId === 'string' ? propertyId : (propertyId?.assignedCivilEngineer || propertyId?.civilEng_id);
        const filterEng = AllCivilEngineers?.find((x) => x.civilEng_id === engId || x._id === engId);
        if (filterEng?.image && typeof filterEng.image === 'string' && filterEng.image.trim() !== "" && filterEng.image !== "null" && filterEng.image !== "undefined") {
            return filterEng.image;
        }

        if (UserImage && typeof UserImage === 'string' && UserImage.trim() !== '' && !UserImage.includes('undefined')) {
            return UserImage;
        }

        return DEFAULT_DUMMY_AVATAR;
    };
    const getUserName = (propertyId) => {
        const filterTheUser = AllUsers?.filter((x) => x.user_id === propertyId?.userId);

        if (filterTheUser?.length > 0 && filterTheUser[0]?.name) {
            return filterTheUser[0].name;
        } else {
            const filterTheUser = AllCivilEngineers?.filter((x) => x.civilEng_id === propertyId);
            console.log(AllCivilEngineers, 'filterTheUser')
            if (filterTheUser?.length > 0 && filterTheUser[0]?.name) {
                return filterTheUser[0].name;
            } else {
                return 'John';
            }
        }
    };

    const handleSaledeedDocNames = (e) => {
        const { name, value } = e.target;

        if (name === 'officerNumber') {
            const onlyNums = value.replace(/[^0-9]/g, '');

            if (onlyNums.length <= 10) {
                setHandleSaledeedFields(prev => ({
                    ...prev,
                    [name]: onlyNums
                }));
            }
            return;
        }
        setHandleSaledeedFields(prev => ({
            ...prev,
            [name]: value
        }));
    };
    const handleUploadSaledeedDocument = async () => {

        if (!SaleDeedUploadedFile) {
            setErrorMessagesForSaledeedModel("Please upload the Sale Deed document.");
            return;
        }
        const requiredFields = [
            { label: "Document Number", value: HandleSaledeedFields.documentNumber },
            { label: "Document Officer", value: HandleSaledeedFields.documentOfficer },
            { label: "Issued By Designation", value: HandleSaledeedFields.issuedByDesignation },
        ];
        for (const field of requiredFields) {
            if (!field.value || field.value.trim() === "") {
                setErrorMessagesForSaledeedModel(`${field.label} is required.`);
                return;
            }
        }
        const officerNumber = (HandleSaledeedFields.officerNumber || "").trim();
        if (officerNumber && officerNumber.length !== 10) {
            setErrorMessagesForSaledeedModel("Please enter a valid 10-digit Officer Number or leave it empty.");
            return;
        }
        const propertyState = selectedProperty?.state || selectedProperty?.State || PropertyDetails?.state || PropertyDetails?.State || "";
        const documentNumber = (HandleSaledeedFields.documentNumber || "").trim();
        if (!propertyState) {
            setErrorMessagesForSaledeedModel("Property state is required to validate the document number.");
            return;
        }
        // if (!validateRegistrationNumber(documentNumber, propertyState)) {
        //     setErrorMessagesForSaledeedModel(`Please enter a valid Document Number for ${propertyState}.`);
        //     return;
        // }
        setIsSubmittingSaledeed(true);
        setErrorMessagesForSaledeedModel("");

        try {
            const properyObject = { propertyId: selectedProperty?._id };
            const getProperty = await PropertiesService.getSignleProperty(properyObject);
            const findChat = await chatService.findChat({
                firstId: selectedProperty?._id,
                secondId: getProperty?.data?.assignedCivilEngineer,
            });
            const chat = findChat?.data?.data[0];
            const docs = await PropertiesService.getDocs({
                userId: selectedProperty?._id
            });

            await PropertiesService.uploadDoc({
                userId: selectedProperty?._id,
                docType: "saledeedDocument",
                docUrl: SaleDeedUploadedFile,
                fields: HandleSaledeedFields,
                verificationStatus: "Pending",
            });

            await PropertiesService.UpdateProperty({
                ...selectedProperty,
                propertyId: selectedProperty._id,
                saleDeedUploaded: SaleDeedUploadedFile,
                saleDeedFields: HandleSaledeedFields,
                saledeedSubmittedDate: new Date().toISOString().split("T")[0],
                userId: userDetails.user_id,
            });
            const objss = {
                documentNumber: HandleSaledeedFields.documentNumber,
                documentOfficer: HandleSaledeedFields.documentOfficer,
                issuedByDesignation: HandleSaledeedFields.issuedByDesignation,
                officerNumber: HandleSaledeedFields.officerNumber,
                preparedByRole: HandleSaledeedFields.preparedByRole,
                preparedByName: HandleSaledeedFields.preparedByName,

                // backward compatibility
                issuedByName: HandleSaledeedFields.documentOfficer,
                PhoneNumber: HandleSaledeedFields.officerNumber,
            };
            const msgData = {
                senderId: selectedProperty._id,
                receiverId: selectedProperty?.assignedCivilEngineer,
                text: SaleDeedUploadedFile,
                chartId: chat._id,
                id: Date.now(),
                files: [],
                fields: [objss],
                verificationStatus: 'Pending'
            };
            socket.current.emit("sendMessage", msgData);
            const createdMessage = await chatService.createMessage({ ...msgData, images: [] });
            if (createdMessage?.data?.message === "Success") {
                setChatMessages(prev => [...prev, createdMessage.data.data]);
                socket.current.emit("addNewUser", selectedProperty?._id);
                setUserQuestion("");
                setHandleSaledeedFields([]);
                setMessage("");
                setopenUploadSaledeedModel(false);
            }
            setSaleDeedUploadedFile('');
        } catch (error) {
            console.error("Error submitting Sale Deed document:", error);
            setErrorMessagesForSaledeedModel("Failed to submit Sale Deed document. Please try again.");
        } finally {
            setIsSubmittingSaledeed(false);
        }
    };
    const getProgressWidth = () => {
        if (selectedProperty?.Status === 'running') {
            if (!selectedProperty?.assignedCivilEngineer) {
                return 16.67;
            }
        } else {
            if (!selectedProperty?.resolvedBy) {
                return 16.67;
            }
        }
        if (!selectedProperty?.saledeedVerified) {
            return 33.33;
        }
        if (!selectedProperty?.registrationDocument) {
            return 50.0;
        }
        if (!selectedProperty?.FinalMarketValue) {
            return 66.67;
        }
        return 100.0;
    };
    const DisplaySaledeedButton = (messages) => {
        const filterData = messages.filter((x) =>
            (x?.text || "").toString().toLowerCase().includes(SALE_DEED_ACCEPTED_KEYWORD)
        )
        if (filterData.length > 0) {
            return true
        } else {
            const filterData = messages.filter((x) => x.text === 'To complete the process, upload the sale deed draft')
            if (filterData.length > 0) {
                return false
            } else {
                return true
            }

        }
    }
    const handleCloseSaledeedModal = () => {
        setopenUploadSaledeedModel(false);
        setIsSubmittingSaledeed(false);
        setErrorMessagesForSaledeedModel("");
    };
    const DisplaySaledeedFieldsModel = () => {
        const accessForUploadSaledeed = chatMessages.some(x => x.verificationStatus === 'Pending') ? 'yes' : 'no';
        if (accessForUploadSaledeed === 'yes') {
            setopenDocUploadErrorInChat(true)
            setTimeout(() => {
                setopenDocUploadErrorInChat(false)
            }, 2000)
        } else {
            setHasManuallyClosedSaledeedPopup(false);
            setopenUploadSaledeedModel(true)
        }
    }
    const submitHowDidGetInTouchOption = async (value) => {
        if (!currentQuestion) return;
        if (SendMessageLoad) return;

        setSendMessageLoad(true);
        try {
            await PropertiesService.uploadDoc({
                userId: selectedProperty?._id,
                docType: currentQuestion?.question,
                docUrl: value,
            });

            const docs = await PropertiesService.getDocs({ userId: selectedProperty?._id });
            setUserUploadedDocs(docs.data);

            const properyObject = { propertyId: selectedProperty?._id };
            const getProperty = await PropertiesService.getSignleProperty(properyObject);
            const findChat = await chatService.findChat({
                firstId: selectedProperty?._id,
                secondId: getProperty?.data?.assignedCivilEngineer,
            });
            const chat = findChat?.data?.data?.[0];

            if (chat?._id) {
                const msgData = {
                    senderId: selectedProperty?._id,
                    receiverId: getProperty?.data?.assignedCivilEngineer,
                    text: value,
                    chartId: chat._id,
                    id: Date.now(),
                    files: [],
                };
                sendMessageOptimistic(msgData);
            } else {
                setChatMessages((prevMessages) => [
                    ...prevMessages,
                    { sender: "user", text: value },
                ]);
            }

            setSelectedRadioForChatBrokerOrRelative("");
            pushNextQuestionAfterInlineAnswer();
        } catch (error) {
            console.error("Failed to submit contact source option", error);
            toast.error("Something went wrong. Please try again.");
        } finally {
            setSendMessageLoad(false);
        }
    };

    const handleSubmitHowdidhegetintouchwiththeproperty = async (response) => {
        setSelectedRadioForChatBrokerOrRelative(response);

        // For "Other", wait for user to type custom message and send manually.
        if (response === "other") {
            setUserQuestion("");
            return;
        }

        // Broker / Relative should send immediately.
        await submitHowDidGetInTouchOption(response);
    }
    const hasEngineerRegistrationRequestInChat = chatMessages.some((msg) => {
        const text = (msg?.text || "").toString().toLowerCase().trim();
        return (
            text.includes("upload registration document") ||
            text.includes("upload the registration document")
        );
    });
    const hasSaleDeedAcceptedMessageInChat = chatMessages.some((msg) => {
        const text = (msg?.text || "").toString().toLowerCase().trim();
        return text.includes(SALE_DEED_ACCEPTED_KEYWORD);
    });
    const shouldShowEngineerRegistrationUploadCard =
        selectedProperty?.saledeedVerified === true &&
        selectedProperty?.assignedCivilEngineer &&
        selectedProperty?.registrationDocument === "" &&
        (engineerDocRequest?.type === "Registration Document" || hasEngineerRegistrationRequestInChat || hasSaleDeedAcceptedMessageInChat);
    const isInlineRegistrationUploadingForCurrentProperty =
        inlineRegistrationUploadLoading && inlineRegistrationUploadingPropertyId === selectedProperty?._id;

    useEffect(() => {
        if (!(showSaleDeedSuccessCard || shouldShowEngineerRegistrationUploadCard)) return;

        const timer = setTimeout(() => {
            registrationUploadCardRef.current?.scrollIntoView({
                behavior: "smooth",
                block: "center",
            });
        }, 180);

        return () => clearTimeout(timer);
    }, [showSaleDeedSuccessCard, shouldShowEngineerRegistrationUploadCard]);

    const hasSaledeedRequest = chatMessages ? chatMessages.some(
        (msg) => (msg.text || "").toString().toLowerCase().includes("to complete the process, upload the sale deed draft")
    ) : false;
    const hasPendingSaledeed = chatMessages ? chatMessages.some(
        (msg) => msg.senderId === selectedProperty?._id && msg.verificationStatus === 'Pending'
    ) : false;
    const hasRejectedSaledeed = chatMessages ? chatMessages.some(
        (msg) => msg.senderId === selectedProperty?._id && (msg.verificationStatus === 'Rejected' || msg.rejected === true)
    ) : false;
    const isVerified = selectedProperty?.saledeedVerified === true;

    const isSaleDeedExpired = selectedProperty?.saleDeedSubmissionDate &&
        selectedProperty?.assignedCivilEngineer &&
        selectedProperty?.saleDeedUploaded === "" &&
        getRemainingDays(selectedProperty) === 0;

    const shouldShowSaledeedUploadPrompt = (hasSaledeedRequest || hasRejectedSaledeed) && !hasPendingSaledeed && !isVerified && !hasManuallyClosedSaledeedPopup && !isSaleDeedExpired;

    // if (propertyListLoading) {
    //     return (
    //         <div className="property-chat-container responsive-wrapper" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '80vh' }}>
    //             <div className="property-chat-full-loader">
    //                 <div className="setInCenter">
    //                     <FetchingCard message="" sub="Loading property list..." />
    //                 </div>
    //             </div>
    //         </div>
    //     );
    // }

    return (
        <div className="property-chat-container responsive-wrapper">
            <MarketValueCertificate
                isOpen={showMarketValueCertificate}
                onClose={() => setShowMarketValueCertificate(false)}
                certificateData={certificateData}
            />

            <MarketValueCertificateModal
                isOpen={showMarketValueCertificateModal}
                onClose={() => setShowMarketValueCertificateModal(false)}
                certificateData={certificateData}
                onViewFullCertificate={() => {
                    setShowMarketValueCertificateModal(false);
                    setShowMarketValueCertificate(true);
                }}
            />

            {!showEditModal ?
                <>
                    <div className={`property-chat-list ${isMobile && !ShowPropertyList ? 'mobile-hidden' : ''}`}>

                        <div className="property-chat-list-header">
                            <h6>
                                Properties
                                {isMobile && ShowPropertyList && (
                                    <span className="close-icon" onClick={() => setShowPropertyList(false)}> × </span>
                                )}
                            </h6>
                        </div>

                        <div className="property-sidebar-search-filter-container">
                            <div className="d-flex align-items-center gap-2 p-3 pb-1 mb-2" style={{ boxSizing: 'border-box' }}>
                                <input
                                    type='search'
                                    className='form-control searchForProperty'
                                    value={searchTerm}
                                    onChange={handleSearch}
                                    placeholder='Search for a property'
                                    style={{
                                        flex: 1,
                                        margin: '0',
                                        height: '40px',
                                        minHeight: '40px',
                                        maxHeight: '40px',
                                        borderRadius: '10px',
                                        boxSizing: 'border-box'
                                    }}
                                />
                                <div className="position-relative" style={{ height: '40px' }}>
                                    <button
                                        className={`btn filter-icon-btn ${selectedStatusFilter !== 'All' ? 'active' : ''}`}
                                        onClick={() => setShowStatusFilterDropdown(!showStatusFilterDropdown)}
                                        title="Filter by Status"
                                        style={{
                                            padding: '0',
                                            borderRadius: '10px',
                                            border: '1px solid rgba(13, 27, 42, 0.15)',
                                            backgroundColor: '#ffffff',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            cursor: 'pointer',
                                            transition: 'all 0.2s ease',
                                            height: '40px',
                                            minHeight: '40px',
                                            maxHeight: '40px',
                                            width: '40px',
                                            margin: '0',
                                            boxSizing: 'border-box'
                                        }}
                                    >
                                        <Filter size={18} style={{ color: selectedStatusFilter !== 'All' ? 'var(--color-turquoise-teal)' : '#495057' }} />
                                    </button>

                                    {showStatusFilterDropdown && (
                                        <div className="status-filter-dropdown" style={{
                                            position: 'absolute',
                                            top: '100%',
                                            right: '0',
                                            marginTop: '8px',
                                            backgroundColor: '#ffffff',
                                            border: '1px solid rgba(13, 27, 42, 0.1)',
                                            borderRadius: '8px',
                                            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                            zIndex: 1050,
                                            minWidth: '180px',
                                            padding: '6px 0'
                                        }}>
                                            <div className="dropdown-header-title" style={{
                                                fontSize: '10px',
                                                textTransform: 'uppercase',
                                                color: '#888',
                                                padding: '6px 12px 2px 12px',
                                                fontWeight: '600'
                                            }}>
                                                Status Filter
                                            </div>
                                            {["All", "Pending", "In Process", "Cleared", "Market Value Declared"].map((status) => (
                                                <div
                                                    key={status}
                                                    className={`dropdown-status-item ${selectedStatusFilter === status ? 'active' : ''}`}
                                                    onClick={() => handleStatusFilterSelect(status)}
                                                    style={{
                                                        padding: '8px 12px',
                                                        fontSize: '12px',
                                                        cursor: 'pointer',
                                                        color: selectedStatusFilter === status ? 'var(--color-turquoise-teal)' : 'var(--color-oxford-blue)',
                                                        backgroundColor: selectedStatusFilter === status ? 'rgba(31, 182, 166, 0.08)' : 'transparent',
                                                        fontWeight: selectedStatusFilter === status ? '600' : 'normal',
                                                        transition: 'all 0.15s ease'
                                                    }}
                                                >
                                                    {status}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Horizontal scrollable states */}
                            <div className="property-status-filters px-3">
                                <div className="status-filters-scroll-container d-flex gap-2">
                                    {getUniqueStates().map((state) => (
                                        <button
                                            key={state}
                                            className={`status-filter-btn ${selectedStateFilter === state ? 'active' : ''}`}
                                            onClick={() => handleStateFilterSelect(state)}
                                        >
                                            {state}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </div>

                        <div className="property-chat-items">

                            {aggregateViewMode ? (
                                <div className="agg-tree">
                                    {propertyList.length === 0 ? (
                                        <p className="agg-empty">No properties to group.</p>
                                    ) : (
                                        Object.entries(buildAggregation(propertyList)).map(([state, cities]) => (
                                            <div key={state} className="agg-state-block">
                                                <div
                                                    className="agg-state-row"
                                                    onClick={() => toggleAggState(state)}
                                                >
                                                    <span className="agg-chevron">{expandedStates[state] ? '▾' : '▸'}</span>
                                                    <span className="agg-label">{state}</span>
                                                    <span className="agg-badge">
                                                        {Object.values(cities).reduce((s, pins) => s + Object.values(pins).reduce((a, arr) => a + arr.length, 0), 0)}
                                                    </span>
                                                </div>
                                                {expandedStates[state] && Object.entries(cities).map(([city, pincodes]) => {
                                                    const cityKey = `${state}__${city}`;
                                                    return (
                                                        <div key={city} className="agg-city-block">
                                                            <div
                                                                className="agg-city-row"
                                                                onClick={() => toggleAggCity(cityKey)}
                                                            >
                                                                <span className="agg-chevron">{expandedCities[cityKey] ? '▾' : '▸'}</span>
                                                                <span className="agg-label">🏙 {city}</span>
                                                                <span className="agg-badge">
                                                                    {Object.values(pincodes).reduce((a, arr) => a + arr.length, 0)}
                                                                </span>
                                                            </div>
                                                            {expandedCities[cityKey] && Object.entries(pincodes).map(([pin, props]) => {
                                                                const pinKey = `${cityKey}__${pin}`;
                                                                return (
                                                                    <div key={pin} className="agg-pin-block">
                                                                        <div
                                                                            className="agg-pin-row"
                                                                            onClick={() => toggleAggPincode(pinKey)}
                                                                        >
                                                                            <span className="agg-chevron">{expandedPincodes[pinKey] ? '▾' : '▸'}</span>
                                                                            <span className="agg-label">📍 {pin}</span>
                                                                            <span className="agg-badge">{props.length}</span>
                                                                        </div>
                                                                        {expandedPincodes[pinKey] && (
                                                                            <div className="agg-prop-list">
                                                                                {props.map((p) => (
                                                                                    <div
                                                                                        key={p._id}
                                                                                        onClick={() => handlePropertyConvo(p)}
                                                                                        className={`property-chat-item ${p._id === selectedProperty?._id ? 'property-chat-unread' : ''}`}
                                                                                    >
                                                                                        <div className="property-chat-avatar">
                                                                                            <div className={`property-icon-circle ${p.FinalMarketValue !== "" ? "icon-active" : "icon-inactive"}`}>
                                                                                                <MapPinHouseIcon size={20} />
                                                                                            </div>
                                                                                        </div>

                                                                                        <div className="property-chat-info">
                                                                                            <div className="property-chat-name ellipsis-text" title={p.address}>
                                                                                                {p.address}
                                                                                            </div>

                                                                                            <div className="property-status-messages mt-1">

                                                                                                {p?.saleDeedSubmissionDate && p?.assignedCivilEngineer && p?.saleDeedUploaded === "" && (
                                                                                                    getRemainingDays(p) > 0 ? (
                                                                                                        <span className="status-warning text-orange">
                                                                                                            {getRemainingDays(p)} days left for Sale Deed
                                                                                                        </span>
                                                                                                    ) : (
                                                                                                        <span className="status-expired text-danger">
                                                                                                            ❌ Sale Deed Time Expired
                                                                                                        </span>
                                                                                                    )
                                                                                                )}

                                                                                                {p?.registrationDocument === "" && p?.saleDeedUploaded !== "" && (
                                                                                                    getRemainingDays2(p?.saledeedSubmittedDate) > 0 ? (
                                                                                                        <span className="status-warning text-orange">
                                                                                                            {getRemainingDays2(p?.saledeedSubmittedDate)} days left for Registration
                                                                                                        </span>
                                                                                                    ) : (
                                                                                                        <span className="status-expired text-danger">
                                                                                                            ❌ Registration Time Expired
                                                                                                        </span>
                                                                                                    )
                                                                                                )}

                                                                                                {p?.registrationDocument !== "" && p?.saleDeedUploaded !== "" && p?.FinalMarketValue === "" && (
                                                                                                    getRemainingDays3(p?.registrationDocumentSubmittedDate) > 0 ? (
                                                                                                        <span className="status-warning text-orange">
                                                                                                            {getRemainingDays3(p?.registrationDocumentSubmittedDate)} days left for Market Value
                                                                                                        </span>
                                                                                                    ) : (
                                                                                                        <span className="status-expired text-danger">
                                                                                                            ❌ Market Value Time Expired
                                                                                                        </span>
                                                                                                    )
                                                                                                )}

                                                                                                {p?.FinalMarketValue !== "" && (
                                                                                                    <span className="remaining-days3 text-success">
                                                                                                        ✓ Completed
                                                                                                    </span>
                                                                                                )}
                                                                                            </div>
                                                                                        </div>

                                                                                        <div className="property-chat-meta">
                                                                                            <div className="property-chat-message-pincode mb-1">
                                                                                                {p.pincode}
                                                                                            </div>
                                                                                            {p.engineerMessageCount > 0 && (
                                                                                                <div className="messageCount">
                                                                                                    {p.engineerMessageCount}
                                                                                                </div>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        ))
                                    )}
                                </div>
                            ) : (

                                <>{filteredProperties.length > 0 ? filteredProperties.map((item) => (
                                    <div
                                        key={item._id}
                                        onClick={() => handlePropertyConvo(item)}
                                        className={`property-chat-item ${item._id === selectedProperty?._id ? 'property-chat-unread' : ''}`}
                                    >
                                        <div className="property-chat-avatar">
                                            <div className={`property-icon-circle ${item.FinalMarketValue !== "" ? "icon-active" : "icon-inactive"}`}>
                                                <MapPinHouseIcon size={20} />
                                            </div>
                                        </div>

                                        <div className="property-chat-info">
                                            <div className="property-chat-name ellipsis-text" title={item.address}>
                                                {item.address}
                                            </div>

                                            <div className="property-status-messages mt-1">

                                                {item?.saleDeedSubmissionDate && item?.assignedCivilEngineer && item?.saleDeedUploaded === "" && (
                                                    getRemainingDays(item) > 0 ? (
                                                        <span className="status-warning text-orange">
                                                            {getRemainingDays(item)} days left for Sale Deed
                                                        </span>
                                                    ) : (
                                                        <span className="status-expired text-danger">
                                                            ❌ Sale Deed Time Expired
                                                        </span>
                                                    )
                                                )}

                                                {item?.registrationDocument === "" && item?.saleDeedUploaded !== "" && (
                                                    getRemainingDays2(item?.saledeedSubmittedDate) > 0 ? (
                                                        <span className="status-warning text-orange">
                                                            {getRemainingDays2(item?.saledeedSubmittedDate)} days left for Registration
                                                        </span>
                                                    ) : (
                                                        <span className="status-expired text-danger">
                                                            ❌ Registration Time Expired
                                                        </span>
                                                    )
                                                )}

                                                {item?.registrationDocument !== "" && item?.saleDeedUploaded !== "" && item?.FinalMarketValue === "" && (
                                                    getRemainingDays3(item?.registrationDocumentSubmittedDate) > 0 ? (
                                                        <span className="status-warning text-orange">
                                                            {getRemainingDays3(item?.registrationDocumentSubmittedDate)} days left for Market Value
                                                        </span>
                                                    ) : (
                                                        <span className="status-expired text-danger">
                                                            ❌ Market Value Time Expired
                                                        </span>
                                                    )
                                                )}

                                                {item?.FinalMarketValue !== "" && (
                                                    <span className="remaining-days3 text-success">
                                                        ✓ Completed
                                                    </span>
                                                )}
                                            </div>
                                        </div>

                                        <div className="property-chat-meta">
                                            <div className="property-chat-message-pincode mb-1">
                                                {item.pincode}
                                            </div>
                                            {item.engineerMessageCount > 0 && (
                                                <div className="messageCount">
                                                    {item.engineerMessageCount}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )) : (
                                    <div className="p-4 text-center">
                                        <p className="text-muted small">No properties found.</p>
                                        <a href="/" className="text-primary small text-decoration-underline">
                                            Click here to request a property.
                                        </a>
                                    </div>
                                )}</>
                            )}
                        </div>
                    </div>
                    {/* Main Chat Area */}
                    <div className={`property-chat-main ${isMobile && ShowPropertyList ? 'mobile-hidden' : ''}`}>
                        {!showRightPanel && selectedProperty && (
                            <button
                                className="chat-panel-toggle-fab"
                                onClick={() => {
                                    setShowRightPanel(true);
                                    setShowPropertyList(false);
                                }}
                                aria-label="Open Onboarding Panel"
                                title="Open Panel"
                            >
                                <ChevronLeft size={16} />
                                {getMissingDocsCount() > 0 && (
                                    <span className="pending-docs-dot"></span>
                                )}
                            </button>
                        )}
                        <div className="property-chat-header">
                            {selectedProperty &&
                                <div className="progress-line" style={{ display: 'flex', width: '100%' }}>
                                    <div
                                        className="progress-chunk"
                                        style={{
                                            width: `${getProgressWidth()}%`,
                                            backgroundColor: 'var(--color-turquoise-teal)',
                                            transition: 'width 0.4s ease, background-color 0.3s ease',
                                            height: '4px'
                                        }}
                                    />
                                </div>
                            }
                            <div className="property-chat-header-info">
                                {/* Chat List */}
                                {isMobile && !selectedProperty && (
                                    <div className="mobile-menu-trigger" onClick={showPropertyListView}>
                                        <Menu size={20} />
                                        {/* <span>Menu</span> */}
                                    </div>
                                )}
                                {isMobile && selectedProperty && (
                                    <div className="mobile-header-nav">
                                        <button
                                            className="mobile-back-btn"
                                            onClick={showPropertyListView}
                                            aria-label="Back to properties"
                                        >
                                            <Menu size={20} />
                                        </button>
                                    </div>
                                )}

                                {/* Desktop menu icon (optional, for consistency) */}
                                {/* {!isMobile && (
                            <button
                                className="desktop-menu-btn"
                                onClick={() => setShowPropertyList(!ShowPropertyList)}
                                aria-label="Toggle properties list"
                            >
                                <Menu size={20} />
                            </button>
                        )} */}
                                {selectedProperty && (
                                    <div className={`property-chat-header-main-info ${isMobile ? 'mobile-compact' : ''}`}>
                                        <div className="property-chat-header-avatar">
                                            <img
                                                src={getUserImage(selectedProperty)}
                                                alt="Avatar"
                                                onError={(e) => {
                                                    e.target.src = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='100' height='100'><circle cx='12' cy='12' r='12' fill='%23cbd5e1'/><path d='M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z' fill='%2394a3b8'/></svg>";
                                                }}
                                            />
                                        </div>
                                        <div className="property-chat-header-text">
                                            <h3>{selectedProperty?.pincode}</h3>
                                            <span className="address-text">{selectedProperty?.address}</span>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className="property-chat-header-actions-wrap" style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                <div className="property-chat-header-actions">
                                    {(() => {
                                        const requiredDocs = [
                                            "⁠link documents explaining the title deeds?",
                                            "⁠Revenue department links?",
                                            "Advance receipt or any other proof of purchase?",
                                            "Property ownership details like previous Sale deed registered with seller?",
                                        ];
                                        const hasAllDocs = requiredDocs.every((reqType) =>
                                            UserUploadedDocs?.some(
                                                (doc) =>
                                                    doc.Type?.trim() === reqType && (doc.url || doc.value) !== "No"
                                            )
                                        );
                                        const isSaleDeedExpired = selectedProperty?.saleDeedSubmissionDate &&
                                            selectedProperty?.assignedCivilEngineer &&
                                            selectedProperty?.saleDeedUploaded === "" &&
                                            getRemainingDays(selectedProperty) === 0;

                                        const hasPendingSaledeed = chatMessages ? chatMessages.some(
                                            (msg) => msg.senderId === selectedProperty?._id && msg.verificationStatus === 'Pending'
                                        ) : false;

                                        return hasAllDocs ? (
                                            hasManuallyClosedSaledeedPopup && DisplaySaledeedButton(chatMessages) === false && !hasPendingSaledeed && selectedProperty?.assignedCivilEngineer && !selectedProperty?.saledeedVerified && !isSaleDeedExpired ? <button className='btn uploadSaledeedButton' onClick={() => DisplaySaledeedFieldsModel()}>Upload sale deed</button> : null
                                        ) : null;
                                    })()}
                                </div>
                                {selectedProperty && (
                                    <div
                                        className="chat-header-nav-actions"
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '12px',
                                            marginRight: !showRightPanel ? '36px' : '10px',
                                            transition: 'margin-right 0.3s ease'
                                        }}
                                    >
                                        {selectedProperty?.Payment_Status === true && (
                                            <button
                                                className="chat-header-edit-btn"
                                                onClick={() => handleEditProperty(selectedProperty)}
                                                aria-label="Edit Property"
                                                style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--color-oxford-blue)', display: 'flex', alignItems: 'center', padding: '6px', }}
                                            >
                                                <Pencil size={20} />
                                            </button>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="property-chat-messages" style={{ position: 'relative', overflowY: shouldShowSaledeedUploadPrompt ? 'hidden' : 'auto' }}>
                            {ChatPageLoading ? (
                                <div className="setInCenter" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%' }}>
                                    <FetchingCard message="" sub="Fetching details" />
                                </div>
                            ) : (
                                <>
                                    {selectedProperty?.Payment_Status === false ? (
                                        <div className="payment-body">
                                            <div className="payment-messages">
                                                <>
                                                    <div className="d-flex flex-column align-items-center">
                                                        {PaymentScreen === false ? <>
                                                            <PaymentPreviewCard
                                                                baseAmount={18000}
                                                                gstRate={18}
                                                                servicePoints={[
                                                                    "Clearance support for property buying",
                                                                    "Master plan education for future city growth and development",
                                                                    "Civil engineer guidance for investment alignment",
                                                                    "Bank-loan support for safety and security",
                                                                    "Future access support for insurance, government departments, and nationalized banks",
                                                                    "Support for title guarantee and property insurance readiness",
                                                                ]}
                                                            />
                                                            <button className='btn btn-paymentButton mt-3' onClick={() => showPaymentScreen(true)}>Continue to pay</button>
                                                        </> :
                                                            <Product
                                                                amount={18000}
                                                                gstRate={18}
                                                                currency="INR"
                                                                paymentFor="requestForProperty"
                                                                userId={selectedProperty?.userId}
                                                                onPaymentStatusChange={setPaymentStatus}
                                                                paymentRequestId={selectedProperty}
                                                                paymentStatus={paymentStatus}
                                                                SuccessStatus="AfterRequest"
                                                                handlePropertyConvo={() => handlePropertyConvo(selectedProperty)}
                                                            />}
                                                    </div>
                                                </>
                                            </div>
                                        </div>
                                    ) : (
                                        <>
                                            {selectedProperty?.saleDeedSubmissionDate &&
                                                selectedProperty?.assignedCivilEngineer &&
                                                selectedProperty?.saleDeedUploaded === "" &&
                                                getRemainingDays(selectedProperty) === 0 ? (
                                                <>
                                                    <div className="chat-body">
                                                        <div className="row">
                                                            <div className="col-md-6 justify-content-center">
                                                                <div className="setCenterTheMessage">
                                                                    <div className='bg-color-card'>
                                                                        {handleRerequest(
                                                                            selectedProperty?.property_Key, 'saledeed document'
                                                                        ) === true ? (
                                                                            <>
                                                                                <p>
                                                                                    Your time has passed to submit
                                                                                    your <strong>sale deed document</strong>.
                                                                                    <br />
                                                                                    If you would like to extend your
                                                                                    submission deadline for the <strong>sale deed</strong>,{" "}
                                                                                    <br />
                                                                                    please raise a request with the <strong>admin</strong>.
                                                                                </p>
                                                                                <button
                                                                                    className="btn btn-info"
                                                                                    onClick={() => RaiseRequestModelWithRequestForText('saledeed document')}>
                                                                                    Raise a request
                                                                                </button>
                                                                            </>
                                                                        ) : (
                                                                            <p>Your request has been submitted successfully. The admin will review your request and extend your <strong>sale deed submission date</strong>. Please wait until the <strong>admin</strong> completes the extension process.</p>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            ) :
                                                (
                                                    (selectedProperty?.registrationDocument === "" && getRemainingDays2(selectedProperty?.saledeedSubmittedDate) === 0) ?
                                                        handleRerequest(selectedProperty?.property_Key, 'Registration Document') === true ? (
                                                            <div
                                                                className="success-message-box"
                                                                onClick={handleBoxClick}
                                                            >
                                                                <p>
                                                                    Your time has passed to submit your <strong>registration document</strong>.
                                                                    <br />
                                                                    If you would like to extend your submission deadline for the <strong>registration document</strong>,{" "}
                                                                    please raise a request with the admin.
                                                                </p>
                                                                <button
                                                                    className="btn btn-info"
                                                                    onClick={() => RaiseRequestModelWithRequestForText('Registration Document')}
                                                                >
                                                                    Raise a request
                                                                </button>
                                                            </div>
                                                        ) : (
                                                            <p className="success-message-box">
                                                                Your request has been submitted successfully. The admin will review your request and extend your <strong>registration document</strong> submission date. Please wait until the admin completes the extension process.
                                                            </p>
                                                        )
                                                        :
                                                        (selectedProperty?.registrationDocument !== "" && selectedProperty?.FinalMarketValue === "" && getRemainingDays3(selectedProperty?.registrationDocumentSubmittedDate) === 0) ?
                                                            handleRerequest(selectedProperty?.property_Key, 'Market Value') === true ? (
                                                                <div
                                                                    className="success-message-box"
                                                                    onClick={handleBoxClick}
                                                                >
                                                                    <p>
                                                                        Your time has passed to submit your <strong>Market Value details</strong>.
                                                                        <br />
                                                                        If you would like to extend your submission deadline for the <strong>Market Value details</strong>,{" "}
                                                                        please raise a request with the admin.
                                                                    </p>
                                                                    <button
                                                                        className="btn btn-info"
                                                                        onClick={() => RaiseRequestModelWithRequestForText('Market Value')}
                                                                    >
                                                                        Raise a request
                                                                    </button>
                                                                </div>
                                                            ) : (
                                                                <p className="success-message-box">
                                                                    Your request has been submitted successfully. The admin will review your request and extend your <strong>Market Value details</strong> submission date. Please wait until the admin completes the extension process.
                                                                </p>
                                                            )
                                                            :
                                                            <>

                                                                {AssignedCivilEngineerData?.name ? (
                                                                    <>
                                                                        {(() => {
                                                                            const requiredDocs = [
                                                                                "⁠link documents explaining the title deeds?",
                                                                                "⁠Revenue department links?",
                                                                                "Advance receipt or any other proof of purchase?",
                                                                                "Property ownership details like previous Sale deed registered with seller?",
                                                                            ];
                                                                            const missingDocs = requiredDocs.filter(
                                                                                (reqType) =>
                                                                                    !UserUploadedDocs?.some(
                                                                                        (doc) => doc.Type?.trim() === reqType && (doc.url || doc.value) !== "No"
                                                                                    )
                                                                            );

                                                                            return missingDocs.length > 0 && (
                                                                                <div>
                                                                                    <p
                                                                                        className="error-text"
                                                                                        style={{ display: "flex", alignItems: "flex-start", color: "var(--color-oxford-blue)" }}
                                                                                    >
                                                                                        <h5 className="status-box status-info" style={{ fontSize: "12px", margin: 0 }}>
                                                                                            ❌ <span className='missingfilestext'>Documents incomplete. Please upload the missing files to proceed with the sale deed document:</span><br />
                                                                                            <br />
                                                                                            {missingDocs.map((doc, index) => (
                                                                                                <span key={index} style={{ color: 'var(--color-oxford-blue)' }}>
                                                                                                    {index + 1}. {doc} &nbsp;&nbsp;&nbsp;<br />
                                                                                                </span>
                                                                                            ))}
                                                                                        </h5>

                                                                                        <svg
                                                                                            className="error-arrow-shake"
                                                                                            width="24"
                                                                                            height="24"
                                                                                            viewBox="0 0 24 24"
                                                                                            fill="none"
                                                                                            style={{ marginLeft: "8px" }}
                                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                                        >
                                                                                            <path
                                                                                                d="M5 12h14M13 18l6-6-6-6"
                                                                                                stroke="#dc3545"
                                                                                                strokeWidth="2"
                                                                                                strokeLinecap="round"
                                                                                                strokeLinejoin="round"
                                                                                            />
                                                                                        </svg>
                                                                                    </p>
                                                                                </div>
                                                                            );
                                                                        })()}

                                                                        <div className="connection-banner">
                                                                            <span className="line" />
                                                                            <span className="text">
                                                                                You are now connected with {AssignedCivilEngineerData.name}
                                                                            </span>
                                                                            <span className="line" />
                                                                        </div>
                                                                    </>
                                                                ) : (
                                                                    ""
                                                                )}

                                                                {DisplayFinalMessage === true ? (
                                                                    <p></p>
                                                                ) : conversationEnded ? (
                                                                    <p className="assigned-engineer-banner">
                                                                        Please wait for the civil engineer to
                                                                        connect.
                                                                    </p>
                                                                ) : (
                                                                    ""
                                                                )}
                                                                <div className="chat-body">
                                                                    <div className="chat-messages">
                                                                        {DisplayFinalMessage === true ? (
                                                                            <>
                                                                                {selectedProperty?.registrationDocument === '' && (
                                                                                    <>
                                                                                        {registrationFileLoader ? (
                                                                                            <div className="loader-container">
                                                                                                <img src={loader} alt="Loading..." />
                                                                                                <p>Uploading...</p>
                                                                                            </div>
                                                                                        ) : selectedProperty?.registrationDocument === '' ? (
                                                                                            <>
                                                                                                {getRemainingDays2(selectedProperty?.saledeedSubmittedDate) > 0 ?
                                                                                                    <>
                                                                                                        <div
                                                                                                            className="success-message-box"
                                                                                                            onClick={handleBoxClick}
                                                                                                        >
                                                                                                            <input
                                                                                                                type="file"
                                                                                                                id="registration-upload"
                                                                                                                style={{ display: "none" }}
                                                                                                                ref={fileInputRef}
                                                                                                                accept=".pdf, .doc, .docx, .xls, .xlsx, .png, .jpg, .jpeg, .csv, .svg"
                                                                                                                onChange={handleUploadRegistrationFileUpload}
                                                                                                            />
                                                                                                            <p>Upload Your Registration Document</p>
                                                                                                            <img
                                                                                                                src={uploadw}
                                                                                                                alt="Upload"
                                                                                                                className="RegistrationDocument-doc-image"
                                                                                                            />
                                                                                                        </div>
                                                                                                    </>
                                                                                                    : <>
                                                                                                        ''
                                                                                                    </>}
                                                                                            </>
                                                                                        ) : (
                                                                                            <>
                                                                                                <FilePreview
                                                                                                    url={normalizeUrlToHttps(selectedProperty?.registrationDocument)}
                                                                                                    width="100%"
                                                                                                    height="150px"
                                                                                                    title="Registration Document Preview"
                                                                                                    className="document-preview"
                                                                                                />
                                                                                            </>
                                                                                        )}
                                                                                    </>
                                                                                )}
                                                                                {selectedProperty?.FinalMarketValue === '' && selectedProperty?.registrationDocument !== '' && (
                                                                                    <>
                                                                                        {marketValueFileLoader ? (
                                                                                            <div className="loader-container">
                                                                                                <img src={loader} alt="Loading..." />
                                                                                                <p>Uploading...</p>
                                                                                            </div>
                                                                                        ) : selectedProperty?.FinalMarketValue === '' ? (
                                                                                            <div className="marketValueBox">
                                                                                                <h3 style={{ marginBottom: '15px', color: 'var(--color-oxford-blue)', fontSize: '16px', fontWeight: 'bold', textAlign: 'center' }}>Enter Final Market Value Details</h3>
                                                                                                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', gap: '20px' }}>
                                                                                                    <div style={{ flex: 1, marginBottom: '15px', minWidth: 0 }}>
                                                                                                        <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500', color: 'var(--color-oxford-blue)' }}>Registration Document Number</label>
                                                                                                        <input
                                                                                                            type="text"
                                                                                                            placeholder="Enter document number"
                                                                                                            value={registrationDocNumber}
                                                                                                            onChange={(e) => setRegistrationDocNumber(e.target.value)}
                                                                                                            onBlur={validateRegDoc}
                                                                                                            style={{ width: '100%', padding: '10px', border: regDocError ? '1px solid #dc3545' : '1px solid #ccc', borderRadius: '4px', fontSize: '14px' }}
                                                                                                        />
                                                                                                        {regDocError && <p style={{ color: 'var(--color-error)', fontSize: '12px', marginTop: '5px' }}>{regDocError}</p>}
                                                                                                    </div>
                                                                                                    <div style={{ flex: 1, marginBottom: '15px', minWidth: 0 }}>
                                                                                                        <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500', color: 'var(--color-oxford-blue)' }}>Property Registered Date</label>
                                                                                                        <input
                                                                                                            type="date"
                                                                                                            max={new Date().toISOString().split("T")[0]}
                                                                                                            value={registrationDate}
                                                                                                            onChange={(e) => {
                                                                                                                setRegistrationDate(e.target.value);
                                                                                                                if (registrationDateError) {
                                                                                                                    validateRegistrationDate(e.target.value);
                                                                                                                }
                                                                                                            }}
                                                                                                            onBlur={() => validateRegistrationDate()}
                                                                                                            style={{
                                                                                                                width: '100%',
                                                                                                                padding: '10px',
                                                                                                                border: registrationDateError ? '1px solid #dc3545' : '1px solid #ccc',
                                                                                                                borderRadius: '4px',
                                                                                                                fontSize: '14px'
                                                                                                            }}
                                                                                                        />
                                                                                                        {registrationDateError && <p style={{ color: 'var(--color-error)', fontSize: '12px', marginTop: '5px' }}>{registrationDateError}</p>}
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', gap: '20px' }}>
                                                                                                    <div style={{ flex: 1, marginBottom: '15px', minWidth: 0 }}>
                                                                                                        <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500', color: 'var(--color-oxford-blue)' }}>Market Value</label>
                                                                                                        <div style={{ display: 'flex', gap: '10px' }}>
                                                                                                            <select
                                                                                                                value={marketValueCurrency}
                                                                                                                onChange={(e) => setMarketValueCurrency(e.target.value)}
                                                                                                                style={{ padding: '10px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '14px', width: '50px' }}
                                                                                                            >
                                                                                                                <option value="USD">$</option>
                                                                                                                <option value="EUR">€</option>
                                                                                                                <option value="GBP">£</option>
                                                                                                                <option value="INR">₹</option>
                                                                                                                <option value="JPY">¥</option>
                                                                                                            </select>
                                                                                                            <input
                                                                                                                type="number"
                                                                                                                placeholder="Enter market value"
                                                                                                                value={marketValueAmount}
                                                                                                                onChange={(e) => setMarketValueAmount(e.target.value)}
                                                                                                                style={{ flex: 1, minWidth: 0, padding: '10px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '14px' }}
                                                                                                            />
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div style={{ flex: 1, marginBottom: '15px', minWidth: 0 }}>
                                                                                                        <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500', color: 'var(--color-oxford-blue)' }}>Property Value (As per Saledeed)</label>
                                                                                                        <div style={{ display: 'flex', gap: '10px' }}>
                                                                                                            <select
                                                                                                                value={propertyValueCurrency}
                                                                                                                onChange={(e) => setPropertyValueCurrency(e.target.value)}
                                                                                                                style={{ padding: '10px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '14px', width: '50px' }}
                                                                                                            >
                                                                                                                <option value="USD">$</option>
                                                                                                                <option value="EUR">€</option>
                                                                                                                <option value="GBP">£</option>
                                                                                                                <option value="INR">₹</option>
                                                                                                                <option value="JPY">¥</option>
                                                                                                            </select>
                                                                                                            <input
                                                                                                                type="number"
                                                                                                                placeholder="Enter property value"
                                                                                                                value={propertyValueAmount}
                                                                                                                onChange={(e) => setPropertyValueAmount(e.target.value)}
                                                                                                                style={{ flex: 1, minWidth: 0, padding: '10px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '14px' }}
                                                                                                            />
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div style={{ marginBottom: '15px' }}>
                                                                                                    <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', marginBottom: '8px' }}>
                                                                                                        <input
                                                                                                            type="checkbox"
                                                                                                            checked={isRegisteredDocSubmittedToDoCity}
                                                                                                            onChange={(e) => setIsRegisteredDocSubmittedToDoCity(e.target.checked)}
                                                                                                        />
                                                                                                        The registered document is already submitted to DoCity
                                                                                                    </label>
                                                                                                    <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px' }}>
                                                                                                        <input
                                                                                                            type="checkbox"
                                                                                                            checked={isStrictlyConfidential}
                                                                                                            onChange={(e) => setIsStrictlyConfidential(e.target.checked)}
                                                                                                        />
                                                                                                        This is Strictly Confidential and I don't disclose this declaration.
                                                                                                    </label>
                                                                                                    {marketValueAgreementError && (
                                                                                                        <p style={{ color: '#dc3545', fontSize: '12px', marginTop: '5px' }}>
                                                                                                            {marketValueAgreementError}
                                                                                                        </p>
                                                                                                    )}
                                                                                                </div>
                                                                                                <button
                                                                                                    onClick={handleSubmitMarketValueDetails}
                                                                                                    style={{ width: '100%', padding: '12px', backgroundColor: 'var(--color-turquoise-teal)', color: 'var(--color-frosted-silver-sage)', border: 'none', borderRadius: '4px', fontSize: '16px', fontWeight: 'bold', cursor: 'pointer' }}
                                                                                                >
                                                                                                    Submit Details
                                                                                                </button>
                                                                                            </div>
                                                                                        ) : (
                                                                                            <>
                                                                                                {(() => {
                                                                                                    try {
                                                                                                        const details = JSON.parse(selectedProperty?.FinalMarketValue);
                                                                                                        return (
                                                                                                            <div className="document-preview" style={{ padding: '15px', border: '1px solid #ddd', borderRadius: '8px', backgroundColor: 'var(--color-frosted-silver-sage)' }}>
                                                                                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '15px' }}>
                                                                                                                    <h4 style={{ marginBottom: '0', color: 'var(--color-oxford-blue)', fontSize: '16px', fontWeight: 'bold' }}>Final Market Value Details</h4>
                                                                                                                    <button
                                                                                                                        onClick={() => {
                                                                                                                            setCertificateData({
                                                                                                                                registrationDocNumber: details[0]?.registrationDocNumber,
                                                                                                                                registrationDate: details[0]?.registrationDate,
                                                                                                                                marketValue: details[0]?.marketValue,
                                                                                                                                currency: details[0]?.currency,
                                                                                                                                ownerName: selectedProperty?.ownerName || selectedProperty?.userName || 'rohitkalyan',
                                                                                                                                propertyAddress: selectedProperty?.address || selectedProperty?.propertyAddress || 'Address not available',
                                                                                                                                expiryDate: selectedProperty?.expiryDate || 'N/A',
                                                                                                                            });
                                                                                                                            setShowMarketValueCertificate(true);
                                                                                                                        }}
                                                                                                                        style={{
                                                                                                                            background: 'linear-gradient(135deg, #0D1B2A, #1a2d40)',
                                                                                                                            color: 'var(--color-frosted-silver-sage)',
                                                                                                                            border: 'none',
                                                                                                                            padding: '8px 16px',
                                                                                                                            borderRadius: '6px',
                                                                                                                            fontSize: '13px',
                                                                                                                            fontWeight: '600',
                                                                                                                            cursor: 'pointer',
                                                                                                                            transition: 'all 0.2s',
                                                                                                                            boxShadow: '0 2px 8px rgba(13, 27, 42, 0.2)'
                                                                                                                        }}
                                                                                                                        onMouseEnter={(e) => {
                                                                                                                            e.target.style.transform = 'translateY(-2px)';
                                                                                                                            e.target.style.boxShadow = '0 4px 12px rgba(13, 27, 42, 0.3)';
                                                                                                                        }}
                                                                                                                        onMouseLeave={(e) => {
                                                                                                                            e.target.style.transform = 'translateY(0)';
                                                                                                                            e.target.style.boxShadow = '0 2px 8px rgba(13, 27, 42, 0.2)';
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        📜 View Certificate
                                                                                                                    </button>
                                                                                                                </div>
                                                                                                                <p style={{ margin: '5px 0', color: 'var(--color-oxford-blue)' }}><strong>Registration Doc Number:</strong> {details[0]?.registrationDocNumber}</p>
                                                                                                                <p style={{ margin: '5px 0', color: 'var(--color-oxford-blue)' }}><strong>Property Registered Date:</strong> {details[0]?.registrationDate}</p>
                                                                                                                <p style={{ margin: '5px 0', color: 'var(--color-oxford-blue)' }}><strong>Market Value:</strong> {details[0]?.currency} {details[0]?.marketValue}</p>
                                                                                                            </div>
                                                                                                        );
                                                                                                    } catch {
                                                                                                        return (
                                                                                                            <FilePreview
                                                                                                                url={normalizeUrlToHttps(selectedProperty?.FinalMarketValue)}
                                                                                                                width="100%"
                                                                                                                height="150px"
                                                                                                                title="Registration Document Preview"
                                                                                                                className="document-preview"
                                                                                                            />
                                                                                                        );
                                                                                                    }
                                                                                                })()}
                                                                                            </>
                                                                                        )}
                                                                                    </>
                                                                                )}
                                                                                {selectedProperty?.FinalMarketValue !== '' ?
                                                                                    <div className="centerTheContent">
                                                                                        <MergeAllDocuments property={selectedProperty} ErrorForMergeDocument={ErrorForMergeDocument} />
                                                                                    </div> : ''}

                                                                                {/* Market Value Certificate Section */}
                                                                                {selectedProperty?.FinalMarketValue !== '' && (() => {
                                                                                    try {
                                                                                        const details = JSON.parse(selectedProperty?.FinalMarketValue);
                                                                                        return (
                                                                                            <div className="centerTheContent" style={{ marginTop: '10px', display: 'flex', justifyContent: 'center' }}>
                                                                                                <button
                                                                                                    onClick={() => {
                                                                                                        setCertificateData({
                                                                                                            registrationDocNumber: details[0]?.registrationDocNumber,
                                                                                                            registrationDate: details[0]?.registrationDate,
                                                                                                            marketValue: details[0]?.marketValue,
                                                                                                            currency: details[0]?.currency,
                                                                                                            ownerName: selectedProperty?.ownerName || selectedProperty?.userName || 'rohitkalyan',
                                                                                                            propertyAddress: selectedProperty?.address || selectedProperty?.propertyAddress || 'Address not available',
                                                                                                            expiryDate: selectedProperty?.expiryDate || 'N/A',
                                                                                                        });
                                                                                                        setShowMarketValueCertificate(true);
                                                                                                    }}
                                                                                                    className='marketCertificate'
                                                                                                >View Market Value Certificate
                                                                                                </button>
                                                                                            </div>
                                                                                        );
                                                                                    } catch (error) {
                                                                                        console.error('Error parsing market value data:', error);
                                                                                        return null;
                                                                                    }
                                                                                })()}
                                                                            </>
                                                                        ) :
                                                                            chatMessages.length > 0 ? (
                                                                                <>
                                                                                    {remainingQuestions.length > 0 ? (
                                                                                        chatMessages
                                                                                            .filter((msg) => {
                                                                                                if (shouldShowSaledeedUploadPrompt && (msg.text || "").toString().toLowerCase().includes("to complete the process, upload the sale deed draft")) {
                                                                                                    return false;
                                                                                                }
                                                                                                return msg.text !== "Hi Engineer, I have uploaded all the documents. Can you help me with the further process?";
                                                                                            })
                                                                                            .map((msg, index, filteredMsgs) =>
                                                                                                EnableInput === true ? (
                                                                                                    <div
                                                                                                        key={index}
                                                                                                        className={
                                                                                                            msg.senderId ===
                                                                                                                selectedProperty?._id
                                                                                                                ? "property-chat-message-text"
                                                                                                                : "property-chat-message-text"
                                                                                                        }
                                                                                                        style={{
                                                                                                            alignSelf:
                                                                                                                msg.senderId ===
                                                                                                                    selectedProperty?._id
                                                                                                                    ? "flex-end"
                                                                                                                    : "flex-start",
                                                                                                        }}
                                                                                                    >
                                                                                                        <div
                                                                                                            className={
                                                                                                                msg.senderId ===
                                                                                                                    selectedProperty?._id
                                                                                                                    ? "property-chat-message-text"
                                                                                                                    : "property-chat-message-text"
                                                                                                            }
                                                                                                            style={{
                                                                                                                alignSelf:
                                                                                                                    msg.senderId ===
                                                                                                                        selectedProperty?._id
                                                                                                                        ? "flex-end"
                                                                                                                        : "flex-start",
                                                                                                            }}
                                                                                                        >
                                                                                                            {msg.text &&
                                                                                                                (msg.text.startsWith(
                                                                                                                    "http://"
                                                                                                                ) ||
                                                                                                                    msg.text.startsWith(
                                                                                                                        "https://"
                                                                                                                    )) ? (
                                                                                                                <div>
                                                                                                                    {isLoading &&
                                                                                                                        !hasError && (
                                                                                                                            <p>
                                                                                                                                Loading
                                                                                                                                document...
                                                                                                                            </p>
                                                                                                                        )}
                                                                                                                    {hasError && (
                                                                                                                        <p>
                                                                                                                            Error loading
                                                                                                                            document. Please
                                                                                                                            try again.
                                                                                                                        </p>
                                                                                                                    )}
                                                                                                                    <FilePreview
                                                                                                                        url={normalizeUrlToHttps(msg.text)}
                                                                                                                        width="100%"
                                                                                                                        style={{
                                                                                                                            border: "none",
                                                                                                                        }}
                                                                                                                        title="Document Viewer"
                                                                                                                        onLoad={onLoad}
                                                                                                                        onError={onError}
                                                                                                                    />
                                                                                                                </div>
                                                                                                            ) : (
                                                                                                                <>
                                                                                                                    {msg.text}
                                                                                                                </>
                                                                                                            )}
                                                                                                        </div>
                                                                                                    </div>
                                                                                                ) : (
                                                                                                    <>
                                                                                                        <div
                                                                                                            key={index}
                                                                                                            className="message-row"
                                                                                                            style={{
                                                                                                                display: "flex",
                                                                                                                flexDirection: "row",
                                                                                                                justifyContent: msg.sender === "user" ? "flex-end" : "flex-start",
                                                                                                                alignItems: "center",
                                                                                                                marginBottom: "12px",
                                                                                                                gap: "10px",
                                                                                                            }}
                                                                                                        >
                                                                                                            {msg.sender !== "user" && <Bot />}

                                                                                                            {/* Message bubble */}
                                                                                                            <div
                                                                                                                className={`message-box ${msg.sender === "user"
                                                                                                                    ? "property-chat-message-text-bot22"
                                                                                                                    : "property-chat-message-text-bot"
                                                                                                                    }`}
                                                                                                                data-onboarding={
                                                                                                                    index === filteredMsgs.length - 1 &&
                                                                                                                    msg.sender !== 'user' &&
                                                                                                                    msg.text?.startsWith('Please provide your response to:') &&
                                                                                                                    (currentQuestion?.questionType === 'radio' || currentQuestion?.questionType === 'FileUpload')
                                                                                                                        ? 'first-question'
                                                                                                                        : undefined
                                                                                                                }
                                                                                                            >
                                                                                                                <div
                                                                                                                    className={
                                                                                                                        msg.sender === "user"
                                                                                                                            ? "property-chat-message-text-bot22"
                                                                                                                            : "property-chat-message-text-bot"
                                                                                                                    }
                                                                                                                >
                                                                                                                    {msg.text?.startsWith("http://") || msg.text?.startsWith("https://") ? (
                                                                                                                        <div>
                                                                                                                            {hasError && <p>Error loading document. Please try again.</p>}
                                                                                                                            <FilePreview
                                                                                                                                url={msg.text}
                                                                                                                                width="100%"
                                                                                                                                height="100px"
                                                                                                                                style={{
                                                                                                                                    border: "none",
                                                                                                                                    borderRadius: "6px",
                                                                                                                                    marginTop: "5px",
                                                                                                                                }}
                                                                                                                                title={`Document Viewer ${index}`}
                                                                                                                                onLoad={onLoad}
                                                                                                                                onError={onError}
                                                                                                                            />
                                                                                                                        </div>
                                                                                                                    ) : msg.text?.includes("bank loan") ? (
                                                                                                                        <>
                                                                                                                            <p>{msg.text}</p>
                                                                                                                            <a href="#!" className="bankLoanUi" onClick={(e) => { e.preventDefault(); sethandleOpenBankLoanLink(); }}>
                                                                                                                                Why Consider a Bank Loan for Your Property Purchase?
                                                                                                                            </a>
                                                                                                                            {index === filteredMsgs.length - 1 && currentQuestion?.questionType === 'radio' && !conversationEnded && (
                                                                                                                                <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginTop: '10px', flexWrap: 'wrap' }}>
                                                                                                                                    <label style={{ marginBottom: 0, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                                                                                                        <input type="radio" name="inlineBubbleRadio" value="Yes" checked={userQuestion === "Yes"} onChange={() => handleInlineRadioAnswer("Yes")} />
                                                                                                                                        <strong>I am intrestedin bank loan</strong>
                                                                                                                                    </label>
                                                                                                                                    <label style={{ marginBottom: 0, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                                                                                                        <input type="radio" name="inlineBubbleRadio" value="No" checked={userQuestion === "No"} onChange={() => handleInlineRadioAnswer("No")} />
                                                                                                                                        <strong>I will apply for a bank loan in future</strong>
                                                                                                                                    </label>
                                                                                                                                </div>
                                                                                                                            )}
                                                                                                                        </>
                                                                                                                    ) : (
                                                                                                                        msg.text?.includes("(broker, relative, or another medium)") &&
                                                                                                                            !UserUploadedDocs.some(
                                                                                                                                (x) =>
                                                                                                                                    x.Type?.includes(
                                                                                                                                        "How did he get in touch with the property owner (broker, relative, or another medium)?"
                                                                                                                                    )
                                                                                                                            ) ? (
                                                                                                                            <>
                                                                                                                                <p>{msg.text}</p>
                                                                                                                                <div className="checkbox-row">
                                                                                                                                    <label
                                                                                                                                        className="checkbox-item"
                                                                                                                                        onClick={() => handleSubmitHowdidhegetintouchwiththeproperty("broker")}
                                                                                                                                    >
                                                                                                                                        <input
                                                                                                                                            type="checkbox"
                                                                                                                                            checked={SelectedRadioForChatBrokerOrRelative === "broker"}
                                                                                                                                        />
                                                                                                                                        <span>Broker</span>
                                                                                                                                    </label>

                                                                                                                                    <label
                                                                                                                                        className="checkbox-item"
                                                                                                                                        onClick={() => handleSubmitHowdidhegetintouchwiththeproperty("relative")}
                                                                                                                                    >
                                                                                                                                        <input
                                                                                                                                            type="checkbox"
                                                                                                                                            checked={SelectedRadioForChatBrokerOrRelative === "relative"}
                                                                                                                                        />
                                                                                                                                        <span>Relative</span>
                                                                                                                                    </label>

                                                                                                                                    <label
                                                                                                                                        className="checkbox-item"
                                                                                                                                        onClick={() => handleSubmitHowdidhegetintouchwiththeproperty("other")}
                                                                                                                                    >
                                                                                                                                        <input
                                                                                                                                            type="checkbox"
                                                                                                                                            checked={SelectedRadioForChatBrokerOrRelative === "other"}
                                                                                                                                        />
                                                                                                                                        <span>Other</span>
                                                                                                                                    </label>
                                                                                                                                </div>
                                                                                                                            </>
                                                                                                                        ) : (msg.text?.includes("Do you have the document") || currentQuestion?.questionType === 'FileUpload') && index === filteredMsgs.length - 1 && currentQuestion?.questionType === 'FileUpload' && !conversationEnded ? (
                                                                                                                            <>
                                                                                                                                <p>{msg.text}</p>
                                                                                                                                <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginTop: '8px', flexWrap: 'wrap' }}>
                                                                                                                                    <label style={{ marginBottom: 0, cursor: selectedInlineRadioOption ? 'default' : 'pointer', display: 'flex', alignItems: 'center', gap: '6px', opacity: selectedInlineRadioOption && selectedInlineRadioOption !== 'Yes' ? 0.5 : 1 }}>
                                                                                                                                        <input type="radio" name="inlineBubbleFileRadio" value="Yes" checked={selectedInlineRadioOption === 'Yes'} onChange={() => openInlineFileUploadModal()} disabled={selectedInlineRadioOption !== null} />
                                                                                                                                        <strong>Yes</strong>
                                                                                                                                    </label>
                                                                                                                                    <label style={{ marginBottom: 0, cursor: selectedInlineRadioOption ? 'default' : 'pointer', display: 'flex', alignItems: 'center', gap: '6px', opacity: selectedInlineRadioOption && selectedInlineRadioOption !== 'No' ? 0.5 : 1 }}>
                                                                                                                                        <input type="radio" name="inlineBubbleFileRadio" value="No" checked={selectedInlineRadioOption === 'No'} onChange={() => handleInlineFileQuestionAnswer('No')} disabled={selectedInlineRadioOption !== null} />
                                                                                                                                        <strong>No</strong>
                                                                                                                                    </label>
                                                                                                                                </div>
                                                                                                                            </>
                                                                                                                        ) : radioQuestions.some(q => msg.text?.includes(q)) && index === filteredMsgs.length - 1 && currentQuestion?.questionType === 'radio' && !conversationEnded ? (
                                                                                                                            <>
                                                                                                                                <p>{msg.text}</p>
                                                                                                                                <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginTop: '8px', flexWrap: 'wrap' }}>
                                                                                                                                    <label style={{ marginBottom: 0, cursor: selectedInlineRadioOption ? 'default' : 'pointer', display: 'flex', alignItems: 'center', gap: '6px', opacity: selectedInlineRadioOption && selectedInlineRadioOption !== 'Yes' ? 0.5 : 1 }}>
                                                                                                                                        <input type="radio" name="inlineBubbleRadio" value="Yes" checked={selectedInlineRadioOption === 'Yes'} onChange={() => handleInlineRadioAnswer("Yes")} disabled={selectedInlineRadioOption !== null} />
                                                                                                                                        <strong>Yes</strong>
                                                                                                                                    </label>
                                                                                                                                    <label style={{ marginBottom: 0, cursor: selectedInlineRadioOption ? 'default' : 'pointer', display: 'flex', alignItems: 'center', gap: '6px', opacity: selectedInlineRadioOption && selectedInlineRadioOption !== 'No' ? 0.5 : 1 }}>
                                                                                                                                        <input type="radio" name="inlineBubbleRadio" value="No" checked={selectedInlineRadioOption === 'No'} onChange={() => handleInlineRadioAnswer("No")} disabled={selectedInlineRadioOption !== null} />
                                                                                                                                        <strong>No</strong>
                                                                                                                                    </label>
                                                                                                                                </div>
                                                                                                                            </>
                                                                                                                        ) : (
                                                                                                                            <>{msg.text}</>
                                                                                                                        )
                                                                                                                    )}
                                                                                                                </div>
                                                                                                            </div>

                                                                                                            {/* User icon on the right */}
                                                                                                            {msg.sender === "user" && (
                                                                                                                <img
                                                                                                                    src={getUserImage(selectedProperty)}
                                                                                                                    alt="User"
                                                                                                                    className="message-icon"
                                                                                                                    onError={(e) => {
                                                                                                                        e.target.src = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='100' height='100'><circle cx='12' cy='12' r='12' fill='%23cbd5e1'/><path d='M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z' fill='%2394a3b8'/></svg>";
                                                                                                                    }}
                                                                                                                />
                                                                                                            )}
                                                                                                        </div>
                                                                                                        {index === filteredMsgs.length - 1 && msg.sender !== "user" && currentQuestion && remainingQuestions.length > 0 && !conversationEnded && !msg.text?.includes("(broker, relative, or another medium)") && currentQuestion.questionType !== 'radio' && currentQuestion.questionType !== 'text' && currentQuestion.questionType !== 'FileUpload' && currentQuestion.questionType !== 'date' && (
                                                                                                            <div className="inline-chat-input-wrapper" style={{ marginLeft: "34px" }}>
                                                                                                                {saledeedSubmissionErrorMessage && <p className="error">{saledeedSubmissionErrorMessage}</p>}
                                                                                                            </div>
                                                                                                        )}
                                                                                                    </>
                                                                                                )
                                                                                            )
                                                                                    ) : (
                                                                                        <>
                                                                                            {chatMessages.length > 0 ? (
                                                                                                chatMessages
                                                                                                    .filter(
                                                                                                        (msg) => {
                                                                                                            if (shouldShowSaledeedUploadPrompt && (msg.text || "").toString().toLowerCase().includes("to complete the process, upload the sale deed draft")) {
                                                                                                                return false;
                                                                                                            }
                                                                                                            return msg.text !== "Hi Engineer, I have uploaded all the documents. Can you help me with the further process?";
                                                                                                        }
                                                                                                    )
                                                                                                    .map((msg, index) => {
                                                                                                        const isUser = msg.senderId === selectedProperty?._id;
                                                                                                        const isBot = msg.sender === "bot" || (!msg.senderId && msg.sender === "bot");
                                                                                                        if (isBot) {
                                                                                                            return (
                                                                                                                <div
                                                                                                                    key={index}
                                                                                                                    className="message-row"
                                                                                                                    style={{
                                                                                                                        display: "flex",
                                                                                                                        flexDirection: "row",
                                                                                                                        justifyContent: "flex-start",
                                                                                                                        alignItems: "center",
                                                                                                                        marginBottom: "12px",
                                                                                                                        gap: "10px",
                                                                                                                    }}
                                                                                                                >
                                                                                                                    <Bot />
                                                                                                                    <div className="message-box property-chat-message-text-bot">
                                                                                                                        <div className="property-chat-message-text-bot">
                                                                                                                            {msg.text}
                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            );
                                                                                                        }
                                                                                                        const senderData = isUser ? selectedProperty : selectedProperty.assignedCivilEngineer;
                                                                                                        const userImage = getUserImage(senderData);
                                                                                                        const userName = getUserName(senderData);
                                                                                                        return (
                                                                                                            <div
                                                                                                                key={index}
                                                                                                                className={`message-wrapper ${isUser ? "message-user" : "message-engineer"}`}
                                                                                                                style={{
                                                                                                                    display: "flex",
                                                                                                                    flexDirection: isUser ? "row-reverse" : "row",
                                                                                                                    alignItems: "flex-start",
                                                                                                                    gap: "8px",
                                                                                                                    margin: "12px 0",
                                                                                                                }}
                                                                                                            >
                                                                                                                <img
                                                                                                                    className="chat-avatar"
                                                                                                                    src={userImage}
                                                                                                                    alt="Avatar"
                                                                                                                    style={{
                                                                                                                        width: "28px",
                                                                                                                        height: "28px",
                                                                                                                        borderRadius: "50%",
                                                                                                                        objectFit: "cover",
                                                                                                                    }}
                                                                                                                    onError={(e) => {
                                                                                                                        e.target.src = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='100' height='100'><circle cx='12' cy='12' r='12' fill='%23cbd5e1'/><path d='M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z' fill='%2394a3b8'/></svg>";
                                                                                                                    }}
                                                                                                                />

                                                                                                                <div
                                                                                                                    className={`chat-bubble ${isUser ? "chat-user" : "chat-bot"}`}
                                                                                                                    style={{
                                                                                                                        backgroundColor: isUser ? "#e0f7fa" : "#f1f1f1",
                                                                                                                        padding: "8px 12px",
                                                                                                                        borderRadius: "10px",
                                                                                                                        maxWidth: "70%",
                                                                                                                        textAlign: "left",
                                                                                                                    }}>
                                                                                                                    <div
                                                                                                                        style={{
                                                                                                                            fontWeight: 600,
                                                                                                                            fontSize: "13px",
                                                                                                                            marginBottom: "4px",
                                                                                                                            color: isUser ? "#0D1B2A" : "#0D1B2A",
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        {userName}
                                                                                                                    </div>

                                                                                                                    {msg?.text &&
                                                                                                                        (msg.text.startsWith("http://") || msg.text.startsWith("https://")) ? (
                                                                                                                        <>

                                                                                                                            {msg?.fields?.length > 0 ?
                                                                                                                                <div
                                                                                                                                    style={{
                                                                                                                                        border: "1px solid #ccc",
                                                                                                                                        borderRadius: "4px",
                                                                                                                                        padding: "6px",
                                                                                                                                        backgroundColor: "var(--color-frosted-silver-sage)",
                                                                                                                                        marginBottom: "8px",
                                                                                                                                        boxShadow: "0 1px 2px rgba(0,0,0,0.02)",
                                                                                                                                        fontSize: "10px",
                                                                                                                                    }}
                                                                                                                                >
                                                                                                                                    <h5 style={{ marginBottom: "5px", color: "var(--color-oxford-blue)", fontSize: '11px', fontWeight: '600' }}>
                                                                                                                                        📄 Document
                                                                                                                                    </h5>

                                                                                                                                    {msg.fields?.length > 0 && (
                                                                                                                                        <>
                                                                                                                                            <div
                                                                                                                                                style={{
                                                                                                                                                    display: "grid",
                                                                                                                                                    gridTemplateColumns: "repeat(auto-fit, minmax(100px, 1fr))",
                                                                                                                                                    gap: "4px",
                                                                                                                                                    marginBottom: "6px",
                                                                                                                                                }}
                                                                                                                                            >
                                                                                                                                                <div><b>Doc No:</b> {msg.fields[0].documentNumber || "N/A"}</div>
                                                                                                                                                <div><b>Officer:</b> {msg.fields[0].documentOfficer || msg.fields[0].issuedByName || "N/A"}</div>
                                                                                                                                                <div><b>Desig:</b> {msg.fields[0].issuedByDesignation || "N/A"}</div>
                                                                                                                                                <div><b>Officer No:</b> {msg.fields[0].officerNumber || msg.fields[0].PhoneNumber || "N/A"}</div>
                                                                                                                                                <div><b>Prepared By Type:</b> {msg.fields[0].preparedByRole || "N/A"}</div>
                                                                                                                                                <div><b>Prepared By Name:</b> {msg.fields[0].preparedByName || "N/A"}</div>
                                                                                                                                            </div>
                                                                                                                                            {/* Status & Reason */}
                                                                                                                                            <div className="document-status-container">
                                                                                                                                                {/* <p className={`status-text ${msg.verificationStatus?.toLowerCase()}`}>
                                                                                                                                                    {msg.verificationStatus || "-"}
                                                                                                                                                </p> */}
                                                                                                                                                {msg.rejectionReason && (
                                                                                                                                                    <p className="rejection-reason">
                                                                                                                                                        <b>Reason:</b> {msg.rejectionReason}
                                                                                                                                                    </p>
                                                                                                                                                )}
                                                                                                                                            </div>
                                                                                                                                        </>
                                                                                                                                    )}

                                                                                                                                    <div
                                                                                                                                        style={{
                                                                                                                                            border: "1px solid #bbb",
                                                                                                                                            borderRadius: "3px",
                                                                                                                                            overflow: "hidden",
                                                                                                                                            height: "120px",
                                                                                                                                        }}
                                                                                                                                    >
                                                                                                                                        <FilePreview
                                                                                                                                            url={normalizeUrlToHttps(msg.text)}
                                                                                                                                            width="100%"
                                                                                                                                            height="100%"
                                                                                                                                            style={{ border: "none" }}
                                                                                                                                            title="Doc View"
                                                                                                                                        />
                                                                                                                                    </div>
                                                                                                                                </div>
                                                                                                                                : <FilePreview
                                                                                                                                    url={msg.text}
                                                                                                                                    width="100%"
                                                                                                                                    height="120px"
                                                                                                                                    style={{ border: "none", borderRadius: "6px" }}
                                                                                                                                    title="Document Viewer"
                                                                                                                                />}
                                                                                                                        </>
                                                                                                                    ) : (
                                                                                                                        <>
                                                                                                                            {msg?.files?.map((x, i) => (
                                                                                                                                <FilePreview
                                                                                                                                    key={i}
                                                                                                                                    url={x.url}
                                                                                                                                    className="file-preview"
                                                                                                                                    width="100%"
                                                                                                                                    height="120px"
                                                                                                                                    title={`Document Viewer ${i}`}
                                                                                                                                    style={{
                                                                                                                                        width: "100%",
                                                                                                                                        height: "120px",
                                                                                                                                        border: "none",
                                                                                                                                        borderRadius: "6px",
                                                                                                                                        marginBottom: "6px",
                                                                                                                                    }}
                                                                                                                                />
                                                                                                                            ))}
                                                                                                                            <div className="chat-message-text" style={{ fontSize: "14px" }}>
                                                                                                                                {/(?:\+?\d{1,4}[\s-]?)?(?:\(?\d{2,4}\)?[\s-]?)?\d{3,4}[\s-]?\d{4}/.test(msg.text) ||
                                                                                                                                    /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/i.test(msg.text)
                                                                                                                                    ? <i style={{ color: "var(--color-oxford-blue)" }}>Message hidden (contains restricted info)</i>
                                                                                                                                    : msg.text
                                                                                                                                }

                                                                                                                                <span style={{ fontSize: "9px", marginLeft: "6px" }}>
                                                                                                                                    {moment(msg.createdAt).format("LT")}
                                                                                                                                </span>
                                                                                                                            </div>

                                                                                                                        </>
                                                                                                                    )}
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        );
                                                                                                    })
                                                                                            ) : (
                                                                                                <div className="select-property-card">
                                                                                                    <p className="select-property-text">No Messages Found</p>
                                                                                                </div>
                                                                                            )}
                                                                                        </>
                                                                                    )}
                                                                                    <div ref={messagesEndRefUser2} />
                                                                                    {(showSaleDeedSuccessCard || shouldShowEngineerRegistrationUploadCard) && (
                                                                                        <div className="registration-upload-wrap" ref={registrationUploadCardRef}>
                                                                                            <div className="message-row registration-upload-row">
                                                                                                <Bot className="registration-upload-bot-icon" size={22} />
                                                                                                <div className="message-box registration-upload-box">
                                                                                                    <p className="registration-upload-desc">You have 45 days to upload your Registration.</p>
                                                                                                    <input
                                                                                                        type="file"
                                                                                                        ref={inlineRegistrationUploadRef}
                                                                                                        style={{ display: "none" }}
                                                                                                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                                                                                        onChange={handleInlineRegistrationUpload}
                                                                                                        disabled={inlineRegistrationUploadLoading}
                                                                                                    />
                                                                                                    <button
                                                                                                        className="registration-upload-btn"
                                                                                                        onClick={() => inlineRegistrationUploadRef.current?.click()}
                                                                                                        disabled={isInlineRegistrationUploadingForCurrentProperty}
                                                                                                    >
                                                                                                        <span className="registration-upload-icon">📤</span>
                                                                                                        {isInlineRegistrationUploadingForCurrentProperty ? 'Uploading...' : 'Please upload your Registration Document'}
                                                                                                    </button>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    )}
                                                                                </>
                                                                            ) : (
                                                                                <div className="select-property-card">
                                                                                    <p className="select-property-text">
                                                                                        Select a property from the list to view complete details and documents.
                                                                                    </p>
                                                                                </div>
                                                                            )}
                                                                    </div>
                                                                </div>
                                                            </>
                                                )}
                                        </>
                                    )}
                                </>
                            )}
                        </div>
                        {DisplayFinalMessage === false && (
                            <div className="property-chat-input">
                                <>
                                    {selectedProperty?.saleDeedSubmissionDate &&
                                        selectedProperty?.assignedCivilEngineer &&
                                        selectedProperty?.saleDeedUploaded === "" &&
                                        getRemainingDays(selectedProperty) === 0 ?
                                        <>
                                        </> :
                                        <>
                                            {selectedProperty?.Payment_Status === true && getRemainingDays2(selectedProperty?.saledeedSubmittedDate) !== 0 ?
                                                <div className="chat-footer-style">

                                                    {UploadFileLoader === false ? (
                                                        uploadedFile ? (
                                                            <div >
                                                                {isLoading && !hasError && (
                                                                    <p>Loading document...</p>
                                                                )}
                                                                {hasError && (
                                                                    <p>
                                                                        Error loading document. Please try
                                                                        again.
                                                                    </p>
                                                                )}
                                                                <FilePreview
                                                                    url={uploadedFile || ""}
                                                                    width="40%"
                                                                    height="40%"
                                                                    style={{ border: "none" }}
                                                                    title="PDF Viewer"
                                                                    onLoad={onLoad}
                                                                    onError={onError}
                                                                />
                                                            </div>
                                                        ) : (
                                                            <></>
                                                        )
                                                    ) : (
                                                        <p
                                                            style={{
                                                                textAlign: "center",
                                                                color: "var(--color-oxford-blue)",
                                                            }}
                                                        >
                                                            Uploading.....
                                                        </p>
                                                    )}
                                                    {conversationEnded ? (
                                                        selectedProperty?.resolvedBy !== "" ? (
                                                            <p></p>
                                                        ) : (

                                                            <p className="footerMessage">
                                                                {/* Please wait for the civil engineer to
                                                                    connect. */}
                                                            </p>
                                                        )
                                                    ) : (
                                                        <div>
                                                            {isLoading === true ? (
                                                                <div>
                                                                    <p style={{ textAlign: "center" }}>
                                                                        Document is Uploading Please wait
                                                                    </p>
                                                                </div>
                                                            ) : (
                                                                <div className="row pt-3">
                                                                    <>
                                                                        {saledeedSubmissionErrorMessage && <p className="error">{saledeedSubmissionErrorMessage}</p>}
                                                                        {!(currentQuestion?.questionType && remainingQuestions.length !== 0) ? (
                                                                            <>
                                                                                {selectedProperty?.saleDeedUploaded !==
                                                                                    "" ? (
                                                                                    <>
                                                                                        <div className="col-md-10">
                                                                                            <textarea type="text"
                                                                                                value={Message}
                                                                                                onChange={(e) =>
                                                                                                    setMessage(
                                                                                                        e.target.value
                                                                                                    )
                                                                                                }
                                                                                                placeholder="Type your message or update..."
                                                                                                className="auto-expand"
                                                                                                onKeyDown={(e) => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); handleSendMessage(); } }}
                                                                                            ></textarea>
                                                                                        </div>
                                                                                    </>
                                                                                ) : (
                                                                                    <div className="col-md-10">

                                                                                        <textarea type="text"
                                                                                            value={Message}
                                                                                            onChange={(e) =>
                                                                                                setMessage(
                                                                                                    e.target.value
                                                                                                )
                                                                                            }
                                                                                            placeholder="Type your message or update..."
                                                                                            className="auto-expand"
                                                                                            disabled={
                                                                                                selectedProperty?.assignedCivilEngineer ===
                                                                                                ""
                                                                                            }
                                                                                            onKeyDown={(e) => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); handleSendMessage(); } }}
                                                                                        ></textarea>

                                                                                    </div>
                                                                                )}
                                                                            </>
                                                                        ) : (currentQuestion?.questionType === 'text' || currentQuestion?.questionType === 'date') && remainingQuestions.length > 0 ? (
                                                                            <>
                                                                                {currentQuestion?.questionType === 'date' ? (
                                                                                    <div className="col-md-10">
                                                                                        <input
                                                                                            type="date"
                                                                                            className="form-control"
                                                                                            value={userQuestion}
                                                                                            min={new Date().toISOString().split("T")[0]}
                                                                                            onChange={(e) => { let v = e.target.value; const p = v.split('-'); if (p[0] && p[0].length > 4) { p[0] = p[0].slice(0, 4); v = p.join('-'); } setUserQuestion(v); }}
                                                                                            style={{ flex: 1 }}
                                                                                        />
                                                                                    </div>
                                                                                ) : (
                                                                                    <div className="col-md-10">
                                                                                        <textarea
                                                                                            value={userQuestion}
                                                                                            onChange={(e) => setUserQuestion(e.target.value)}
                                                                                            placeholder="Type your message or update..."
                                                                                            className="auto-expand"
                                                                                            onKeyDown={(e) => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); handleSendMessage(); } }}
                                                                                        />
                                                                                    </div>
                                                                                )}
                                                                                <div className="col-md-1">
                                                                                    <button className={`property-chat-send-btn${userQuestion.trim() ? ' has-text' : ''}`} onClick={handleSendMessage} disabled={SendMessageLoad}>
                                                                                        {SendMessageLoad ? <Loader2 size={18} className="animate-spin" /> : <Send size={20} />}
                                                                                    </button>
                                                                                </div>
                                                                            </>
                                                                        ) : null}

                                                                        {false && null /* date input moved inline */}

                                                                        {false && null /* FileUpload moved inline */}

                                                                        {false && null /* radio moved inline */}
                                                                    </>

                                                                    {(!currentQuestion?.questionType || currentQuestion?.length === 0 || Object.keys(currentQuestion || {}).length === 0) && (
                                                                        <>
                                                                            <div className="col-md-1 pt-2" >
                                                                                <input
                                                                                    type="file"
                                                                                    id="file-upload"
                                                                                    style={{
                                                                                        display: "none",
                                                                                    }}
                                                                                    ref={fileInputRef2}
                                                                                    accept=".pdf, .doc, .docx, .xls, .xlsx, .png, .jpg, .jpeg, .csv,.svg"
                                                                                    onChange={
                                                                                        handleFileUpload2
                                                                                    }
                                                                                />
                                                                                <div
                                                                                    className="upload-icon"
                                                                                    onClick={handleBoxClick2}>
                                                                                    <img className='property-chat-input-btn' src={uploadIcon} alt="Upload" />
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-1" style={{ marginTop: '0px' }}>
                                                                                <button
                                                                                    className={`property-chat-send-btn${Message.trim() ? ' has-text' : ''}`}
                                                                                    onClick={handleSendMessage}
                                                                                    disabled={
                                                                                        SendMessageLoad ||
                                                                                        (Message === "" && uploadedFiles.length === 0)
                                                                                    }
                                                                                >
                                                                                    {SendMessageLoad ? <Loader2 size={18} className="animate-spin" /> : <Send size={20} />}
                                                                                </button>

                                                                            </div>{" "}
                                                                        </>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                                : ''}
                                        </>}
                                </>
                            </div>
                        )}
                        {shouldShowSaledeedUploadPrompt && (() => {
                            const rejectionReason = getSaledeedRejectionReason();
                            return (
                                <div className="saledeed-popup-blur-overlay" style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    backgroundColor: "rgba(13, 27, 42, 0.12)",
                                    backdropFilter: "blur(5px)",
                                    zIndex: 1000,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "20px"
                                }}>
                                    <div className="saledeed-floating-popup" style={{
                                        width: "100%",
                                        maxWidth: "480px",
                                        backgroundColor: "#ffffff",
                                        border: "1px solid rgba(31, 182, 166, 0.3)",
                                        borderLeft: "5px solid var(--color-turquoise-teal)",
                                        borderRadius: "14px",
                                        boxShadow: "0 12px 35px rgba(13, 27, 42, 0.15)",
                                        padding: "24px 28px 24px 20px",
                                        position: "relative",
                                        boxSizing: "border-box"
                                    }}>
                                        <button
                                            onClick={() => setHasManuallyClosedSaledeedPopup(true)}
                                            style={{
                                                position: "absolute",
                                                top: "12px",
                                                right: "16px",
                                                background: "none",
                                                border: "none",
                                                fontSize: "16px",
                                                fontWeight: "600",
                                                cursor: "pointer",
                                                color: "#888",
                                                padding: "2px 6px",
                                                lineHeight: 1,
                                                outline: "none"
                                            }}
                                            title="Close"
                                            className="saledeed-popup-close-btn"
                                        >
                                            ✕
                                        </button>
                                        <h6 style={{ fontWeight: 600, color: "var(--color-oxford-blue)", marginBottom: "8px", fontSize: "14px", display: "flex", alignItems: "center", gap: "6px" }}>
                                            {rejectionReason ? "❌ Sale Deed Rejected" : "📄 Action Required: Sale Deed Draft"}
                                        </h6>
                                        <p style={{ fontSize: "12px", color: "var(--color-oxford-blue)", marginBottom: "16px", lineHeight: "1.4" }}>
                                            {rejectionReason
                                                ? `The engineer rejected the sale deed draft. Reason: "${rejectionReason}". Please re-upload a corrected version.`
                                                : "The engineer has requested your Sale Deed Draft to complete the verification process."
                                            }
                                        </p>
                                        <div style={{ display: "flex", justifyContent: "flex-start" }}>
                                            <button
                                                className="btn btn-sm text-white"
                                                style={{
                                                    backgroundColor: "var(--color-turquoise-teal)",
                                                    border: "none",
                                                    padding: "6px 16px",
                                                    borderRadius: "6px",
                                                    fontWeight: "600",
                                                    fontSize: "12px"
                                                }}
                                                onClick={() => DisplaySaledeedFieldsModel()}
                                            >
                                                {rejectionReason ? "Re-upload Sale Deed" : "Upload Sale Deed"}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            );
                        })()}
                    </div>
                    {/* Right Panel */}
                    <div className={`property-chat-right-panel ${!showRightPanel ? 'right-panel-closed' : ''}`}>
                        <div style={{ position: 'relative', height: '100%', display: 'flex', flexDirection: 'column' }}>
                            {showRightPanel && (
                                <button
                                    className="chat-panel-close-fab"
                                    onClick={() => setShowRightPanel(false)}
                                    aria-label="Close Onboarding Panel"
                                    title="Close Panel"
                                >
                                    <ChevronRight size={18} />
                                </button>
                            )}
                            {ChatPageLoading ? (
                                <div className="setInCenter" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%' }}>
                                    <FetchingCard message="" sub="Fetching details" />
                                </div>
                            ) : (
                                <>
                                    <div className="property-chat-right-panel-header">
                                        {isMobile && (
                                            <button
                                                className="mobile-back-btn mb-2"
                                                onClick={() => setShowRightPanel(false)}
                                                aria-label="Back to chat"
                                            >
                                                <ArrowLeft size={20} />
                                                <span>Back to Chat</span>
                                            </button>
                                        )}
                                        {selectedProperty && (
                                            <div className="status-card">
                                                <div className="status-card-info">
                                                    <h6 className="status-title" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                        {getMissingDocsCount() > 0 && (
                                                            <span className="missing-docs-badge">
                                                                {getMissingDocsCount()}
                                                            </span>
                                                        )}
                                                        {selectedProperty?.Status === 'resolved' || selectedProperty?.status === 'resolved'
                                                            ? 'Verification Complete'
                                                            : (hasMatchedQuestions === 11
                                                                ? (selectedProperty?.assignedCivilEngineer ? 'Under Review' : 'Waiting for Engineer')
                                                                : 'Property Onboarding')}
                                                    </h6>
                                                    <span className="status-badge" style={{
                                                        background: (selectedProperty?.Status === 'resolved' || selectedProperty?.status === 'resolved') ? '#10b981' : '#f1f5f9',
                                                        color: (selectedProperty?.Status === 'resolved' || selectedProperty?.status === 'resolved') ? '#ffffff' : '#475569'
                                                    }}>
                                                        {selectedProperty?.Status === 'resolved' || selectedProperty?.status === 'resolved' ? 'Resolved' : 'In Progress'}
                                                    </span>
                                                </div>

                                                {hasMatchedQuestions !== 11 && (
                                                    <div className="progress-section">
                                                        <div className="progress-text-row">
                                                            <span className="progress-label">Completion Status</span>
                                                            <span className="progress-percentage">
                                                                {Math.round((completedQuestions / totalQuestions) * 100) || 0}%
                                                            </span>
                                                        </div>

                                                        <div className="progress-track">
                                                            <div
                                                                className="progress-fill-animate"
                                                                style={{ width: `${(completedQuestions / totalQuestions) * 100 || 0}%` }}
                                                            ></div>
                                                        </div>

                                                        <p className="progress-subtext">
                                                            {completedQuestions} of {totalQuestions} requirements met
                                                        </p>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                    <div className="property-chat-right-panel-content">
                                        {hasMatchedQuestions !== 11 ?
                                            <>
                                                <div
                                                    className="property-chat-files-list1"
                                                    style={{ padding: '10px', overflow: 'scroll' }}
                                                >
                                                    {(
                                                        (showAllQuestions ? QuwstionsList : QuwstionsList || [])
                                                            .sort((a, b) => {
                                                                const aCorrect = checkUserUploadedToQuestions2(a);
                                                                const bCorrect = checkUserUploadedToQuestions2(b);
                                                                if (aCorrect === bCorrect) return 0;
                                                                return aCorrect ? 1 : -1;
                                                            })
                                                            .map((property, index) => (
                                                                <div
                                                                    className="question-list-item"
                                                                    key={index}
                                                                >
                                                                    <div className="question-list-main">
                                                                        <span
                                                                            className={`question-list-status fw-bold ${checkUserUploadedToQuestions2(property)
                                                                                ? 'text-success'
                                                                                : 'text-danger'
                                                                                }`}
                                                                        >
                                                                            {checkUserUploadedToQuestions2(property) ? '✓' : '✗'}
                                                                        </span>
                                                                        <span className="question-list-text question-with-info-inline">
                                                                            {property.question}
                                                                            {isMarketValueDeclarationQuestion(property.question) && (
                                                                                <span className="market-value-info-wrapper" tabIndex={0}>
                                                                                    <span className="market-value-info-icon">i</span>
                                                                                </span>
                                                                            )}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            ))
                                                    )}
                                                </div>
                                            </>
                                            : <>
                                                <div
                                                    className="property-chat-files-list1"
                                                >
                                                    <div className="property-chat-group-profile">
                                                        <ProgressWithCategories
                                                            UserUploadedDocs={UserUploadedDocs}
                                                        />
                                                    </div>
                                                    <div className="property-chat-panel-section">
                                                        <div className="property-chat-section-header">
                                                            <h4>Questions List<span style={{ color: 'var(--color-oxford-blue)' }}>&nbsp;&nbsp;{getPendingBotQuestions(selectedProperty) !== 0 && getPendingBotQuestions(selectedProperty)}</span></h4>
                                                            <span className="property-chat-view-all" onClick={toggleShowAllQuestions}>
                                                                {showAllQuestions ? "View Less" : "View All"}
                                                            </span>
                                                        </div>
                                                        <div className="property-chat-members-list">
                                                            <div className="property-chat-files-list">
                                                                {(showAllQuestions ? UserUploadedDocs : UserUploadedDocs.slice(0, 3)).map((property, index) => (
                                                                    <div className="col-md-12" key={index}>
                                                                        <div className="question-list-row">
                                                                            <div className="question-list-main">
                                                                                <span
                                                                                    className={`question-list-status fs-5 fw-bold ${checkUserUploadedToQuestions(property) ? 'text-success' : 'text-danger'
                                                                                        }`}
                                                                                >
                                                                                    {checkUserUploadedToQuestions(property) ? '✓' : '✗'}
                                                                                </span>
                                                                                <div className="question-list-content">
                                                                                    <p className="text-muted question-list-description">
                                                                                        <span className="question-list-text question-with-info-inline">
                                                                                            {property.Type}{" "}
                                                                                            {isMarketValueDeclarationQuestion(property.Type) && (
                                                                                                <span className="market-value-info-wrapper" tabIndex={0}>
                                                                                                    <span className="market-value-info-icon">i</span>
                                                                                                </span>
                                                                                            )}
                                                                                        </span>
                                                                                        {getQuestionType(property) === 'FileUpload' &&
                                                                                            !checkUserUploadedToQuestions(property) && (
                                                                                                <>
                                                                                                    <input
                                                                                                        type="file"
                                                                                                        id="registration-upload"
                                                                                                        style={{ display: "none" }}
                                                                                                        ref={UserUploadInputRef}
                                                                                                        accept=".pdf, .doc, .docx, .xls, .xlsx, .png, .jpg, .jpeg, .csv, .svg"
                                                                                                        onChange={handleUploadUserDocumentFileUpload}
                                                                                                    />
                                                                                                    {LoaderForUploadFile.Type === property.Type ? (
                                                                                                        <p className="error">Uploading.....</p>
                                                                                                    ) : (
                                                                                                        <>
                                                                                                            <br />
                                                                                                            <br />
                                                                                                            <div style={{ marginTop: '8px' }}>
                                                                                                                <span
                                                                                                                    className="uploadremainingdocsbutton"
                                                                                                                    onClick={() => handleUploadRemainingDocs(property)}
                                                                                                                >
                                                                                                                    Upload Document
                                                                                                                </span>
                                                                                                                {!!uploadRemainingDocsErrors[property.docId || property.Type] && (
                                                                                                                    <p className="error" style={{ marginTop: "6px" }}>
                                                                                                                        {uploadRemainingDocsErrors[property.docId || property.Type]}
                                                                                                                    </p>
                                                                                                                )}
                                                                                                            </div>
                                                                                                        </>
                                                                                                    )}
                                                                                                </>
                                                                                            )}
                                                                                        {getQuestionType(property) === 'radio' &&
                                                                                            !checkUserUploadedToQuestions(property) && (
                                                                                                <div className="col-md-3">
                                                                                                    <label>
                                                                                                        <input
                                                                                                            type="radio"
                                                                                                            name={`question_${property.docId}`}
                                                                                                            value="Yes"
                                                                                                            onChange={() => updateMissingQuestion('Yes', property)}
                                                                                                        />
                                                                                                        &nbsp;&nbsp;Yes&nbsp;&nbsp;&nbsp;&nbsp;
                                                                                                    </label>
                                                                                                </div>
                                                                                            )}
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="property-chat-panel-section">
                                                        <div className="property-chat-section-header d-flex justify-content-between align-items-center">
                                                            <h4 className="mb-0">Files</h4>
                                                            {UserUploadedDocs.length > 3 && (
                                                                <span className="property-chat-view-all" onClick={toggleShowAllFiles}>
                                                                    {showAllFiles ? "View Less" : "View All"}
                                                                </span>
                                                            )}
                                                        </div>

                                                        <div className="property-chat-files-list">
                                                            {UserUploadedDocs.length > 0 ? (
                                                                (showAllFiles ? UserUploadedDocs : UserUploadedDocs.slice(0, 3)).map((property, index) => (
                                                                    <div
                                                                        className="file-card"
                                                                        key={index}
                                                                    >
                                                                        <div className="d-flex align-items-start mb-2">
                                                                            <span
                                                                                className={`status-icon me-3 fs-5 fw-bold ${checkUserUploadedToQuestions(property) ? "text-success" : "text-danger"
                                                                                    }`}
                                                                            >
                                                                                {checkUserUploadedToQuestions(property) ? "✓" : "✗"}
                                                                            </span>
                                                                            <div>
                                                                                <p className="mb-1 fw-semibold text-dark">Question Type</p>
                                                                                <p className="mb-0 text-muted small">{property.Type}</p>
                                                                            </div>
                                                                        </div>
                                                                        <div className="document-preview mt-2">
                                                                            {property.url && property.url.startsWith("http") ? (
                                                                                <FilePreview
                                                                                    url={property.url}
                                                                                    width="100%"
                                                                                    height="120px"
                                                                                    style={{
                                                                                        width: '100%',
                                                                                        minHeight: '120px',
                                                                                        border: 'none',
                                                                                        borderRadius: '6px',
                                                                                        boxShadow: '0 2px 6px rgba(0, 0, 0, 0.08)',
                                                                                    }}
                                                                                    className="document-frame"
                                                                                    title={`Document Viewer ${index}`}
                                                                                    onLoad={onLoad}
                                                                                    onError={onError}
                                                                                />
                                                                            ) : (
                                                                                <p className="text-success">{property.url}</p>
                                                                            )}
                                                                        </div>
                                                                        {property.history && property.history.length > 0 && (
                                                                            <div className="document-history-container mt-2 pt-2 border-top">
                                                                                <div className="text-muted small fw-semibold mb-1" style={{ fontSize: '11px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                                                    <span>🕒 Previous Versions:</span>
                                                                                </div>
                                                                                <div className="d-flex flex-wrap gap-2">
                                                                                    {property.history.map((hist, hIdx) => (
                                                                                        <a
                                                                                            key={hIdx}
                                                                                            href={hist.url}
                                                                                            target="_blank"
                                                                                            rel="noreferrer"
                                                                                            className="btn btn-xs px-2 py-1 text-decoration-none d-inline-flex align-items-center gap-1"
                                                                                            style={{
                                                                                                fontSize: '10px',
                                                                                                backgroundColor: '#f1f3f5',
                                                                                                border: '1px solid #dee2e6',
                                                                                                borderRadius: '4px',
                                                                                                color: 'var(--color-turquoise-teal)',
                                                                                                fontWeight: '500'
                                                                                            }}
                                                                                            title={`Status: ${hist.verificationStatus || 'Unknown'}${hist.rejectionReason ? ` - Reason: ${hist.rejectionReason}` : ''}`}
                                                                                        >
                                                                                            v{hIdx + 1}
                                                                                        </a>
                                                                                    ))}
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                ))
                                                            ) : (
                                                                <p className="text-muted">No Uploaded Documents found</p>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </>}
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </>
                : <EditPropertyModal
                    showEditModal={showEditModal}
                    setShowEditModal={setShowEditModal}
                    PropertyDetails={PropertyDetails}
                    handleChange={handleChange}
                    page222={page}
                    SaleAggementloading={SaleAggementloading}
                    fileInputRefForSaleDeedUploaded={fileInputRefForSaleDeedUploaded}
                    fileInputRefForSaleAggrement={fileInputRefForSaleAggrement}
                    SaleDeedUploadedloading={SaleDeedUploadedloading}
                    onOpenSaleAggrimentUpload={onOpenSaleAggrimentUpload}
                    onOpenSaleDeedUploaded={onOpenSaleDeedUploaded}
                    onEditSaleDeedUploaded={onEditSaleDeedUploaded}
                    onEditSaleAggriment={onEditSaleAggriment}
                    onDeleteSaleDeedUploaded={onDeleteSaleDeedUploaded}
                    onDeleteSaleAgreement={onDeleteSaleAgreement}
                    handleSaleAggrementUpload={handleSaleAggrementUpload}
                    handleSaleDeedUploaded={handleSaleDeedUploaded}
                    handleSubmitOfEditProperty={handleSubmitOfEditProperty}
                    handleSubmitPropertyData={handleSubmitPropertyData}

                />}
            <Modal
                show={openRaiseIssueModel}
                size="md"
                onHide={handleClose}
                centered
            >
                <Modal.Header>
                    <Modal.Title className="model-text-colo">
                        Raise a request to extend the {formatExtendForDisplay(ExtendForText)}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="d-flex justify-content-center">
                    <div className="card-body">
                        <>
                            <p className="form-label-raise-request">
                                Select extended date
                            </p>
                            <input
                                name="ExtendedDate"
                                min={new Date().toISOString().split("T")[0]}
                                value={raiseRequestFormValues.ExtendedDate}
                                onChange={handleRaiseRequestValues}
                                className="form-control"
                                type="date"
                            />
                            <p>
                                {raiseRequestErrors?.ExtendedDate ? (
                                    <span className="error">
                                        {raiseRequestErrors?.ExtendedDate}
                                    </span>
                                ) : (
                                    ""
                                )}
                            </p>
                            <p className="form-label-raise-request">
                                Enter the reason for extending the submission date ({formatExtendForDisplay(ExtendForText)})
                            </p>
                            <input
                                name="ExtendedDateReason"
                                value={raiseRequestFormValues.ExtendedDateReason}
                                onChange={handleRaiseRequestValues}
                                className="form-control"
                                placeholder={
                                    ExtendForText === "Registration Document"
                                        ? "Enter the reason for extending the registration document submission date"
                                        : "Enter the reason for extending the sale deed submission date"
                                }
                                type="text"
                            />
                            <p>
                                {raiseRequestErrors?.ExtendedDateReason ? (
                                    <span className="error">
                                        {raiseRequestErrors?.ExtendedDateReason}
                                    </span>
                                ) : (
                                    ""
                                )}
                            </p>
                        </>
                    </div>
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-center">
                    <>
                        <Button
                            className="raise-request-button"
                            onClick={handleRaiseRequest}
                        >
                            Raise Request
                        </Button>
                        <Button className="cancel-request-button" onClick={handleClose}>
                            Cancel
                        </Button>
                    </>
                </Modal.Footer>
            </Modal>
            <Modal
                show={openUploadSaledeedModel}
                size="lg"
                onHide={handleCloseSaledeedModal}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title className="model-text-colo">
                        Upload Your Saledeed
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="d-flex flex-column align-items-center">
                    {getSaledeedRejectionReason() && (
                        <div className="alert alert-danger w-100 mb-3" style={{ fontSize: "14px", borderRadius: "8px" }}>
                            <strong>Rejection Reason:</strong> {getSaledeedRejectionReason()}
                        </div>
                    )}
                    <div className="card-body w-100">
                        <>
                            <div className="row">
                                <div className="col-md-6 d-flex justify-content-center">
                                    {isLoading1 ? <div className="loader-container">
                                        <img src={loader} alt="Loading..." />
                                        <p>Uploading...</p>
                                    </div> :
                                        <>
                                            {SaleDeedUploadedFile ?
                                                <div style={{ position: "relative", width: "100%", height: "300px" }}>
                                                    <FilePreview
                                                        url={SaleDeedUploadedFile}
                                                        width="100%"
                                                        height="100%"
                                                        title="Document Preview"
                                                        className="document-preview"
                                                        style={{
                                                            border: "1px solid #ccc",
                                                            borderRadius: "8px",
                                                        }}
                                                    />
                                                    <button
                                                        onClick={() => setSaleDeedUploadedFile(null)}
                                                        className='removeiconstyleforsaledeeddoc'
                                                    >
                                                        ✕
                                                    </button>
                                                </div>
                                                : <div
                                                    onClick={handleBoxClick}
                                                    style={{
                                                        width: '100%',
                                                        minHeight: '150px',
                                                        border: '2px dashed #999',
                                                        borderRadius: '12px',
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                        cursor: 'pointer',
                                                        backgroundColor: 'var(--color-frosted-silver-sage)',
                                                        transition: 'background-color 0.3s',
                                                    }}
                                                    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#EEF4F1')}
                                                    onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#f9f9f9')}
                                                >
                                                    <input
                                                        type="file"
                                                        id="file-upload"
                                                        ref={fileInputRef}
                                                        style={{ display: 'none' }}
                                                        accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg,.csv,.svg"
                                                        onChange={handleSaledeedFileUpload}
                                                    />
                                                    <div style={{ textAlign: 'center', color: 'var(--color-oxford-blue)' }}>
                                                        <div style={{ fontSize: '18px', fontWeight: 500 }}>📎 Upload Document</div>
                                                        <div style={{ fontSize: '12px', marginTop: '5px', color: 'var(--color-turquoise-teal)' }}>
                                                            Accepted: PDF, DOC, XLS, PNG, JPG, etc.
                                                        </div>
                                                    </div>
                                                </div>}
                                            {ErrorMessagesForSaledeedModel && !SaleDeedUploadedFile && (
                                                <p style={{ color: 'var(--color-error)', fontSize: '12px', marginTop: '8px', textAlign: 'left' }}>{ErrorMessagesForSaledeedModel}</p>
                                            )}
                                        </>
                                    }
                                </div>
                                <div className="col-md-6">
                                    <label className='form-label'>Document Number</label>
                                    <input type='text' className='form-control' name='documentNumber' value={HandleSaledeedFields.documentNumber || ''} onChange={handleSaledeedDocNames} placeholder='Enter document number' />

                                    <label className='form-label'>Document Officer</label>
                                    <input type='text' className='form-control' name='documentOfficer' value={HandleSaledeedFields.documentOfficer || ''} onChange={handleSaledeedDocNames} placeholder='Enter document officer name' />

                                    <label className='form-label'>Document Issued By Designation</label>
                                    <input type='text' className='form-control' name='issuedByDesignation' value={HandleSaledeedFields.issuedByDesignation || ''} onChange={handleSaledeedDocNames} placeholder='Enter issuing officer designation' />

                                    <label className='form-label'>Officer Number (Optional)</label>
                                    <input type='text' inputMode='numeric' maxLength={10} className='form-control' name='officerNumber' value={HandleSaledeedFields.officerNumber || ''} onChange={handleSaledeedDocNames} placeholder='Enter officer phone number (optional)' />

                                    <label className='form-label'>Prepared By Type (Optional)</label>
                                    <select className='form-control' name='preparedByRole' value={HandleSaledeedFields.preparedByRole || ''} onChange={handleSaledeedDocNames}>
                                        <option value=''>Select Type (Optional)</option>
                                        <option value='Document Writer'>Document Writer</option>
                                        <option value='Advocate'>Advocate</option>
                                    </select>

                                    <label className='form-label'>Prepared By Name (Optional)</label>
                                    <input type='text' className='form-control' name='preparedByName' value={HandleSaledeedFields.preparedByName || ''} onChange={handleSaledeedDocNames} placeholder='Enter preparer name (optional)' />
                                </div>
                            </div>
                        </>
                    </div>
                </Modal.Body>
                <p style={{ color: 'var(--color-error)', textAlign: 'center' }}>{ErrorMessagesForSaledeedModel}</p>
                <Modal.Footer className="d-flex justify-content-center">
                    <>
                        <Button
                            className="saledeed-modelsubmit"
                            onClick={() => handleUploadSaledeedDocument()}
                            disabled={isSubmittingSaledeed}
                        >
                            {isSubmittingSaledeed ? (
                                <span style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    <span>Submitting...</span>
                                </span>
                            ) : (
                                "Submit"
                            )}
                        </Button>
                        <Button className="cancel-saledeed-model" onClick={handleCloseSaledeedModal} disabled={isSubmittingSaledeed}>
                            Cancel
                        </Button>
                    </>
                </Modal.Footer>
            </Modal>
            <Modal
                show={openDocUploadErrorInChat}
                size="md"
                centered
                // onHide={() => setopenDocUploadErrorInChat(false)}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Body className="text-center">
                    <Modal.Title className="w-100 text-center mb-3" style={{ fontWeight: "600" }}>
                        {/* <XCircle color="red" className="me-2" /> */}
                        {DocUploadAlertError && 'Upload Error'}
                    </Modal.Title>
                    <p style={{ color: "var(--color-oxford-blue)", fontSize: "16px", fontWeight: 500 }}>
                        {DocUploadAlertError ? DocUploadAlertError : 'Please wait, your previous sale deed is still under verification.'}
                    </p>
                </Modal.Body>
                {/* 
                <Modal.Footer className="border-0 d-flex justify-content-center pb-4">
                    <Button
                        variant="outline-danger"
                        onClick={() => setopenDocUploadErrorInChat(false)}
                        style={{
                            padding: "6px 24px",
                            borderRadius: "6px",
                            fontWeight: "500",
                            fontSize: "14px",
                        }}
                    >
                        Close
                    </Button>
                </Modal.Footer> */}
            </Modal>
            <Modal
                show={showInlineFileUploadModal}
                size="sm"
                centered
                onHide={() => {
                    setInlineFileUploadError("");
                    setShowInlineFileUploadModal(false);
                }}
                backdrop="static"
                keyboard={!inlineFileUploadLoading}
            >
                <Modal.Header closeButton={!inlineFileUploadLoading}></Modal.Header>
                <Modal.Body className="text-center">
                    <input
                        type="file"
                        ref={inlineFileUploadRef}
                        style={{ display: "none" }}
                        accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg,.csv,.svg"
                        onChange={handleInlineFileSelected}
                        disabled={inlineFileUploadLoading}
                    />
                    <div style={{ textAlign: 'center' }}>
                        <Button
                            className="saledeed-modelsubmit"
                            onClick={() => inlineFileUploadRef.current?.click()}
                            disabled={inlineFileUploadLoading}
                            style={{ background: 'none', border: 'none', padding: '0' }}
                        >
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' }}>
                                <span style={{ fontSize: '32px' }}>📤</span>
                                <span style={{ fontSize: '14px', color: 'var(--color-oxford-blue)' }}>Upload Document</span>
                            </div>
                        </Button>
                        {inlineFileUploadLoading && <p style={{ marginTop: '8px' }}>Uploading...</p>}
                        {inlineFileUploadError && (
                            <p style={{ marginTop: '8px', color: 'var(--color-oxford-blue)', fontSize: '12px' }}>
                                {inlineFileUploadError}
                            </p>
                        )}
                    </div>
                </Modal.Body>
            </Modal>
        </div >
    );
};

export default PropertyChat2;




